// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1UqdR":[function(require,module,exports,__globalThis) {
const _temp0 = require("231e0a69dc3f0d46");
const _temp1 = require("907d91e262c242ff");
const _temp2 = require("45da033475347da4");
const _temp3 = require("3fe980cb81d7ca05");
const _temp4 = require("c1a887d44dec7315");
const _temp5 = require("cbcc5100bf6f2758");
const _temp6 = require("985a41651244380b");
const _temp7 = require("d4446eb7f5b0d4ad");
const _temp8 = require("20eec45199029b57");
const _temp9 = require("271faedb4d2d3a28");
const _temp10 = require("8e74f90c17f580c5");
const _temp11 = require("3de3d7d090e0c33a");
const _temp12 = require("183376a24ff24e77");
const _temp13 = require("c8731384e0271f84");
const _temp14 = require("1b766a3d7faedc2a");
const _temp15 = require("157ae62fd05b0ed1");
const _temp16 = require("69cbb5cb455fbc09");
const _temp17 = require("2bb4dc813a6689f6");
const _temp18 = require("b8dd6c27a7f8e139");
const _temp19 = require("c6e9a406ae6c9edd");
const _temp20 = require("aef89102f27d8286");
const _temp21 = require("1743154ecab461ab");
const _temp22 = require("6e090f5f1fc4ca8");
const _temp23 = require("15940b399779bec9");
const _temp24 = require("2380053b2e8a2d52");
const _temp25 = require("8dcf24cc08172e97");
const _temp26 = require("e8293b17c5c544be");
const _temp27 = require("9f2b876555908fad");
const _temp28 = require("359de201a7fea00f");
const _temp29 = require("dbff7f31db205e61");
const _temp30 = require("8d0a5796b2a12f9");
const _temp31 = require("5f106359edaba166");
const _temp32 = require("9e1a17bfedaad353");
const _temp33 = require("f3c70a9a2fa8ff28");
const _temp34 = require("d95052b8ab9c7440");
const _temp35 = require("4f0abe87de7c78ce");
const _temp36 = require("cc0263817d650ad4");
const _temp37 = require("11f7edb69a984cec");
const _temp38 = require("933db094d9988a14");
const _temp39 = require("a74b01f76d430e4d");
const _temp40 = require("2d5d2faaa84966bd");
const _temp41 = require("b243256ec968c9b8");
const _temp42 = require("6df35de6861ca522");
const _temp43 = require("d9e5371ee88f9943");
const _temp44 = require("5b8a1d1b4379a6be");
const _temp45 = require("98d4a9740a773ea9");
const _temp46 = require("de6bd474f8e510ff");
const _temp47 = require("6d2afa003e8376f9");
const _temp48 = require("d701e8a00182d2bc");
const _temp49 = require("7cdd91dd827763c0");
const _temp50 = require("f2ff1e35f503a359");
const _temp51 = require("da26633b7affebc0");
const _temp52 = require("ac334db8e5a2ddb4");
const _temp53 = require("92d3ba5c82bccec8");
const _temp54 = require("5848c028c04bd5a4");
const _temp55 = require("e0bf0909deca7962");
const _temp56 = require("b408a6b5292c3e79");
const _temp57 = require("5dc426682f6a5323");
const _temp58 = require("533b7ca7afe751a5");
const _temp59 = require("b97a34e36e8142d0");
const _temp60 = require("5d4d26f41dfaeaa8");
const _temp61 = require("1e1b86bce808c9b");
const _temp62 = require("a28e4de0a3e2716a");
const _temp63 = require("907c7cba9e922da7");
const _temp64 = require("aa8033aee22521c2");
const _temp65 = require("9a8763b4ae8eab96");
const _temp66 = require("5f6c62f3a39f0dd2");
const _temp67 = require("6b6014ee8ff46c96");
const _temp68 = require("2cbbb79d24d78855");
const _temp69 = require("f0ae57edbde5773c");
const _temp70 = require("9758936a65df3079");
const _temp71 = require("5ad7263fc88c9fe");
const _temp72 = require("48b3b5e90c62a56a");
const _temp73 = require("6f6749451b711c9a");
const _temp74 = require("769cda48bc17168a");
const _temp75 = require("ce7b62c3c81f21c9");
const _temp76 = require("78d9a7527e75de9c");
const _temp77 = require("d2a87a1267503f2a");
const _temp78 = require("3ce70b4fe80a4084");
const _temp79 = require("29be3cf36ac45ef");
const _temp80 = require("e3463035dd1a6260");
const _temp81 = require("cef4cb6b618de6c9");
const _temp82 = require("c4429e72c74e6001");
const _temp83 = require("3521bf3ecaae81cd");
const _temp84 = require("f623e79b8b2ee1fe");
const _temp85 = require("c858f73b0698e31b");
const _temp86 = require("f9af7bae7c5054f5");
const _temp87 = require("79804aba1c1245e5");
const _temp88 = require("5ea946f3bd193bce");
const _temp89 = require("7ca9024f8377db86");
const _temp90 = require("ac5805ff163a2dec");
const _temp91 = require("5331a8cb8b7635dd");
const _temp92 = require("3597e814e39cb3c8");
const _temp93 = require("462c52334090094b");
const _temp94 = require("38176e6b976666ad");
const _temp95 = require("67a8d7e5a13f4350");
const _temp96 = require("bbb5143ce7187c7f");
const _temp97 = require("d57872447e2b6a79");
const _temp98 = require("ac76f8effd443637");
const _temp99 = require("a4f795a85fd4e92a");
const _temp100 = require("24c9797f75cb9e28");
const _temp101 = require("136f5fa37e70d1b6");
const _temp102 = require("41c75fbbfdcee84e");
const _temp103 = require("30630a13fbf2aba7");
const _temp104 = require("aec2ab22f3271464");
const _temp105 = require("9c079d1c6c4efc7e");
const _temp106 = require("749f9f25a6a8c5db");
const _temp107 = require("f4b20cb9e52c6da6");
const _temp108 = require("3e4242b1b0bad2d");
const _temp109 = require("6d94ec34f355c7ae");
const _temp110 = require("c7ba5a6ff7e1476a");
const _temp111 = require("38222936b6cb58e8");
const _temp112 = require("ba39a9993f7b35d2");
const _temp113 = require("6d8f233195f5f648");
const _temp114 = require("539fd8f29a7cec44");
const _temp115 = require("38073bd37c0172d7");
const _temp116 = require("df04ef23d3d3f64");
const _temp117 = require("52c11bd251181298");
const _temp118 = require("264b166999e685bc");
const _temp119 = require("d44c1b9ec4cff34c");
const _temp120 = require("6626f3959e9ae79");
const _temp121 = require("49515851fd6d2c5d");
const _temp122 = require("547d5cc79f959485");
const _temp123 = require("aa136d813c0c841d");
const _temp124 = require("faf207aa97f8dd20");
const _temp125 = require("d23ff68b0c6d6be7");
const _temp126 = require("9775cee1fcb72894");
const _temp127 = require("cbdd219e38a56b0");
const _temp128 = require("7c865d879b2d98af");
const _temp129 = require("6ff199d02008e74c");
const _temp130 = require("344a62cc587d389c");
const _temp131 = require("79d24ff606952fb7");
const _temp132 = require("2410a78040e6ea26");
const _temp133 = require("ae8c7ce955301d3");
const _temp134 = require("caec6c1b85f59e52");
const _temp135 = require("7cf7e4d30b2a3b20");
const _temp136 = require("15fff6499b8bd3ba");
const _temp137 = require("7030298510269f4b");
const _temp138 = require("a571b6a5e6c955db");
const _temp139 = require("b27142edaafbdbd7");
const _temp140 = require("79c46bea530050c1");
const _temp141 = require("10fa1e76a674fd6d");
const _temp142 = require("ce5d6ff07f979cb8");
const _temp143 = require("3e7ed4a6a55484a8");
const _temp144 = require("77e1d117e5f29fe3");
const _temp145 = require("ae5e60ae8cc98d7e");
const _temp146 = require("32fed45b146fa468");
const _temp147 = require("350ec56bf5303f7a");
const _temp148 = require("97cdb7fe01434966");
const _temp149 = require("28294a3a401bd4ff");
const _temp150 = require("fdc05c0f6968fcec");
const _temp151 = require("5df4cf43a216ece9");
const _temp152 = require("71b16826e5db7c22");
const _temp153 = require("2781bbfae1f64a1b");
const _temp154 = require("3a8f4e5b20fe8952");
const _temp155 = require("468e164bb444d97b");
const _temp156 = require("d838d2eb417da597");
const _temp157 = require("76b9c46b384122cf");
const _temp158 = require("90c141280f3aa156");
const _temp159 = require("3fd5e2c2eb4e2989");
const _temp160 = require("236ddd091b59aed8");
const _temp161 = require("5f1908db7b81ae8e");
const _temp162 = require("28b259e0649e926a");
const _temp163 = require("6f4f527fa0881668");
const _temp164 = require("e8e1e81d83c5fe26");
const _temp165 = require("1d2ae8c12d2034f6");
const _temp166 = require("d8bda0b2d8dc93fc");
const _temp167 = require("ac4c8a73700989f1");
const _temp168 = require("48eba80e067a7eff");
const _temp169 = require("9062e5f326ea4b68");
const _temp170 = require("4cf6331f8555205");
const _temp171 = require("ab9cb15aaee9c31b");
const _temp172 = require("60e59c37cf639cdf");
const _temp173 = require("995de3e9dfc322e4");
const _temp174 = require("f58b6e332c3a0bef");
const _temp175 = require("a6b366fb1803cfe5");
const _temp176 = require("da176464bbd8523");
const _temp177 = require("947d00af2668d87b");
const _temp178 = require("a618619ed5140a6b");
const _temp179 = require("e18d0f978bc5d872");
const _temp180 = require("903ae48abe8f030d");
const _temp181 = require("6b3470206003ee50");
const _temp182 = require("568d974b44dc3dfc");
const _temp183 = require("c058ccd074b7ea78");
const _temp184 = require("cdcf6e87457c9983");
const _temp185 = require("f95b976ede313f1a");
const _temp186 = require("964806ba61c2dc5d");
const _temp187 = require("d5ecc8571cb25c35");
const _temp188 = require("bae269583f046fa0");
const _temp189 = require("9ba324215df32043");
const _temp190 = require("8fe1ac7d5ef0f81");
const _temp191 = require("4ac3552768ce0c32");
const _temp192 = require("f8e051a9b44c9918");
const _temp193 = require("e94c2885380f7d3c");
const _temp194 = require("78df0d0777b2da50");
const _temp195 = require("7c5b0fbb812a43b4");
const _temp196 = require("780c01abbbb56f03");
const _temp197 = require("ccf36c825dbcbaf7");
const _temp198 = require("a2048441e6eb8848");
const _temp199 = require("12d2ee5b9d184e54");
const _temp200 = require("5bd2c7c47f7bd189");
const _temp201 = require("2a574a9a81d0447a");
const _temp202 = require("10528dc19499e25a");
const _temp203 = require("b488323d801247c8");
const _temp204 = require("8c20ae29e1f29489");
const _temp205 = require("a66dedc0b213991b");
const _temp206 = require("b4d1a056cc3add2b");
const _temp207 = require("8cb9783bac30c6a1");
const _temp208 = require("d0260832343f556a");
const _temp209 = require("bd839a1655197bb1");
const _temp210 = require("896f6b5c20fb5e68");
const _temp211 = require("4ebe595ca40ad970");
const _temp212 = require("58f8df047b758d02");
const _temp213 = require("d0e5bb469616a4fd");
const _temp214 = require("5de725c689a5a44");
const _temp215 = require("bf2241a9d8f87849");
const _temp216 = require("77efb63c0c6547fa");
const _temp217 = require("afd89c9b8e1e7748");
const _temp218 = require("5cd7968f2a2c2fab");
const _temp219 = require("af6dfc6a94b5b31");
const _temp220 = require("739f0decedd5022e");
const _temp221 = require("927d509be785b427");
const _temp222 = require("6b66344a9044be0f");
const _temp223 = require("e608a58890a2c414");
const _temp224 = require("2fadd810153e3411");
const _temp225 = require("a682e20e12a99f51");
const _temp226 = require("5aa24c702f3f9e32");
const _temp227 = require("f934123202bf95dc");
const _temp228 = require("789e1fcdd3bfb7f7");
const _temp229 = require("ac6e8fd53e676aef");
const _temp230 = require("daad00144f0b5da3");
const _temp231 = require("d77e301e3c236a57");
const _temp232 = require("c32c320207f70053");
const _temp233 = require("a423a702807fbe2c");
const _temp234 = require("3b27734354f2e9fa");
const _temp235 = require("6557faf3c60a726f");
const _temp236 = require("5c6cf9dde67250dc");
const _temp237 = require("7480c143c99ded74");
const _temp238 = require("3954f632122f493");
const _temp239 = require("1f8f3888793d85cb");
const _temp240 = require("16409a00dc7f403c");
const _temp241 = require("c260477e1174c8be");
const _temp242 = require("910d432de2111f19");
const _temp243 = require("f5e447860c43da7b");
const _temp244 = require("a470861487d75465");
const _temp245 = require("11f1b7b30040bd3b");
const _temp246 = require("d52785e1e5f2788b");
const _temp247 = require("dbd7784b57b4631b");
const _temp248 = require("b4e56267604a7d42");
const _temp249 = require("dfd12170080dd7a4");
const _temp250 = require("7b511554946f4f49");
const _temp251 = require("d233051b9400b0ca");
const _temp252 = require("b437a5b64b916209");
const _temp253 = require("b2cddd767aab89b2");
const _temp254 = require("7d75e871dffcb154");
const _temp255 = require("5f7835b7da8dbd2");
const _temp256 = require("dd7c320a27a7907b");
const _temp257 = require("847699a169a7b4fb");
const _temp258 = require("24a54e118faa27f2");
const _temp259 = require("5dea199dec2b8c88");
const _temp260 = require("ecb361fca7170cdf");
const _temp261 = require("abe4d6cbe5145a6");
const _temp262 = require("bf4961f5c4ccadf0");
const _temp263 = require("d03bfd93be761ab1");
const _temp264 = require("7790ad56e39bc2e7");
const _temp265 = require("16c3da0692a395fc");
const _temp266 = require("fd0998dfd337530f");
const _temp267 = require("bd9a0e653b9a16f9");
const _temp268 = require("dff5bdf69ad9b39f");
const _temp269 = require("69d904e8b08676dc");
const _temp270 = require("5e539bc7c030e40b");
const _temp271 = require("7442893356376757");
const _temp272 = require("d09c761c0575dca8");
const _temp273 = require("c7bd4e06538ea45d");
const _temp274 = require("3e495dd25f838505");
const _temp275 = require("37def537096458cb");
const _temp276 = require("2e15aabd4ee40122");
const _temp277 = require("d3e932d36e835175");
const _temp278 = require("eaecfd058c8f21a2");
const _temp279 = require("32cba2d4008fec8a");
const _temp280 = require("e27f1ab005546c81");
const _temp281 = require("3b6b56992c717d3e");
const _temp282 = require("8199206a71f267cb");
const _temp283 = require("fd700c4a37a75c43");
const _temp284 = require("2dadbe149aacfd7");
const _temp285 = require("4c9c13c296471bc7");
const _temp286 = require("19d0eb60d30d5c5a");
const _temp287 = require("b4b5d30bf571a102");
const _temp288 = require("7f23fb3dd9d5d1bc");
const _temp289 = require("b39ca6a45436a855");
const _temp290 = require("33516746aea36fb1");
const _temp291 = require("d53a9c0d5a846261");
const _temp292 = require("181239c46f23acdc");
const _temp293 = require("7e10b526dfc48b69");
const _temp294 = require("26f9c9655ac53160");
const _temp295 = require("de416bc9fdb225d8");
const _temp296 = require("69c56e2703d72474");
const _temp297 = require("b21289bdd11a44f3");
const _temp298 = require("9e8feba304cee8fb");
const _temp299 = require("383eb288767199be");
const _temp300 = require("b07e5681d8dc3cea");
const _temp301 = require("4ee25ed68296a6e8");
const _temp302 = require("6299bba1b62a8cbf");
const _temp303 = require("d8a00a0dacf1e69c");
const _temp304 = require("13fc078037ef3683");
const _temp305 = require("3dcd072923e44724");
const _temp306 = require("8bef9b1b1484cbbc");
const _temp307 = require("e53d8475175248c4");
const _temp308 = require("1fbbb0a8c0ad0110");
const _temp309 = require("3c16475a63756ef4");
const _temp310 = require("36d89a8903ff3c3c");
const _temp311 = require("3d83c73165c42643");
const _temp312 = require("f8d1ff36c31acea3");
const _temp313 = require("f42a06ca03a9bae5");
const _temp314 = require("16d03ebb03196487");
const _temp315 = require("4e7672f45a2f0f6b");
const _temp316 = require("c63c19369ff8a368");
const _temp317 = require("f4bba485dcd02324");
const _temp318 = require("2442ebe8953f80d3");
const _temp319 = require("e1e9bdf5d9d053d3");
const _temp320 = require("f3a516008c8ec6e5");
const _temp321 = require("a86f4d21878a4165");
const _temp322 = require("49840c0ca6fbe4db");
const _temp323 = require("d72bdf06ea59cf25");
const _temp324 = require("405f79cae0a3bb81");
const _temp325 = require("197a644131e46048");
const _temp326 = require("4e8188811005e75b");
const _temp327 = require("462ff65e4ec3be4a");
const _temp328 = require("d4fe5dc3d998e8b4");
const _temp329 = require("92ff555d0d626ad7");
const _temp330 = require("6fd528982e77f0cf");
const _temp331 = require("58722f2b1e044ab0");
const _temp332 = require("1feb23deefd3e7f6");
const _temp333 = require("48c35dc870c3950a");
const _temp334 = require("eb0bac4c4185d3c9");
const _temp335 = require("a4a7714c604a05ea");
const _temp336 = require("2e530cd81da4535e");
const _temp337 = require("816e54ce73fe44cd");
const _temp338 = require("932059cb319b37fc");
const _temp339 = require("767b042d678a78f1");
const _temp340 = require("16453d7c8b78f62b");
const _temp341 = require("2c067a2992d27856");
const _temp342 = require("a8d2a6c75f21840a");
const _temp343 = require("1c7afe7e27ae41ee");
const _temp344 = require("d40d704f6a269027");
const _temp345 = require("69c8982c4f722a5c");
const _temp346 = require("66e0ca0d9cfcb659");
const _temp347 = require("a3cf04690df6bbd9");
const _temp348 = require("d86860bcd3a8e603");
const _temp349 = require("fa5cea672c3db864");
const _temp350 = require("73b3ad702647d4ec");
const _temp351 = require("efe61c36d1b3aa04");
const _temp352 = require("1d240709e8bc86a5");
const _temp353 = require("95d9e8098379eeb2");
const _temp354 = require("c524c98e9ff96ce9");
const _temp355 = require("1841c2b927fafc7e");
const _temp356 = require("ac23e5db0087f386");
const _temp357 = require("8706cbe0af6a0541");
const _temp358 = require("207eab6bcc7d3b4d");
const _temp359 = require("bbd7adc7919f030e");
const _temp360 = require("be8c04ca7cebcabe");
const _temp361 = require("cbe157bf83d2e95a");
const _temp362 = require("76e22dfcac6e2655");
const _temp363 = require("6c56ddb72d4caf71");
const _temp364 = require("136f2f61e195af6");
const _temp365 = require("e25afae5778c58c4");
const _temp366 = require("43c97c816e884c34");
const _temp367 = require("df72206e7791eef4");
const _temp368 = require("b0d64b44ab7f0e4b");
const _temp369 = require("9d7298f6df570ea3");
const _temp370 = require("46ca7c5387438b31");
const _temp371 = require("e13bee8ff988ab50");
const _temp372 = require("bd81a032b9259db1");
const _temp373 = require("c70bf51cacf2cd61");
const _temp374 = require("48324fbd57fb519e");
const _temp375 = require("2ae23f3f07c76238");
const _temp376 = require("6d52ec2cd1102d2");
const _temp377 = require("1c201bbf46462f5b");
const _temp378 = require("1f26b9750576e278");
const _temp379 = require("b304f60b1c6fcb12");
const _temp380 = require("3276dab36b1dc99e");
const _temp381 = require("c7bd5c77efb878ce");
const _temp382 = require("14ef6ca3b0495359");
const _temp383 = require("69b86ae68f62fea");
const _temp384 = require("bdd6018e8f091998");
const _temp385 = require("e3b2852cdfd22318");
const _temp386 = require("b69778e25f136b6");
const _temp387 = require("1052e5a1d619a8d");
const _temp388 = require("9b461c3ab49900de");
const _temp389 = require("94bfb483b869f40e");
const _temp390 = require("1e711527be31fd67");
const _temp391 = require("5d4bc529f23d14a9");
const _temp392 = require("7657e81b7841ad0e");
const _temp393 = require("e327e50f090ebe46");
const _temp394 = require("5d87f906010ba38a");
const _temp395 = require("772c2ba63a886bd8");
const _temp396 = require("45b3415f8e2b18f6");
const _temp397 = require("6f7bb8f49ef80190");
const _temp398 = require("29a331f4b0104873");
const _temp399 = require("4d9a8be4685a2003");
const _temp400 = require("8f221bfc4196c66a");
const _temp401 = require("da7d7abb7765118f");
module.exports = {
    "S2_Icon_3DAsset_20_N": _temp0,
    "S2_Icon_3DMaterial_20_N": _temp1,
    "S2_Icon_3D_20_N": _temp2,
    "S2_Icon_ABC_20_N": _temp3,
    "S2_Icon_Accessibility_20_N": _temp4,
    "S2_Icon_AddCircle_20_N": _temp5,
    "S2_Icon_AddContent_20_N": _temp6,
    "S2_Icon_Add_20_N": _temp7,
    "S2_Icon_AlertDiamond_20_N": _temp8,
    "S2_Icon_AlertTriangle_20_N": _temp9,
    "S2_Icon_AlignBottom_20_N": _temp10,
    "S2_Icon_AlignCenter_20_N": _temp11,
    "S2_Icon_AlignLeft_20_N": _temp12,
    "S2_Icon_AlignMiddle_20_N": _temp13,
    "S2_Icon_AlignRight_20_N": _temp14,
    "S2_Icon_AlignTop_20_N": _temp15,
    "S2_Icon_AnimationNo_20_N": _temp16,
    "S2_Icon_Animation_20_N": _temp17,
    "S2_Icon_App_20_N": _temp18,
    "S2_Icon_AppsAll_20_N": _temp19,
    "S2_Icon_Apps_20_N": _temp20,
    "S2_Icon_Archive_20_N": _temp21,
    "S2_Icon_ArrowHeadTool_20_N": _temp22,
    "S2_Icon_Artboard_20_N": _temp23,
    "S2_Icon_AspectRatio_20_N": _temp24,
    "S2_Icon_Asset_20_N": _temp25,
    "S2_Icon_Attach_20_N": _temp26,
    "S2_Icon_AudioWave_20_N": _temp27,
    "S2_Icon_AutoSelectSubject_20_N": _temp28,
    "S2_Icon_Background_20_N": _temp29,
    "S2_Icon_BadgeVerified_20_N": _temp30,
    "S2_Icon_BellRotated_20_N": _temp31,
    "S2_Icon_Bell_20_N": _temp32,
    "S2_Icon_BetaApp_20_N": _temp33,
    "S2_Icon_Binoculars_20_N": _temp34,
    "S2_Icon_Blur_20_N": _temp35,
    "S2_Icon_Bookmark_20_N": _temp36,
    "S2_Icon_Brand_20_N": _temp37,
    "S2_Icon_Briefcase_20_N": _temp38,
    "S2_Icon_BrightnessContrast_20_N": _temp39,
    "S2_Icon_Brush_20_N": _temp40,
    "S2_Icon_Bug_20_N": _temp41,
    "S2_Icon_Building_20_N": _temp42,
    "S2_Icon_Buildings_20_N": _temp43,
    "S2_Icon_CCLibrary_20_N": _temp44,
    "S2_Icon_CalendarAdd_20_N": _temp45,
    "S2_Icon_CalendarDay_20_N": _temp46,
    "S2_Icon_CalendarEdit_20_N": _temp47,
    "S2_Icon_CalendarWeek_20_N": _temp48,
    "S2_Icon_Calendar_20_N": _temp49,
    "S2_Icon_CallCenter_20_N": _temp50,
    "S2_Icon_CameraProperties_20_N": _temp51,
    "S2_Icon_Camera_20_N": _temp52,
    "S2_Icon_Cancel_20_N": _temp53,
    "S2_Icon_Channel_20_N": _temp54,
    "S2_Icon_ChartBarVert_20_N": _temp55,
    "S2_Icon_ChartPie_20_N": _temp56,
    "S2_Icon_ChartTrend_20_N": _temp57,
    "S2_Icon_Chat_20_N": _temp58,
    "S2_Icon_CheckBox_20_N": _temp59,
    "S2_Icon_CheckmarkCircle_20_N": _temp60,
    "S2_Icon_Checkmark_20_N": _temp61,
    "S2_Icon_ChevronDoubleLeft_20_N": _temp62,
    "S2_Icon_ChevronDoubleRight_20_N": _temp63,
    "S2_Icon_ChevronDown_20_N": _temp64,
    "S2_Icon_ChevronLeft_20_N": _temp65,
    "S2_Icon_ChevronRight_20_N": _temp66,
    "S2_Icon_ChevronUp_20_N": _temp67,
    "S2_Icon_Circle_20_N": _temp68,
    "S2_Icon_ClockPending_20_N": _temp69,
    "S2_Icon_Clock_20_N": _temp70,
    "S2_Icon_CloseCaptions_20_N": _temp71,
    "S2_Icon_CloseCircle_20_N": _temp72,
    "S2_Icon_Close_20_N": _temp73,
    "S2_Icon_CloudStateDisconnected_20_N": _temp74,
    "S2_Icon_CloudStateError_20_N": _temp75,
    "S2_Icon_CloudStateInProgress_20_N": _temp76,
    "S2_Icon_CloudStateOnline_20_N": _temp77,
    "S2_Icon_CloudStatePaused_20_N": _temp78,
    "S2_Icon_CloudStatePending_20_N": _temp79,
    "S2_Icon_CloudStateSlowConnection_20_N": _temp80,
    "S2_Icon_Cloud_20_N": _temp81,
    "S2_Icon_Code_20_N": _temp82,
    "S2_Icon_Collection_20_N": _temp83,
    "S2_Icon_ColorFill_20_N": _temp84,
    "S2_Icon_ColorHarmony_20_N": _temp85,
    "S2_Icon_Color_20_N": _temp86,
    "S2_Icon_CommentCheckmark_20_N": _temp87,
    "S2_Icon_CommentHide_20_N": _temp88,
    "S2_Icon_CommentRemove_20_N": _temp89,
    "S2_Icon_CommentShow_20_N": _temp90,
    "S2_Icon_CommentText_20_N": _temp91,
    "S2_Icon_Comment_20_N": _temp92,
    "S2_Icon_Community_20_N": _temp93,
    "S2_Icon_Compare_20_N": _temp94,
    "S2_Icon_ContextualTaskBar_20_N": _temp95,
    "S2_Icon_Contrast_20_N": _temp96,
    "S2_Icon_Copy_20_N": _temp97,
    "S2_Icon_CornerRadiusBottomLeft_20_N": _temp98,
    "S2_Icon_CornerRadiusBottomRight_20_N": _temp99,
    "S2_Icon_CornerRadiusEach_20_N": _temp100,
    "S2_Icon_CornerRadiusTopLeft_20_N": _temp101,
    "S2_Icon_CornerRadiusTopRight_20_N": _temp102,
    "S2_Icon_CornerRadius_20_N": _temp103,
    "S2_Icon_CropRotate_20_N": _temp104,
    "S2_Icon_Crop_20_N": _temp105,
    "S2_Icon_CursorClick_20_N": _temp106,
    "S2_Icon_Cut_20_N": _temp107,
    "S2_Icon_DataAdd_20_N": _temp108,
    "S2_Icon_DataRefresh_20_N": _temp109,
    "S2_Icon_DataSettings_20_N": _temp110,
    "S2_Icon_DataUpload_20_N": _temp111,
    "S2_Icon_Data_20_N": _temp112,
    "S2_Icon_Delete_20_N": _temp113,
    "S2_Icon_DeviceAll_20_N": _temp114,
    "S2_Icon_DeviceDesktopMobile_20_N": _temp115,
    "S2_Icon_DeviceDesktop_20_N": _temp116,
    "S2_Icon_DeviceLaptop_20_N": _temp117,
    "S2_Icon_DeviceMobile_20_N": _temp118,
    "S2_Icon_DeviceMultiscreen_20_N": _temp119,
    "S2_Icon_DevicePhone_20_N": _temp120,
    "S2_Icon_DeviceTablet_20_N": _temp121,
    "S2_Icon_DirectSelect_20_N": _temp122,
    "S2_Icon_Discover_20_N": _temp123,
    "S2_Icon_DistributeBottomEdge_20_N": _temp124,
    "S2_Icon_DistributeHorizontalCenter_20_N": _temp125,
    "S2_Icon_DistributeLeftEdge_20_N": _temp126,
    "S2_Icon_DistributeRightEdge_20_N": _temp127,
    "S2_Icon_DistributeSpaceHorizontally_20_N": _temp128,
    "S2_Icon_DistributeSpaceVertically_20_N": _temp129,
    "S2_Icon_DistributeTopEdge_20_N": _temp130,
    "S2_Icon_DistributeVerticalCenter_20_N": _temp131,
    "S2_Icon_Download_20_N": _temp132,
    "S2_Icon_Draw_20_N": _temp133,
    "S2_Icon_Duplicate_20_N": _temp134,
    "S2_Icon_EditNo_20_N": _temp135,
    "S2_Icon_Edit_20_N": _temp136,
    "S2_Icon_Education_20_N": _temp137,
    "S2_Icon_EffectBorder_20_N": _temp138,
    "S2_Icon_Effects_20_N": _temp139,
    "S2_Icon_Email_20_N": _temp140,
    "S2_Icon_Emoji_20_N": _temp141,
    "S2_Icon_Enterprise_20_N": _temp142,
    "S2_Icon_Erase_20_N": _temp143,
    "S2_Icon_ExportTo_20_N": _temp144,
    "S2_Icon_Export_20_N": _temp145,
    "S2_Icon_Exposure_20_N": _temp146,
    "S2_Icon_Eyedropper_20_N": _temp147,
    "S2_Icon_Feedback_20_N": _temp148,
    "S2_Icon_FileAdd_20_N": _temp149,
    "S2_Icon_FileConvert_20_N": _temp150,
    "S2_Icon_FileText_20_N": _temp151,
    "S2_Icon_FileUser_20_N": _temp152,
    "S2_Icon_File_20_N": _temp153,
    "S2_Icon_Files_20_N": _temp154,
    "S2_Icon_Filmstrip_20_N": _temp155,
    "S2_Icon_Filter_20_N": _temp156,
    "S2_Icon_Filters_20_N": _temp157,
    "S2_Icon_FindAndReplace_20_N": _temp158,
    "S2_Icon_Flag_20_N": _temp159,
    "S2_Icon_FlipHorizontal_20_N": _temp160,
    "S2_Icon_FlipVertical_20_N": _temp161,
    "S2_Icon_FolderAdd_20_N": _temp162,
    "S2_Icon_FolderBreadcrumb_20_N": _temp163,
    "S2_Icon_FolderClock_20_N": _temp164,
    "S2_Icon_FolderMoveTo_20_N": _temp165,
    "S2_Icon_FolderOpen_20_N": _temp166,
    "S2_Icon_FolderSearch_20_N": _temp167,
    "S2_Icon_Folder_20_N": _temp168,
    "S2_Icon_FontPicker_20_N": _temp169,
    "S2_Icon_FullScreenExit_20_N": _temp170,
    "S2_Icon_FullScreen_20_N": _temp171,
    "S2_Icon_Gift_20_N": _temp172,
    "S2_Icon_GlobeGrid_20_N": _temp173,
    "S2_Icon_GradientHorizontal_20_N": _temp174,
    "S2_Icon_GradientRadial_20_N": _temp175,
    "S2_Icon_Gradient_20_N": _temp176,
    "S2_Icon_GridTypeDots_20_N": _temp177,
    "S2_Icon_GridTypeLines_20_N": _temp178,
    "S2_Icon_GridsAndRulers_20_N": _temp179,
    "S2_Icon_GroupNo_20_N": _temp180,
    "S2_Icon_Group_20_N": _temp181,
    "S2_Icon_Hand_20_N": _temp182,
    "S2_Icon_HeartFilled_20_N": _temp183,
    "S2_Icon_Heart_20_N": _temp184,
    "S2_Icon_HelpCircle_20_N": _temp185,
    "S2_Icon_History_20_N": _temp186,
    "S2_Icon_Home_20_N": _temp187,
    "S2_Icon_ImageAdd_20_N": _temp188,
    "S2_Icon_ImageBackgroundRemove_20_N": _temp189,
    "S2_Icon_Image_20_N": _temp190,
    "S2_Icon_Images_20_N": _temp191,
    "S2_Icon_Import_20_N": _temp192,
    "S2_Icon_InfoCircle_20_N": _temp193,
    "S2_Icon_Interaction_20_N": _temp194,
    "S2_Icon_Invert_20_N": _temp195,
    "S2_Icon_Invite_20_N": _temp196,
    "S2_Icon_Key_20_N": _temp197,
    "S2_Icon_Keyboard_20_N": _temp198,
    "S2_Icon_LassoSelect_20_N": _temp199,
    "S2_Icon_Layers_20_N": _temp200,
    "S2_Icon_Layout_20_N": _temp201,
    "S2_Icon_Leave_20_N": _temp202,
    "S2_Icon_Lightbulb_20_N": _temp203,
    "S2_Icon_Lighten_20_N": _temp204,
    "S2_Icon_LineHeight_20_N": _temp205,
    "S2_Icon_Line_20_N": _temp206,
    "S2_Icon_LinkVertical_20_N": _temp207,
    "S2_Icon_Link_20_N": _temp208,
    "S2_Icon_ListBulleted_20_N": _temp209,
    "S2_Icon_ListMultiSelect_20_N": _temp210,
    "S2_Icon_ListNumbered_20_N": _temp211,
    "S2_Icon_Location_20_N": _temp212,
    "S2_Icon_LockOpen_20_N": _temp213,
    "S2_Icon_Lock_20_N": _temp214,
    "S2_Icon_Logo_20_N": _temp215,
    "S2_Icon_MagicWand_20_N": _temp216,
    "S2_Icon_Market_20_N": _temp217,
    "S2_Icon_MaskDisable_20_N": _temp218,
    "S2_Icon_Mask_20_N": _temp219,
    "S2_Icon_Maximize_20_N": _temp220,
    "S2_Icon_MediaOffline_20_N": _temp221,
    "S2_Icon_Mention_20_N": _temp222,
    "S2_Icon_MenuHamburger_20_N": _temp223,
    "S2_Icon_MicrophoneOff_20_N": _temp224,
    "S2_Icon_Microphone_20_N": _temp225,
    "S2_Icon_Minimize_20_N": _temp226,
    "S2_Icon_More_20_N": _temp227,
    "S2_Icon_Move_20_N": _temp228,
    "S2_Icon_MovieCamera_20_N": _temp229,
    "S2_Icon_MusicNote_20_N": _temp230,
    "S2_Icon_NamingOrder_20_N": _temp231,
    "S2_Icon_New_20_N": _temp232,
    "S2_Icon_Nudge_20_N": _temp233,
    "S2_Icon_OpenIn_20_N": _temp234,
    "S2_Icon_OrderBottom_20_N": _temp235,
    "S2_Icon_OrderOneDown_20_N": _temp236,
    "S2_Icon_OrderOneUp_20_N": _temp237,
    "S2_Icon_OrderTop_20_N": _temp238,
    "S2_Icon_Order_20_N": _temp239,
    "S2_Icon_OrientationLandscape_20_N": _temp240,
    "S2_Icon_OrientationPortrait_20_N": _temp241,
    "S2_Icon_Paste_20_N": _temp242,
    "S2_Icon_Path_20_N": _temp243,
    "S2_Icon_Pattern_20_N": _temp244,
    "S2_Icon_PauseCircle_20_N": _temp245,
    "S2_Icon_Pause_20_N": _temp246,
    "S2_Icon_PenBrush_20_N": _temp247,
    "S2_Icon_PeopleGroup_20_N": _temp248,
    "S2_Icon_People_20_N": _temp249,
    "S2_Icon_Percentage_20_N": _temp250,
    "S2_Icon_PinOff_20_N": _temp251,
    "S2_Icon_PinOn_20_N": _temp252,
    "S2_Icon_Play_20_N": _temp253,
    "S2_Icon_PluginGear_20_N": _temp254,
    "S2_Icon_Plugin_20_N": _temp255,
    "S2_Icon_Polygon3_20_N": _temp256,
    "S2_Icon_Polygon4_20_N": _temp257,
    "S2_Icon_Polygon5_20_N": _temp258,
    "S2_Icon_Polygon6_20_N": _temp259,
    "S2_Icon_Preview_20_N": _temp260,
    "S2_Icon_Print_20_N": _temp261,
    "S2_Icon_ProjectAddInto_20_N": _temp262,
    "S2_Icon_ProjectCreate_20_N": _temp263,
    "S2_Icon_Project_20_N": _temp264,
    "S2_Icon_Promote_20_N": _temp265,
    "S2_Icon_Prompt_20_N": _temp266,
    "S2_Icon_Properties_20_N": _temp267,
    "S2_Icon_Prototyping_20_N": _temp268,
    "S2_Icon_PublishNo_20_N": _temp269,
    "S2_Icon_Publish_20_N": _temp270,
    "S2_Icon_RadioButton_20_N": _temp271,
    "S2_Icon_RectangleHoriz_20_N": _temp272,
    "S2_Icon_Redo_20_N": _temp273,
    "S2_Icon_Refresh_20_N": _temp274,
    "S2_Icon_RemoveCircle_20_N": _temp275,
    "S2_Icon_Rename_20_N": _temp276,
    "S2_Icon_Replace_20_N": _temp277,
    "S2_Icon_ReportAbuse_20_N": _temp278,
    "S2_Icon_Resize_20_N": _temp279,
    "S2_Icon_Revert_20_N": _temp280,
    "S2_Icon_ReviewLink_20_N": _temp281,
    "S2_Icon_Ribbon_20_N": _temp282,
    "S2_Icon_RocketQuickActions_20_N": _temp283,
    "S2_Icon_RotateCCW_20_N": _temp284,
    "S2_Icon_RotateCW_20_N": _temp285,
    "S2_Icon_RotateOrientation_20_N": _temp286,
    "S2_Icon_Ruler_20_N": _temp287,
    "S2_Icon_Saturation_20_N": _temp288,
    "S2_Icon_SaveFloppy_20_N": _temp289,
    "S2_Icon_Search_20_N": _temp290,
    "S2_Icon_SelectAllItems_20_N": _temp291,
    "S2_Icon_SelectAndMove_20_N": _temp292,
    "S2_Icon_SelectMulti_20_N": _temp293,
    "S2_Icon_SelectNo_20_N": _temp294,
    "S2_Icon_SelectNone_20_N": _temp295,
    "S2_Icon_SelectRectangle_20_N": _temp296,
    "S2_Icon_Select_20_N": _temp297,
    "S2_Icon_Send_20_N": _temp298,
    "S2_Icon_Settings_20_N": _temp299,
    "S2_Icon_Shapes_20_N": _temp300,
    "S2_Icon_ShareAndroid_20_N": _temp301,
    "S2_Icon_Share_20_N": _temp302,
    "S2_Icon_ShoppingCart_20_N": _temp303,
    "S2_Icon_Shuffle_20_N": _temp304,
    "S2_Icon_Similar_20_N": _temp305,
    "S2_Icon_Slideshow_20_N": _temp306,
    "S2_Icon_SlowConnectionCircle_20_N": _temp307,
    "S2_Icon_SocialNetwork_20_N": _temp308,
    "S2_Icon_SortDown_20_N": _temp309,
    "S2_Icon_SortUp_20_N": _temp310,
    "S2_Icon_Sort_20_N": _temp311,
    "S2_Icon_SpeedFast_20_N": _temp312,
    "S2_Icon_StampClone_20_N": _temp313,
    "S2_Icon_StarFilled_20_N": _temp314,
    "S2_Icon_Star_20_N": _temp315,
    "S2_Icon_StepBackward_20_N": _temp316,
    "S2_Icon_StepForward_20_N": _temp317,
    "S2_Icon_StickyNote_20_N": _temp318,
    "S2_Icon_StrokeDotted_20_N": _temp319,
    "S2_Icon_StrokeSolid_20_N": _temp320,
    "S2_Icon_StrokeWidth_20_N": _temp321,
    "S2_Icon_SwitchVertical_20_N": _temp322,
    "S2_Icon_Switch_20_N": _temp323,
    "S2_Icon_Table_20_N": _temp324,
    "S2_Icon_TagBold_20_N": _temp325,
    "S2_Icon_TagItalic_20_N": _temp326,
    "S2_Icon_TagStrikeThrough_20_N": _temp327,
    "S2_Icon_TagUnderline_20_N": _temp328,
    "S2_Icon_Tag_20_N": _temp329,
    "S2_Icon_Target_20_N": _temp330,
    "S2_Icon_Temperature_20_N": _temp331,
    "S2_Icon_Template_20_N": _temp332,
    "S2_Icon_TextAdd_20_N": _temp333,
    "S2_Icon_TextAlignCenter_20_N": _temp334,
    "S2_Icon_TextAlignJustifyLastCenter_20_N": _temp335,
    "S2_Icon_TextAlignJustifyLastLeft_20_N": _temp336,
    "S2_Icon_TextAlignJustifyLastRight_20_N": _temp337,
    "S2_Icon_TextAlignJustify_20_N": _temp338,
    "S2_Icon_TextAlignLeft_20_N": _temp339,
    "S2_Icon_TextAlignRight_20_N": _temp340,
    "S2_Icon_TextBold_20_N": _temp341,
    "S2_Icon_TextCapsAll_20_N": _temp342,
    "S2_Icon_TextCapsSmall_20_N": _temp343,
    "S2_Icon_TextHighlight_20_N": _temp344,
    "S2_Icon_TextIncrease_20_N": _temp345,
    "S2_Icon_TextItalic_20_N": _temp346,
    "S2_Icon_TextNumbers_20_N": _temp347,
    "S2_Icon_TextParagraph_20_N": _temp348,
    "S2_Icon_TextReplaceComment_20_N": _temp349,
    "S2_Icon_TextSize_20_N": _temp350,
    "S2_Icon_TextStrikeThrough_20_N": _temp351,
    "S2_Icon_TextSubscript_20_N": _temp352,
    "S2_Icon_TextSuperscript_20_N": _temp353,
    "S2_Icon_TextUnderline_20_N": _temp354,
    "S2_Icon_TextVariableFontSettings_20_N": _temp355,
    "S2_Icon_Text_20_N": _temp356,
    "S2_Icon_ThumbDown_20_N": _temp357,
    "S2_Icon_ThumbUp_20_N": _temp358,
    "S2_Icon_Toggle_20_N": _temp359,
    "S2_Icon_Tools_20_N": _temp360,
    "S2_Icon_TouchOneFingerSwipeLeftRight_20_N": _temp361,
    "S2_Icon_Transcript_20_N": _temp362,
    "S2_Icon_TransformDistort_20_N": _temp363,
    "S2_Icon_TransformGeneric_20_N": _temp364,
    "S2_Icon_TransformPerspective_20_N": _temp365,
    "S2_Icon_TransformSkew_20_N": _temp366,
    "S2_Icon_TransformWarp_20_N": _temp367,
    "S2_Icon_Translate_20_N": _temp368,
    "S2_Icon_Tutorials_20_N": _temp369,
    "S2_Icon_UnLink_20_N": _temp370,
    "S2_Icon_Undo_20_N": _temp371,
    "S2_Icon_UnlinkHoriz_20_N": _temp372,
    "S2_Icon_UnlinkVertical_20_N": _temp373,
    "S2_Icon_UploadToCloud_20_N": _temp374,
    "S2_Icon_Upload_20_N": _temp375,
    "S2_Icon_UserAdd_20_N": _temp376,
    "S2_Icon_UserAvatarCursor_20_N": _temp377,
    "S2_Icon_UserAvatar_20_N": _temp378,
    "S2_Icon_UserEdit_20_N": _temp379,
    "S2_Icon_UserFollowing_20_N": _temp380,
    "S2_Icon_UserGroup_20_N": _temp381,
    "S2_Icon_UserLock_20_N": _temp382,
    "S2_Icon_UserSettings_20_N": _temp383,
    "S2_Icon_User_20_N": _temp384,
    "S2_Icon_UsersLock_20_N": _temp385,
    "S2_Icon_VectorDraw_20_N": _temp386,
    "S2_Icon_Video_20_N": _temp387,
    "S2_Icon_ViewGridFluid_20_N": _temp388,
    "S2_Icon_ViewGrid_20_N": _temp389,
    "S2_Icon_ViewList_20_N": _temp390,
    "S2_Icon_ViewTransparency_20_N": _temp391,
    "S2_Icon_VisibilityOff_20_N": _temp392,
    "S2_Icon_Visibility_20_N": _temp393,
    "S2_Icon_VolumeOff_20_N": _temp394,
    "S2_Icon_VolumeOne_20_N": _temp395,
    "S2_Icon_VolumeTwo_20_N": _temp396,
    "S2_Icon_Wallet_20_N": _temp397,
    "S2_Icon_WebNavBar_20_N": _temp398,
    "S2_Icon_WebPage_20_N": _temp399,
    "S2_Icon_ZoomIn_20_N": _temp400,
    "S2_Icon_ZoomOut_20_N": _temp401
};

},{"231e0a69dc3f0d46":"fBLEq","907d91e262c242ff":"1QNGZ","45da033475347da4":"32pGt","3fe980cb81d7ca05":"d10jd","c1a887d44dec7315":"cDsa5","cbcc5100bf6f2758":"k8LxT","985a41651244380b":"hkDsd","d4446eb7f5b0d4ad":"brWL3","20eec45199029b57":"921LY","271faedb4d2d3a28":"jyuVv","8e74f90c17f580c5":"7jtI9","3de3d7d090e0c33a":"1N7d5","183376a24ff24e77":"f6GNw","c8731384e0271f84":"lJNcY","1b766a3d7faedc2a":"3I1Mp","157ae62fd05b0ed1":"3y532","69cbb5cb455fbc09":"bd98e","2bb4dc813a6689f6":"7K1NW","b8dd6c27a7f8e139":"hd9GI","c6e9a406ae6c9edd":"k0X7J","aef89102f27d8286":"8M00f","1743154ecab461ab":"2NbrT","6e090f5f1fc4ca8":"la2Hs","15940b399779bec9":"UmfPO","2380053b2e8a2d52":"01pVK","8dcf24cc08172e97":"cyNrR","e8293b17c5c544be":"5Pkgy","9f2b876555908fad":"jF3g4","359de201a7fea00f":"gpJrx","dbff7f31db205e61":"kN69E","8d0a5796b2a12f9":"4xe3L","5f106359edaba166":"cQVAx","9e1a17bfedaad353":"iCEaV","f3c70a9a2fa8ff28":"2370J","d95052b8ab9c7440":"gj1GO","4f0abe87de7c78ce":"krWIU","cc0263817d650ad4":"dU6kd","11f7edb69a984cec":"b2D5l","933db094d9988a14":"1nyHS","a74b01f76d430e4d":"8zJWv","2d5d2faaa84966bd":"lKS2A","b243256ec968c9b8":"6y5M5","6df35de6861ca522":"28VQl","d9e5371ee88f9943":"81MDh","5b8a1d1b4379a6be":"dk7oT","98d4a9740a773ea9":"aL1zM","de6bd474f8e510ff":"bimOU","6d2afa003e8376f9":"5Rdp8","d701e8a00182d2bc":"827by","7cdd91dd827763c0":"3yrCq","f2ff1e35f503a359":"8F2MX","da26633b7affebc0":"g2mMq","ac334db8e5a2ddb4":"jjTpg","92d3ba5c82bccec8":"M4C9q","5848c028c04bd5a4":"iIgvl","e0bf0909deca7962":"2lNmz","b408a6b5292c3e79":"bDzGq","5dc426682f6a5323":"c4s9O","533b7ca7afe751a5":"iaAWm","b97a34e36e8142d0":"in5JG","5d4d26f41dfaeaa8":"6hpGX","1e1b86bce808c9b":"1QXwE","a28e4de0a3e2716a":"hmKpo","907c7cba9e922da7":"1TE6V","aa8033aee22521c2":"erT5A","9a8763b4ae8eab96":"5jnVm","5f6c62f3a39f0dd2":"kmqkh","6b6014ee8ff46c96":"jSLkY","2cbbb79d24d78855":"4exIF","f0ae57edbde5773c":"kKJJv","9758936a65df3079":"iihF3","5ad7263fc88c9fe":"jS6vK","48b3b5e90c62a56a":"k1FvW","6f6749451b711c9a":"aI18O","769cda48bc17168a":"727hu","ce7b62c3c81f21c9":"2H4mr","78d9a7527e75de9c":"1X7NR","d2a87a1267503f2a":"3NngQ","3ce70b4fe80a4084":"2EIpu","29be3cf36ac45ef":"5MXoX","e3463035dd1a6260":"eR09f","cef4cb6b618de6c9":"1huEG","c4429e72c74e6001":"8rpVg","3521bf3ecaae81cd":"aWHKw","f623e79b8b2ee1fe":"jBc3C","c858f73b0698e31b":"8oMAI","f9af7bae7c5054f5":"fTKa2","79804aba1c1245e5":"14bSM","5ea946f3bd193bce":"llsW4","7ca9024f8377db86":"3G75z","ac5805ff163a2dec":"ihnDL","5331a8cb8b7635dd":"fLdl8","3597e814e39cb3c8":"aQjFO","462c52334090094b":"dRvKc","38176e6b976666ad":"bB4qC","67a8d7e5a13f4350":"iAwMm","bbb5143ce7187c7f":"jAv02","d57872447e2b6a79":"6imrL","ac76f8effd443637":"uJMHG","a4f795a85fd4e92a":"5Tiyw","24c9797f75cb9e28":"jUoeK","136f5fa37e70d1b6":"8JlGs","41c75fbbfdcee84e":"eDnn5","30630a13fbf2aba7":"lwOQJ","aec2ab22f3271464":"901M5","9c079d1c6c4efc7e":"bZPpG","749f9f25a6a8c5db":"01Om8","f4b20cb9e52c6da6":"7CXbj","3e4242b1b0bad2d":"7TXs3","6d94ec34f355c7ae":"5i8F6","c7ba5a6ff7e1476a":"cHrqP","38222936b6cb58e8":"l6Fye","ba39a9993f7b35d2":"77KV8","6d8f233195f5f648":"elAa6","539fd8f29a7cec44":"4sR3H","38073bd37c0172d7":"6ZTaF","df04ef23d3d3f64":"g9qPz","52c11bd251181298":"auIka","264b166999e685bc":"7DJon","d44c1b9ec4cff34c":"8DFUz","6626f3959e9ae79":"6988a","49515851fd6d2c5d":"WD2xG","547d5cc79f959485":"2qhE3","aa136d813c0c841d":"6D32N","faf207aa97f8dd20":"jyhIC","d23ff68b0c6d6be7":"bFGRm","9775cee1fcb72894":"iq2rD","cbdd219e38a56b0":"aXPzo","7c865d879b2d98af":"1PyrC","6ff199d02008e74c":"fk1ac","344a62cc587d389c":"hHUco","79d24ff606952fb7":"KLXIn","2410a78040e6ea26":"jifhr","ae8c7ce955301d3":"fSeMY","caec6c1b85f59e52":"bHSBe","7cf7e4d30b2a3b20":"lB02x","15fff6499b8bd3ba":"h4rDR","7030298510269f4b":"bf5nW","a571b6a5e6c955db":"RFzUR","b27142edaafbdbd7":"jyYA8","79c46bea530050c1":"a0yC6","10fa1e76a674fd6d":"cHQyX","ce5d6ff07f979cb8":"lift3","3e7ed4a6a55484a8":"8Xxyi","77e1d117e5f29fe3":"l22kS","ae5e60ae8cc98d7e":"ldsyU","32fed45b146fa468":"4rCzU","350ec56bf5303f7a":"euK87","97cdb7fe01434966":"iz1uk","28294a3a401bd4ff":"2sRPb","fdc05c0f6968fcec":"1FyXF","5df4cf43a216ece9":"8dGEU","71b16826e5db7c22":"1Dl3M","2781bbfae1f64a1b":"99rjs","3a8f4e5b20fe8952":"b0jYl","468e164bb444d97b":"lbNh6","d838d2eb417da597":"6kxa6","76b9c46b384122cf":"frTYk","90c141280f3aa156":"lCGFj","3fd5e2c2eb4e2989":"83kmp","236ddd091b59aed8":"2IzpU","5f1908db7b81ae8e":"4vT2q","28b259e0649e926a":"7YABU","6f4f527fa0881668":"eTHST","e8e1e81d83c5fe26":"jYQ0I","1d2ae8c12d2034f6":"g0aKy","d8bda0b2d8dc93fc":"llhOx","ac4c8a73700989f1":"hGSuR","48eba80e067a7eff":"dLqBo","9062e5f326ea4b68":"lVbjz","4cf6331f8555205":"4j7PJ","ab9cb15aaee9c31b":"6KAi8","60e59c37cf639cdf":"8IMrq","995de3e9dfc322e4":"gY6Id","f58b6e332c3a0bef":"74e2b","a6b366fb1803cfe5":"aY6R3","da176464bbd8523":"9ZmpS","947d00af2668d87b":"2UII3","a618619ed5140a6b":"7uHTH","e18d0f978bc5d872":"f67wn","903ae48abe8f030d":"fHbip","6b3470206003ee50":"cXfQi","568d974b44dc3dfc":"2bQ8n","c058ccd074b7ea78":"2Hd2O","cdcf6e87457c9983":"6GceM","f95b976ede313f1a":"38wV2","964806ba61c2dc5d":"8Y3kV","d5ecc8571cb25c35":"eGxUY","bae269583f046fa0":"aKAX7","9ba324215df32043":"f10ml","8fe1ac7d5ef0f81":"ld4zI","4ac3552768ce0c32":"cq5GK","f8e051a9b44c9918":"41CiH","e94c2885380f7d3c":"hByEX","78df0d0777b2da50":"keCxj","7c5b0fbb812a43b4":"5Mo17","780c01abbbb56f03":"dJeU1","ccf36c825dbcbaf7":"9i0tj","a2048441e6eb8848":"cYlEj","12d2ee5b9d184e54":"bZM0k","5bd2c7c47f7bd189":"fxk0C","2a574a9a81d0447a":"afLJb","10528dc19499e25a":"jUH8i","b488323d801247c8":"2jxDj","8c20ae29e1f29489":"8rFkP","a66dedc0b213991b":"5o3or","b4d1a056cc3add2b":"avv69","8cb9783bac30c6a1":"daMQZ","d0260832343f556a":"ivjAn","bd839a1655197bb1":"4tBiB","896f6b5c20fb5e68":"4HQ0C","4ebe595ca40ad970":"g4ToF","58f8df047b758d02":"2w2X1","d0e5bb469616a4fd":"lAvHi","5de725c689a5a44":"2DEGX","bf2241a9d8f87849":"8dS63","77efb63c0c6547fa":"8diGc","afd89c9b8e1e7748":"3Ohhw","5cd7968f2a2c2fab":"30CWa","af6dfc6a94b5b31":"gOrsQ","739f0decedd5022e":"dyurA","927d509be785b427":"nFkMC","6b66344a9044be0f":"VIo5J","e608a58890a2c414":"bneuv","2fadd810153e3411":"gbebz","a682e20e12a99f51":"bcho2","5aa24c702f3f9e32":"4nP90","f934123202bf95dc":"gP3id","789e1fcdd3bfb7f7":"iesR2","ac6e8fd53e676aef":"4Yg6X","daad00144f0b5da3":"bViLi","d77e301e3c236a57":"7DDOy","c32c320207f70053":"9ljtw","a423a702807fbe2c":"hznZm","3b27734354f2e9fa":"brg0k","6557faf3c60a726f":"iUGVu","5c6cf9dde67250dc":"frBLd","7480c143c99ded74":"8HJNV","3954f632122f493":"1Ke9z","1f8f3888793d85cb":"kmIZF","16409a00dc7f403c":"9fLd8","c260477e1174c8be":"3lC1M","910d432de2111f19":"hyJp5","f5e447860c43da7b":"fSpZi","a470861487d75465":"djbJ6","11f1b7b30040bd3b":"5WDcl","d52785e1e5f2788b":"fqvG6","dbd7784b57b4631b":"eJEX2","b4e56267604a7d42":"ctMXH","dfd12170080dd7a4":"2bVJx","7b511554946f4f49":"5XxZU","d233051b9400b0ca":"buuiR","b437a5b64b916209":"bKDWX","b2cddd767aab89b2":"2qWTs","7d75e871dffcb154":"769FV","5f7835b7da8dbd2":"kP2hr","dd7c320a27a7907b":"fmBad","847699a169a7b4fb":"iLYOX","24a54e118faa27f2":"9k4qh","5dea199dec2b8c88":"8FQgp","ecb361fca7170cdf":"7ujFm","abe4d6cbe5145a6":"4AoeH","bf4961f5c4ccadf0":"fF9ir","d03bfd93be761ab1":"aDb3k","7790ad56e39bc2e7":"lkt5b","16c3da0692a395fc":"5OfyV","fd0998dfd337530f":"h0Yh9","bd9a0e653b9a16f9":"a73RX","dff5bdf69ad9b39f":"cmRpi","69d904e8b08676dc":"8EeNL","5e539bc7c030e40b":"kuJHJ","7442893356376757":"i8pOt","d09c761c0575dca8":"4PoT5","c7bd4e06538ea45d":"5YrhY","3e495dd25f838505":"gwFGB","37def537096458cb":"8rNDD","2e15aabd4ee40122":"bahY1","d3e932d36e835175":"aPbth","eaecfd058c8f21a2":"2HSQI","32cba2d4008fec8a":"Zjfa6","e27f1ab005546c81":"hOe3F","3b6b56992c717d3e":"b1qtW","8199206a71f267cb":"adRGe","fd700c4a37a75c43":"eZF8i","2dadbe149aacfd7":"hsD8u","4c9c13c296471bc7":"dEIAf","19d0eb60d30d5c5a":"eMDaf","b4b5d30bf571a102":"3MX7h","7f23fb3dd9d5d1bc":"JOv4h","b39ca6a45436a855":"bkonk","33516746aea36fb1":"cSREm","d53a9c0d5a846261":"aJeQO","181239c46f23acdc":"gueil","7e10b526dfc48b69":"kKUGI","26f9c9655ac53160":"MY7qb","de416bc9fdb225d8":"7KZLK","69c56e2703d72474":"4HvH2","b21289bdd11a44f3":"ePiXv","9e8feba304cee8fb":"crxtl","383eb288767199be":"kzvDN","b07e5681d8dc3cea":"2xIVU","4ee25ed68296a6e8":"a466w","6299bba1b62a8cbf":"5zEOm","d8a00a0dacf1e69c":"28zfJ","13fc078037ef3683":"bH1Dq","3dcd072923e44724":"dvRuh","8bef9b1b1484cbbc":"dAI8Q","e53d8475175248c4":"eZq7m","1fbbb0a8c0ad0110":"eZU2C","3c16475a63756ef4":"ipfe6","36d89a8903ff3c3c":"9pN2c","3d83c73165c42643":"lTXig","f8d1ff36c31acea3":"4c1u1","f42a06ca03a9bae5":"buR8k","16d03ebb03196487":"cPXrk","4e7672f45a2f0f6b":"hZJhZ","c63c19369ff8a368":"8dCAP","f4bba485dcd02324":"74ZDk","2442ebe8953f80d3":"cgtQ7","e1e9bdf5d9d053d3":"5We3S","f3a516008c8ec6e5":"dAej9","a86f4d21878a4165":"zX49W","49840c0ca6fbe4db":"71qYk","d72bdf06ea59cf25":"lljLf","405f79cae0a3bb81":"hYnHM","197a644131e46048":"a4mCK","4e8188811005e75b":"gFPTC","462ff65e4ec3be4a":"aVVqT","d4fe5dc3d998e8b4":"k6hCW","92ff555d0d626ad7":"eFOXg","6fd528982e77f0cf":"4nACT","58722f2b1e044ab0":"gExBO","1feb23deefd3e7f6":"aNtQV","48c35dc870c3950a":"kJSkG","eb0bac4c4185d3c9":"lJ2dl","a4a7714c604a05ea":"3zo1O","2e530cd81da4535e":"iYsj6","816e54ce73fe44cd":"cwdKI","932059cb319b37fc":"lx2Ht","767b042d678a78f1":"6S5wg","16453d7c8b78f62b":"cSNUd","2c067a2992d27856":"a2vIM","a8d2a6c75f21840a":"2dZZV","1c7afe7e27ae41ee":"bC11M","d40d704f6a269027":"aSnpB","69c8982c4f722a5c":"d28Yb","66e0ca0d9cfcb659":"ldbZV","a3cf04690df6bbd9":"4rSQP","d86860bcd3a8e603":"5QYia","fa5cea672c3db864":"4uJnz","73b3ad702647d4ec":"4IGfd","efe61c36d1b3aa04":"gbHpB","1d240709e8bc86a5":"8rVRU","95d9e8098379eeb2":"fplc4","c524c98e9ff96ce9":"4Hamj","1841c2b927fafc7e":"35shn","ac23e5db0087f386":"QNroZ","8706cbe0af6a0541":"015fd","207eab6bcc7d3b4d":"bt8TI","bbd7adc7919f030e":"6EmTT","be8c04ca7cebcabe":"h9703","cbe157bf83d2e95a":"ach2u","76e22dfcac6e2655":"9LYat","6c56ddb72d4caf71":"iVJgu","136f2f61e195af6":"hrHN8","e25afae5778c58c4":"8ARg1","43c97c816e884c34":"kEXJg","df72206e7791eef4":"9hhbS","b0d64b44ab7f0e4b":"2PtZ3","9d7298f6df570ea3":"gmxtP","46ca7c5387438b31":"gTBhP","e13bee8ff988ab50":"7Cl4f","bd81a032b9259db1":"1FptQ","c70bf51cacf2cd61":"5G11O","48324fbd57fb519e":"4W2RY","2ae23f3f07c76238":"i0vS5","6d52ec2cd1102d2":"2oOIY","1c201bbf46462f5b":"kS2gn","1f26b9750576e278":"7CBmZ","b304f60b1c6fcb12":"j3r74","3276dab36b1dc99e":"3WBuC","c7bd5c77efb878ce":"8sjSV","14ef6ca3b0495359":"9QgwT","69b86ae68f62fea":"acXbr","bdd6018e8f091998":"gWWl0","e3b2852cdfd22318":"gLc9g","b69778e25f136b6":"6hUY8","1052e5a1d619a8d":"bHYwF","9b461c3ab49900de":"bZCJ3","94bfb483b869f40e":"iwUs6","1e711527be31fd67":"2DcIE","5d4bc529f23d14a9":"a4EFS","7657e81b7841ad0e":"iItAA","e327e50f090ebe46":"5Nxjo","5d87f906010ba38a":"2ZQwP","772c2ba63a886bd8":"jegkx","45b3415f8e2b18f6":"gyhDQ","6f7bb8f49ef80190":"fwKUa","29a331f4b0104873":"17pX0","4d9a8be4685a2003":"kPrFq","8f221bfc4196c66a":"gOqkZ","da7d7abb7765118f":"bloyx"}],"fBLEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m17.771 5.082-2.789-1.61c-.528-.306-1.189-.312-1.721-.017L10 5.253 6.737 3.455c-.534-.293-1.193-.288-1.72.018l-2.79 1.609C1.472 5.521 1 6.336 1 7.21v4.556c0 .875.47 1.69 1.229 2.127L8.77 17.67c.38.219.804.328 1.229.328s.85-.11 1.229-.328l6.542-3.778C18.53 13.456 19 12.64 19 11.766V7.21c0-.874-.47-1.69-1.229-2.128m-12.003-.31q.059-.034.125-.034c.04 0 .083.011.12.032l3.625 1.997c.226.123.498.123.724 0l3.623-1.998.001-.001c.076-.042.168-.041.244.002l2.561 1.478-6.79 3.746L3.205 6.25zm-2.79 7.822c-.294-.17-.478-.488-.478-.828v-4.19l6.75 3.718v4.921zm14.043 0-6.271 3.621v-4.922L17.5 7.57v4.196c0 .34-.184.658-.479.828"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1QNGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.86 10.405c-.498 0-.938-.165-1.254-.482-.436-.436-.585-1.107-.41-1.842.153-.638.535-1.287 1.077-1.829 1.216-1.215 2.828-1.508 3.67-.667.843.844.55 2.456-.666 3.672-.542.542-1.192.924-1.828 1.076q-.305.073-.588.072m1.833-4.05c-.39 0-.984.229-1.536.782-.376.375-.647.825-.745 1.235-.072.298-.042.547.078.667.12.121.37.152.668.078.41-.097.86-.369 1.235-.745.784-.783.919-1.65.667-1.902-.075-.075-.203-.116-.367-.116"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"32pGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.876 4.84h-.001l-5.749-3.319c-.696-.402-1.559-.4-2.251 0l-5.751 3.32C2.431 5.242 2 5.989 2 6.79v6.64c0 .801.432 1.548 1.125 1.948l5.749 3.32C9.222 18.9 9.611 19 10 19c.39 0 .778-.1 1.125-.3l5.75-3.321c.693-.4 1.125-1.147 1.125-1.948V6.79c0-.8-.43-1.548-1.124-1.95m-7.25-2.02c.115-.067.244-.1.374-.1.129 0 .259.033.375.1l5.285 3.052L10 8.994l-5.664-3.12zM3.875 14.08c-.231-.135-.375-.384-.375-.65V7.126l5.75 3.168v6.889zm12.25 0-5.375 3.102v-6.889l5.75-3.172v6.309c0 .266-.144.515-.375.65"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8IMrq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.75 6h-1.314c.194-.376.314-.797.314-1.249 0-1.517-1.233-2.75-2.75-2.75-.79 0-1.498.34-2 .874-.502-.535-1.21-.874-2-.874-1.517 0-2.75 1.233-2.75 2.75 0 .452.12.873.314 1.249H4.25C3.01 6 2 7.01 2 8.25v1.5c0 .778.398 1.465 1 1.869v4.131C3 16.99 4.01 18 5.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25v-4.131c.602-.404 1-1.091 1-1.869v-1.5C18 7.01 16.99 6 15.75 6m.75 2.25v1.5c0 .413-.337.75-.75.75h-5V7.501H12l.01-.001h3.74c.413 0 .75.337.75.75M12 3.501c.69 0 1.25.56 1.25 1.25 0 .688-.558 1.246-1.245 1.249H10.75V4.751c0-.69.56-1.25 1.25-1.25m-5.25 1.25c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25V6H7.995c-.687-.003-1.245-.561-1.245-1.249M3.5 8.25c0-.413.337-.75.75-.75h3.74l.01.001h1.25V10.5h-5c-.413 0-.75-.337-.75-.75zm1 7.5V12h4.75v4.5h-4c-.413 0-.75-.337-.75-.75m10.25.75h-4V12h4.75v3.75c0 .413-.337.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gY6Id":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 1.252c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75-3.925-8.75-8.75-8.75m7.21 8H14.07c-.14-2.33-.915-4.526-2.192-6.245 2.856.767 5.023 3.231 5.334 6.245m-7.198 7.631c-1.49-1.537-2.419-3.745-2.582-6.131h5.14c-.162 2.388-1.081 4.593-2.558 6.131M7.431 9.252c.162-2.387 1.091-4.594 2.581-6.132 1.477 1.538 2.396 3.743 2.558 6.132zm.715-6.251c-1.29 1.72-2.074 3.92-2.215 6.251H2.79c.312-3.022 2.49-5.49 5.357-6.251M2.79 10.752h3.142c.141 2.33.926 4.53 2.216 6.25-2.867-.759-5.046-3.228-5.358-6.25m9.088 6.245c1.277-1.72 2.052-3.915 2.192-6.245h3.142c-.311 3.014-2.479 5.478-5.334 6.245"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"74e2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "04e823__a",
                    x1: -239.333,
                    x2: -223.067,
                    y1: 250,
                    y2: 250,
                    gradientTransform: "translate(240 -240)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0.024,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0.968
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0.627,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0.261
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#04e823__a)",
                d: "M3 3h14v14H3z",
                transform: "rotate(-90 10 10)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25M3.5 15.75c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75V4.25c0-.413-.337-.75-.75-.75H4.25c-.413 0-.75.337-.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aY6R3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                    id: "42ff97__a",
                    cx: 10,
                    cy: 10,
                    r: 8.241,
                    fx: 10,
                    fy: 10,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0.024,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0.968
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0.627,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0.261
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 7.25,
                fill: "url(#42ff97__a)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2UII3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h11.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 6,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14,
                cy: 6,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 10,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14,
                cy: 10,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 14,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 14,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14,
                cy: 14,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7uHTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2m.75 2.25v2.625h-3.375V3.5h2.625c.414 0 .75.337.75.75m-8.375 7.625v-3.75h3.75v3.75zm3.75 1.25V16.5h-3.75v-3.375zm-5-1.25H3.5v-3.75h3.375zm1.25-5V3.5h3.75v3.375zm5 1.25H16.5v3.75h-3.375zM4.25 3.5h2.625v3.375H3.5V4.25c0-.413.336-.75.75-.75M3.5 15.75v-2.625h3.375V16.5H4.25c-.414 0-.75-.337-.75-.75m12.25.75h-2.625v-3.375H16.5v2.625c0 .413-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"f67wn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2.75 12.059c-.414 0-.75-.336-.75-.75V4.25C2 3.01 3.01 2 4.25 2h8.5C13.99 2 15 3.01 15 4.25v3.148c0 .415-.336.75-.75.75s-.75-.335-.75-.75V4.25c0-.413-.336-.75-.75-.75h-8.5c-.414 0-.75.337-.75.75v7.059c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m6 11.27 5-1.692V7.25h3V6h-3V3H9.75v3h-2.5V3H6v3H3v1.25h3v2.5H3V11h3zm1.25-4.02h2.5v2.5h-2.5z",
                opacity: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m18.92 12.692-.88-2.594c-.266-.783-1.116-1.207-1.9-.939L3.352 13.484c-.38.128-.687.396-.866.755-.177.36-.205.767-.076 1.148l.88 2.593c.211.625.796 1.02 1.421 1.02q.242.001.48-.08l12.788-4.324.001-.001c.782-.265 1.204-1.117.94-1.903M4.712 17.5l-.88-2.593 1.577-.533.407 1.206c.089.26.332.425.593.425q.1 0 .2-.033c.327-.11.502-.465.392-.792l-.408-1.206 1.657-.561.211.623c.088.26.332.425.592.425q.1 0 .2-.033c.328-.11.503-.465.393-.792l-.211-.624 1.657-.56.408 1.205c.088.261.332.425.592.425q.1 0 .2-.033c.328-.11.503-.465.392-.792l-.408-1.206 1.658-.561.212.623c.087.261.33.425.591.425q.101 0 .201-.033c.327-.11.502-.466.391-.792l-.211-.624 1.503-.508.879 2.595z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fHbip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.5 15h-2c-.827 0-1.5-.673-1.5-1.5S5.673 12 6.5 12h2c.827 0 1.5.673 1.5 1.5S9.327 15 8.5 15M17.25 14.397c-.414 0-.75-.335-.75-.75V4.25c0-.413-.336-.75-.75-.75H6.32c-.414 0-.75-.336-.75-.75S5.906 2 6.32 2h9.43C16.99 2 18 3.01 18 4.25v9.397c0 .415-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.25 18h-9C3.01 18 2 16.99 2 15.75v-9c0-.414.336-.75.75-.75s.75.336.75.75v9c0 .413.336.75.75.75h9c.414 0 .75.336.75.75s-.336.75-.75.75M13.25 10h-.334c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.334c.138 0 .25-.112.25-.25v-1.5c0-.138-.112-.25-.25-.25H9.417c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h3.833c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75M18.25 19.02c-.192 0-.384-.074-.53-.22L1.22 2.3c-.293-.293-.293-.768 0-1.06s.767-.294 1.06 0l16.5 16.5c.293.292.293.767 0 1.06-.146.146-.338.22-.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cXfQi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.5 15h-2c-.827 0-1.5-.673-1.5-1.5S5.673 12 6.5 12h2c.827 0 1.5.673 1.5 1.5S9.327 15 8.5 15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h11.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.25 10h-2.833c-.965 0-1.75-.785-1.75-1.75v-1.5c0-.965.785-1.75 1.75-1.75h2.833c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75m-2.833-3.5c-.138 0-.25.112-.25.25v1.5c0 .138.112.25.25.25h2.833c.138 0 .25-.112.25-.25v-1.5c0-.138-.112-.25-.25-.25z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2bQ8n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.4 5.126c-.357-.06-.705-.019-1.027.09v-.871c0-1.172-.953-2.125-2.125-2.125-.39 0-.703.109-.954.288-.376-.6-1.038-1.002-1.796-1.002-.966 0-1.774.651-2.031 1.535-.226-.082-.466-.134-.719-.134-1.172 0-2.125.953-2.125 2.125V8.73c-.323-.414-.776-.695-1.296-.787-.561-.101-1.125.027-1.588.352-.466.325-.775.812-.874 1.371-.098.56.027 1.123.352 1.589l2.75 3.916c1.842 2.38 3.562 3.323 6.092 3.323h.165c3.224-.03 5.518-2.406 6.133-6.347l.78-4.568c.197-1.155-.582-2.255-1.737-2.452m-.523 6.778c-.501 3.212-2.202 5.067-4.672 5.088-2.125.024-3.462-.683-5.03-2.712l-2.73-3.886c-.095-.137-.132-.303-.103-.468.03-.164.12-.308.257-.404.282-.197.672-.13.872.156l1.289 1.83c.239.339.707.423 1.045.181.187-.131.287-.334.306-.546.007-.004.012-.02.012-.067V5.032c0-.344.28-.625.625-.625s.625.28.625.625V8.79c0 .414.336.75.75.75s.75-.336.75-.75V3.63c0-.344.28-.624.625-.624s.625.28.625.625v5.03c0 .414.336.75.75.75s.75-.336.75-.75V4.345c0-.345.28-.625.625-.625s.625.28.625.625v2.964l-.284 1.659c-.07.408.205.796.613.865.402.075.795-.204.865-.613l.36-2.105c.057-.339.369-.568.721-.51.34.057.569.381.511.721z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Hd2O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 18c-.489 0-.978-.16-1.386-.48-1.586-1.245-5.202-4.512-6.374-6.43-.933-1.525-1.253-3.412-.857-5.048.34-1.404 1.162-2.537 2.378-3.278 1.374-.84 3.023-.997 4.302-.413.66.301 1.363.827 1.929 1.42.578-.63 1.273-1.14 1.967-1.43 1.312-.551 2.953-.387 4.28.423 1.216.74 2.038 1.874 2.378 3.278.396 1.636.076 3.523-.857 5.049-1.17 1.913-4.787 5.182-6.374 6.429-.408.32-.897.48-1.386.48"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8Y3kV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.22 12.657c-.13 0-.26-.033-.38-.104l-3.22-1.895c-.23-.135-.37-.38-.37-.646v-5c0-.414.336-.75.75-.75s.75.336.75.75v4.571l2.85 1.677c.358.21.477.67.267 1.027-.14.237-.39.37-.647.37"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 1.25c-2.79 0-5.39 1.367-7.023 3.566L2.732 3.33c-.067-.41-.462-.684-.862-.618-.408.067-.685.453-.618.862l.554 3.363c.06.367.379.628.739.628q.06 0 .122-.01l3.366-.551c.41-.067.686-.453.62-.861-.068-.409-.448-.684-.862-.62L4.106 5.8C5.454 3.92 7.648 2.75 10 2.75c3.998 0 7.25 3.252 7.25 7.25s-3.252 7.25-7.25 7.25c-2.98 0-5.623-1.787-6.731-4.552-.155-.385-.591-.572-.976-.417s-.571.59-.417.975C3.215 16.594 6.403 18.75 10 18.75c4.825 0 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aKAX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.5 7.521c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5.672-1.5 1.5-1.5 1.5.672 1.5 1.5M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h5.09c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H3.25c-.413 0-.75-.337-.75-.75v-1.169l2.97-2.969c.293-.293.767-.293 1.06 0l1.915 1.915c.293.293.768.293 1.06 0s.294-.767 0-1.06L7.592 9.552c-.877-.877-2.305-.877-3.182 0L2.5 11.46V5.25c0-.413.337-.75.75-.75h13.5c.413 0 .75.337.75.75v3.847c0 .414.336.75.75.75s.75-.336.75-.75V5.25C19 4.01 17.99 3 16.75 3"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"f10ml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2 4h4v4H2zM10 12h-.693L6 9V8h4zM10 4h4v4h-4zM14 8h4v4h-4zM14 12.285l-4 1.175V12h4z",
                opacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.5 7.521c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M3.25 4.5h13.5c.414 0 .75.337.75.75v8.21l-1.909-1.908c-.85-.85-2.333-.85-3.182 0l-1.232 1.231c-.097.098-.257.097-.354.001L7.591 9.552c-.85-.85-2.333-.85-3.182 0L2.5 11.46V5.25c0-.413.336-.75.75-.75m0 11c-.414 0-.75-.337-.75-.75v-1.168l2.97-2.97c.282-.283.777-.283 1.06 0l3.233 3.234c.682.68 1.792.682 2.474-.001l1.233-1.233c.282-.283.777-.283 1.06 0l2.701 2.701c-.131.112-.296.187-.481.187z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cq5GK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.022 6H5.978C4.887 6 4 6.848 4 7.89v7.22C4 16.152 4.887 17 5.978 17h11.044C18.113 17 19 16.152 19 15.11V7.89C19 6.848 18.113 6 17.022 6M5.978 7.5h11.044c.26 0 .478.179.478.39v5.734l-1.333-1.346c-.757-.763-2.076-.762-2.831 0l-1.024 1.036h-.11l-2.69-2.716c-.755-.764-2.075-.762-2.83 0L5.5 11.792V7.89c0-.211.219-.39.478-.39m0 8c-.26 0-.478-.179-.478-.39v-1.185l2.247-2.271c.189-.189.51-.19.7 0l2.689 2.715c.596.604 1.642.607 2.242 0l1.024-1.035c.188-.189.511-.19.699 0l2.11 2.132q-.087.033-.189.034z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M1.75 14c-.414 0-.75-.336-.75-.75V4.89C1 3.848 1.866 3 2.932 3H14.75c.414 0 .75.336.75.75s-.336.75-.75.75H2.932c-.239 0-.432.175-.432.39v8.36c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.29,
                cy: 9.75,
                r: 1.1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"41CiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.325 12.47c-.293.293-.293.767 0 1.06.147.147.338.22.53.22s.384-.073.53-.22l3-3c.294-.293.294-.767 0-1.06l-3-3c-.292-.293-.767-.293-1.06 0s-.293.767 0 1.06l1.72 1.72H.895c-.415 0-.75.336-.75.75s.335.75.75.75h9.15z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.75 2.021h-8.5C5.01 2.021 4 3.031 4 4.271V6.24c0 .414.336.75.75.75s.75-.336.75-.75V4.271c0-.413.337-.75.75-.75h8.5c.413 0 .75.337.75.75v11.5c0 .414-.337.75-.75.75H6.453c-.413 0-.75-.336-.75-.75v-2.043c0-.415-.336-.75-.75-.75s-.75.335-.75.75v2.043c0 1.24 1.01 2.25 2.25 2.25h8.297c1.24 0 2.25-1.01 2.25-2.25v-11.5c0-1.24-1.01-2.25-2.25-2.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"keCxj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M5.191 11.326q-.143.001-.284-.056C2.64 10.339 1.253 8.07 1.452 5.628 1.702 2.546 4.408.24 7.495.495c3.081.251 5.384 2.962 5.133 6.043-.033.413-.388.725-.809.687-.412-.034-.72-.396-.686-.808.184-2.258-1.503-4.243-3.76-4.428-2.25-.175-4.242 1.504-4.426 3.76-.146 1.79.87 3.451 2.53 4.134.383.157.566.596.409.978-.12.29-.4.465-.695.465"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.585 18.791c-1.711 0-3.368-.679-4.698-1.223l-.35-.142c-.578-.235-1.053-.416-1.444-.567-1.3-.497-1.892-.724-2.27-1.427-.48-.899-.104-2.116.806-2.604.696-.374 1.257-.266 3.216.314L6.317 8.435c-.164-.306-.369-.688-.427-1.145-.093-.73.265-1.42.934-1.8.68-.387 1.501-.339 2.091.122.366.287.57.664.734.968l1.356 2.518c1.267-.68 3-1.12 4.465-.703 1.115.317 1.952 1.084 2.42 2.22.56 1.355 2.259 5.475-1.712 7.556-.855.448-1.73.62-2.593.62m-7.073-4.673q-.114 0-.174.031c-.188.102-.287.397-.192.574.108.2.442.338 1.484.736.398.152.881.338 1.47.576l.355.145c1.824.747 4.093 1.676 6.026.663s2.24-2.705 1.023-5.655c-.296-.716-.768-1.158-1.445-1.35-1.233-.356-2.894.2-3.898.925-.175.126-.397.173-.607.122-.21-.048-.39-.185-.492-.375L8.329 7.292c-.108-.2-.22-.405-.34-.5-.132-.102-.311-.062-.425.002-.078.044-.207.144-.186.307.023.182.144.407.26.625l3.382 6.295c.143.267.112.593-.08.829-.19.235-.505.333-.794.245l-1.013-.302c-1.455-.436-2.256-.675-2.62-.675"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Mo17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 9.25H6.725l.922-.988c.284-.303.267-.778-.036-1.06-.301-.282-.777-.266-1.06.036l-2.099 2.25c-.27.288-.27.736 0 1.024l2.1 2.25c.147.158.347.238.548.238.183 0 .367-.066.511-.201.303-.283.32-.758.036-1.06l-.922-.989H10z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2M3.5 15.75V4.25c0-.413.337-.75.75-.75H10v5.75h3.275l-.922-.988c-.284-.303-.267-.778.036-1.06.301-.282.776-.266 1.06.036l2.099 2.25c.27.288.27.736 0 1.024l-2.1 2.25c-.147.158-.347.238-.548.238-.183 0-.367-.066-.511-.201-.303-.283-.32-.758-.036-1.06l.922-.989H10v5.75H4.25c-.413 0-.75-.337-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dJeU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625M10.058 11.422c-.653.012-1.304-.172-1.86-.525-.529-.338-.96-.811-1.25-1.366-.305-.582-.462-1.24-.452-1.9-.024-1.274.61-2.473 1.697-3.183 1.099-.698 2.509-.697 3.6-.005.527.342.96.81 1.254 1.359.307.565.465 1.206.457 1.85.01.64-.146 1.3-.452 1.888-.29.557-.723 1.031-1.25 1.371-.527.335-1.127.51-1.744.51M10.01 9.92h.01c.347-.005.68-.087.972-.273.305-.197.56-.475.73-.801.191-.368.289-.78.282-1.192.005-.41-.09-.798-.277-1.14-.176-.33-.434-.608-.744-.809-.597-.379-1.375-.378-1.977.003-.644.42-1.025 1.14-1.01 1.919-.006.436.09.846.281 1.208.17.325.421.6.729.797.295.188.639.288.992.288z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 1.271c-4.825 0-8.75 3.925-8.75 8.75 0 4.341 3.237 8.066 7.53 8.666q.052.006.104.006c.368 0 .69-.271.741-.646.058-.41-.228-.79-.639-.847-1.433-.2-2.72-.826-3.75-1.732.784-.682 1.915-1.203 3.23-1.437.408-.072.68-.462.607-.869-.073-.41-.46-.68-.87-.607-1.59.282-3.007.928-4 1.8-.913-1.218-1.453-2.724-1.453-4.333 0-3.999 3.252-7.25 7.25-7.25 3.603 0 6.69 2.686 7.182 6.249.056.41.438.692.845.64.41-.056.698-.435.64-.846-.593-4.3-4.319-7.544-8.667-7.544"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9i0tj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M2.073 12.668c1.11-1.323 3.243-1.469 5.017-.442l8.566-10.794c.258-.325.73-.377 1.054-.122.325.257.379.73.122 1.053l-.56.707 2.21 1.856c.155.129.25.315.266.516.016.2-.05.4-.183.551l-2.107 2.415c-.148.17-.356.257-.565.257-.171 0-.342-.058-.483-.176l-2.064-1.733-.623.784 2.046 1.716c.317.265.358.74.091 1.057-.148.176-.36.267-.574.267-.17 0-.342-.058-.482-.176L11.79 8.716l-3.526 4.442c.702.736 1.157 1.627 1.254 2.541.091.873-.148 1.7-.675 2.328-.626.745-1.58 1.12-2.61 1.12-1.011 0-2.097-.36-3.02-1.083-1.033-.807-1.694-1.927-1.815-3.07-.09-.873.149-1.7.674-2.326m13.739-5.8 1.12-1.285-1.594-1.338-1.06 1.336zm-12.92 7.969c.076.73.543 1.495 1.246 2.046 1.215.947 2.843 1.031 3.556.18.337-.402.367-.877.332-1.207-.077-.73-.543-1.494-1.247-2.044-.651-.51-1.422-.77-2.106-.77-.591 0-1.12.194-1.45.589-.336.401-.366.878-.331 1.206"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cYlEj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 15H3.25C2.01 15 1 13.99 1 12.75v-6.5C1 5.01 2.01 4 3.25 4h13.5C17.99 4 19 5.01 19 6.25v6.5c0 1.24-1.01 2.25-2.25 2.25M3.25 5.5c-.414 0-.75.337-.75.75v6.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-6.5c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.25 12h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 8,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.333,
                cy: 8,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 11.667,
                cy: 8,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 15,
                cy: 8,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 11,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 15,
                cy: 11,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bZM0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.999 11.65c-.611.3-1.257.523-1.918.663-1.214.255-2.455.262-3.667.067q.057-.28.058-.574c0-1.59-1.293-2.881-2.882-2.881-.734 0-1.398.284-1.907.738-.03-.089-.07-.174-.092-.266C2.05 7.2 3.989 4.665 7.199 3.37c.385-.155.57-.592.415-.976s-.593-.57-.976-.414C2.666 3.582.402 6.78 1.134 9.757c.13.518.35 1 .642 1.444q-.065.293-.067.605c0 1.589 1.293 2.88 2.881 2.88.149 0 .29-.021.433-.043.173.286.368.54.544.764.263.336.512.653.521.908.02.284-.07.558-.255.773s-.444.345-.728.365q-.132.01-.258-.013c-.41-.064-.796.203-.868.61s.203.798.61.869q.216.037.437.037.093 0 .188-.007c.683-.05 1.306-.362 1.753-.88.448-.518.667-1.18.619-1.835-.025-.715-.458-1.266-.84-1.753q-.193-.245-.339-.458c.096-.079.19-.158.276-.249 1.547.32 3.147.335 4.708.007.783-.167 1.546-.43 2.268-.783.371-.183.526-.632.343-1.004-.181-.371-.63-.523-1.003-.344m-9.79.156c0-.762.62-1.381 1.381-1.381.762 0 1.382.619 1.382 1.38q-.002.118-.023.228c-.102-.032-.207-.05-.308-.086-.199-.068-.418-.053-.604.045-.186.1-.322.273-.374.477-.065.255-.083.49-.08.717-.758-.004-1.374-.621-1.374-1.38M16.535 9.414c-.269.33-.62.589-1.014.75-.385.155-.57.593-.414.977.119.29.4.467.696.467q.141 0 .281-.054c.628-.255 1.186-.667 1.614-1.193.261-.321.213-.794-.108-1.055s-.794-.212-1.055.108M18.478 4.7c-.235-.343-.702-.427-1.043-.194-.342.234-.428.701-.194 1.043.227.33.31.744.227 1.135-.085.405.174.803.58.888q.078.018.155.017c.347 0 .658-.242.733-.595.167-.792 0-1.628-.458-2.295M15.938 3.455c.247 0 .488-.121.631-.345.224-.348.123-.812-.225-1.036-.56-.36-1.176-.607-1.828-.734-.4-.081-.8.187-.88.593-.078.407.187.8.594.88.465.09.903.266 1.303.523.125.081.266.12.405.12M9.685 2.693q.054 0 .108-.007c.508-.074 1.027-.122 1.54-.143.414-.017.736-.366.719-.78s-.357-.775-.781-.718c-.564.023-1.133.076-1.692.156-.41.059-.694.44-.635.849.054.374.374.643.741.643"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"afLJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2M3.5 4.25c0-.413.337-.75.75-.75h11.5c.413 0 .75.337.75.75V8h-13zm0 11.5V9.5H8v7H4.25c-.413 0-.75-.337-.75-.75m12.25.75H9.5v-7h7v6.25c0 .413-.337.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jUH8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m19.077 9.533-2.25-2.25c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.061l.97.97H10.75c-.414 0-.75.336-.75.75s.336.75.75.75h5.986l-.97.97c-.292.292-.292.767 0 1.06.147.146.338.22.53.22s.385-.074.531-.22l2.25-2.25c.293-.293.293-.768 0-1.06"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.75 17h-7.5C3.01 17 2 15.99 2 14.75v-9.5C2 4.01 3.01 3 4.25 3h7.5C12.99 3 14 4.01 14 5.25V7c0 .414-.336.75-.75.75s-.75-.336-.75-.75V5.25c0-.413-.337-.75-.75-.75h-7.5c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75h7.5c.413 0 .75-.337.75-.75V13c0-.414.336-.75.75-.75s.75.336.75.75v1.75c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5o3or":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m4.97 13.97-.47.47V5.06l.47.47c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06L4.28 2.72c-.293-.293-.767-.293-1.06 0L1.47 4.47c-.293.293-.293.767 0 1.06s.767.293 1.06 0L3 5.06v9.38l-.47-.47c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l1.75 1.75q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l1.75-1.75c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0M17.25 4.5h-7.5c-.414 0-.75-.336-.75-.75S9.336 3 9.75 3h7.5c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 10.5h-7.5c-.414 0-.75-.336-.75-.75S9.336 9 9.75 9h7.5c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 16.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"avv69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M2.875 17.875c-.191 0-.383-.073-.53-.22-.293-.293-.293-.767 0-1.06L16.366 2.573c.293-.293.768-.293 1.06 0s.294.768 0 1.06L3.407 17.656c-.147.147-.339.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"daMQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 19c-2.068 0-3.75-1.682-3.75-3.75v-4.209c0-2.068 1.682-3.75 3.75-3.75.28 0 .56.031.832.093.403.09.657.492.566.896-.09.405-.49.66-.897.567Q10.253 8.79 10 8.79c-1.24 0-2.25 1.01-2.25 2.25v4.209c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-1.709c0-.414.336-.75.75-.75s.75.336.75.75v1.709c0 2.068-1.682 3.75-3.75 3.75m3.75-9.959V4.883c0-2.068-1.682-3.75-3.75-3.75s-3.75 1.682-3.75 3.75V6.54c0 .414.336.75.75.75s.75-.336.75-.75V4.883c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25V9.04c0 1.24-1.01 2.25-2.25 2.25q-.253 0-.501-.056c-.403-.092-.806.163-.897.567s.163.805.566.896c.273.062.553.093.832.093 2.068 0 3.75-1.682 3.75-3.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4tBiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.25 16.521h-10c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 10.521h-10c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 4.521h-10c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 3.5,
                cy: 3.771,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 3.5,
                cy: 9.771,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 3.5,
                cy: 15.771,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4HQ0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M4.5 18h-2c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25m-1.75-1.5h1.5V15h-1.5zM4.5 15h.01zM5.808 1.602c-.336-.239-.806-.16-1.045.178l-1.48 2.087-.62-.638c-.289-.296-.763-.302-1.06-.015-.297.289-.304.764-.016 1.06L2.835 5.56c.017.016.039.023.056.037.018.016.029.038.049.052.032.023.068.034.102.051q.036.02.072.036c.084.03.171.051.259.051.107 0 .212-.029.31-.074.031-.014.056-.036.084-.054.044-.028.091-.047.13-.084.02-.02.028-.046.046-.068.012-.015.031-.02.042-.036l2.001-2.823c.24-.337.16-.805-.178-1.045M5.808 7.602c-.336-.238-.806-.16-1.045.178l-1.48 2.087-.62-.638c-.289-.295-.763-.303-1.06-.015-.297.289-.304.764-.016 1.06l1.248 1.285c.017.016.039.023.056.037.018.016.029.038.049.052.032.023.068.034.102.051q.036.02.072.036c.084.03.171.051.259.051.107 0 .212-.029.31-.074.031-.014.056-.036.084-.054.044-.028.091-.047.13-.084.02-.02.028-.046.046-.068.012-.015.031-.02.042-.036l2.001-2.823c.24-.337.16-.805-.178-1.045M17.25 16.521H8c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h9.25c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 10.521H8c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h9.25c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 4.521H8c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h9.25c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g4ToF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.25 16.521h-10c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 10.521h-10c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 4.521h-10c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M3.11 5.52V2.895h-.024l-.448.31c-.105.073-.173.097-.29.097-.231 0-.41-.173-.41-.42 0-.172.07-.313.234-.424l.768-.513c.246-.164.46-.187.7-.187.448 0 .712.27.712.694V5.52c0 .372-.249.612-.621.612s-.621-.24-.621-.612M1.705 11.522c0-.228.106-.404.34-.6l1.163-.996c.475-.407.61-.592.61-.844 0-.267-.206-.451-.507-.451-.223 0-.375.102-.534.33-.164.241-.313.329-.55.329-.317 0-.51-.185-.51-.483q-.001-.145.055-.276c.223-.504.818-.817 1.556-.817 1.028 0 1.685.518 1.685 1.286 0 .568-.293.864-.95 1.433l-.77.665v.023h1.342c.31 0 .486.185.486.469 0 .278-.176.469-.486.469h-2.35c-.404 0-.58-.226-.58-.537M1.679 17.306c-.027-.074-.038-.156-.038-.22 0-.308.205-.498.539-.498.231 0 .383.076.507.255.158.231.313.369.682.369.31 0 .533-.188.533-.448 0-.302-.231-.463-.662-.463h-.03c-.29 0-.436-.161-.436-.41 0-.238.147-.408.437-.408h.03c.383 0 .606-.167.606-.44 0-.26-.194-.424-.507-.424-.252 0-.43.103-.55.314-.142.249-.294.34-.563.34-.34 0-.507-.2-.507-.475 0-.082.011-.147.04-.229.15-.407.666-.855 1.574-.855.94 0 1.655.398 1.655 1.151 0 .548-.401.888-.867.982v.023c.645.067 1.043.422 1.043.984 0 .81-.694 1.322-1.825 1.322-.985 0-1.518-.469-1.661-.87"
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2w2X1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 9.99c-1.379 0-2.5-1.12-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5m0-3.5c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.005 18.583H10c-.557-.001-1.071-.248-1.413-.679C6.688 15.514 3.5 10.98 3.5 7.49c0-3.446 2.916-6.25 6.5-6.25s6.5 2.804 6.5 6.25c0 3.55-3.186 8.052-5.084 10.421-.342.427-.856.672-1.411.672M10 2.74c-2.757 0-5 2.131-5 4.75 0 3.148 3.331 7.68 4.763 9.482.08.1.195.111.24.111h.002c.046 0 .161-.01.24-.11C11.675 15.19 15 10.698 15 7.49c0-2.619-2.243-4.75-5-4.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lAvHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.25 12.5c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25c0 .403.204.745.5.974v.776c0 .414.336.75.75.75s.75-.336.75-.75v-.776c.296-.23.5-.571.5-.974"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.75 8H6.5V5.25c0-1.93 1.57-3.5 3.5-3.5.865 0 1.696.318 2.339.896.307.277.783.252 1.058-.057.278-.308.252-.782-.056-1.059C12.423.705 11.236.25 10 .25c-2.757 0-5 2.243-5 5v2.775c-1.122.127-2 1.07-2 2.225v6.5C3 17.99 4.01 19 5.25 19h9.5c1.24 0 2.25-1.01 2.25-2.25v-6.5C17 9.01 15.99 8 14.75 8m.75 8.75c0 .413-.337.75-.75.75h-9.5c-.413 0-.75-.337-.75-.75v-6.5c0-.413.337-.75.75-.75h9.5c.413 0 .75.337.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2DEGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.25 11.5c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25c0 .403.204.745.5.974v.776c0 .414.336.75.75.75s.75-.336.75-.75v-.776c.296-.23.5-.571.5-.974"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 7.025V6.5c0-2.757-2.243-5-5-5s-5 2.243-5 5v.525c-1.122.127-2 1.07-2 2.225v6.5C3 16.99 4.01 18 5.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25v-6.5c0-1.155-.878-2.098-2-2.225M10 3c1.93 0 3.5 1.57 3.5 3.5V7h-7v-.5C6.5 4.57 8.07 3 10 3m5.5 12.75c0 .413-.337.75-.75.75h-9.5c-.413 0-.75-.337-.75-.75v-6.5c0-.413.337-.75.75-.75h9.5c.413 0 .75.337.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8dS63":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.25 12.75h-5.5c-.265 0-.51-.14-.645-.367s-.14-.51-.013-.742l2.75-5.04c.132-.24.385-.39.659-.39s.527.15.658.39l2.75 5.04c.126.232.121.514-.014.742s-.38.367-.645.367m-4.236-1.5h2.972l-1.485-2.724zM5.75 12.75c-.122 0-.245-.03-.36-.092-.363-.198-.497-.654-.298-1.017l1.981-3.63c.199-.363.655-.497 1.018-.298.364.198.497.654.299 1.017l-1.982 3.63c-.136.248-.393.39-.658.39"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-.115 0-.23-.026-.336-.08l-7.73-3.874c-.255-.128-.415-.387-.415-.671v-8.25c0-.284.16-.543.414-.67l7.731-3.876c.211-.105.461-.105.672 0l7.73 3.875c.255.128.415.387.415.671v8.25c0 .284-.16.543-.414.67l-7.731 3.876q-.16.08-.336.079m-6.981-5.088 6.981 3.5 6.981-3.5V6.338L10 2.838l-6.981 3.5z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8diGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.05 7.2c0-.601-.235-1.167-.658-1.59-.849-.85-2.333-.852-3.183 0L9.388 7.43q-.033.034-.06.069-.037.029-.07.062l-7.599 7.598c-.425.425-.659.99-.659 1.591s.234 1.166.66 1.59.99.66 1.59.66 1.166-.234 1.59-.66l9.55-9.549c.425-.425.66-.99.66-1.59M3.78 17.28c-.283.283-.777.283-1.06 0-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l7.2-7.2 1.065 1.055zm9.55-9.55-1.284 1.285-1.066-1.056 1.29-1.29c.283-.282.777-.283 1.06.002.142.14.22.329.22.53s-.078.388-.22.53M18.706 10.832l-1.261-.499-.203-1.342c-.065-.428-.758-.505-.916-.104l-.499 1.262-1.342.202c-.213.032-.379.203-.403.418s.098.418.299.498l1.262.5.202 1.34c.032.213.203.38.418.404s.418-.098.498-.3l.5-1.26 1.34-.203c.215-.033.38-.204.404-.418s-.099-.42-.299-.498M14.336 3.642l1.262.5.202 1.341c.032.213.204.38.418.403.215.025.418-.097.498-.299l.5-1.26 1.341-.204c.214-.032.379-.203.403-.418s-.098-.419-.299-.498l-1.26-.498-.204-1.342c-.065-.428-.758-.505-.916-.105l-.498 1.263-1.342.201c-.213.032-.38.204-.404.418s.098.418.3.498M5.78 4.69l1.023.406.164 1.088c.026.173.166.307.34.327.173.02.339-.08.404-.243l.405-1.023 1.088-.165c.174-.026.308-.165.328-.339s-.08-.34-.243-.404l-1.023-.404-.165-1.09c-.053-.347-.615-.41-.743-.084l-.405 1.024-1.089.164c-.173.026-.308.165-.327.34-.02.173.079.338.242.403"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Ohhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.39 9.813c-.842 0-1.602-.364-2.13-.943-.527.58-1.286.943-2.13.943S10.527 9.45 10 8.87c-.527.58-1.287.943-2.13.943S6.268 9.45 5.74 8.87c-.527.58-1.287.943-2.13.943-1.17 0-2.225-.683-2.627-1.7-.565-1.431.078-2.654.106-2.706l1.448-2.973C2.87 1.583 3.727 1 4.697 1h10.606c.971 0 1.829.584 2.184 1.487l1.41 2.948c.266.463.57 1.507.123 2.673-.393 1.02-1.45 1.705-2.63 1.705m-1.38-2.88c0 .761.62 1.38 1.38 1.38.555 0 1.061-.305 1.23-.744.304-.793-.022-1.385-.025-1.391q-.022-.033-.037-.068l-1.446-3.025c-.15-.374-.459-.585-.81-.585H4.698c-.35 0-.66.21-.789.537L2.423 6.091c-.024.047-.348.703-.045 1.47.178.45.673.752 1.232.752.761 0 1.38-.619 1.38-1.38 0-.413.336-.75.75-.75s.75.337.75.75c0 .761.62 1.38 1.38 1.38s1.38-.619 1.38-1.38c0-.413.336-.75.75-.75s.75.337.75.75c0 .761.62 1.38 1.38 1.38.762 0 1.38-.619 1.38-1.38 0-.413.337-.75.75-.75s.75.337.75.75M16.75 10.75c-.414 0-.75.336-.75.75V13H9.521l-.015.003.003-1.502c0-.414-.335-.75-.75-.751-.414 0-.75.335-.75.749l-.009 5v.001H4.75c-.413 0-.75-.337-.75-.75V11.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4.25C2.5 16.99 3.51 18 4.75 18h10.5c1.24 0 2.25-1.01 2.25-2.25V11.5c0-.414-.336-.75-.75-.75m-1.5 5.75H9.5l.003-2.004q.01.002.018.004H16v1.25c0 .413-.337.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"30CWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M10.675 13.94q.019-.002.039-.003M13.928 10.761q0-.01.002-.021M9.238 6.075q-.014.002-.028.003",
                    opacity: 0.2
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 19.021c-.192 0-.384-.073-.53-.22l-16.5-16.5c-.293-.292-.293-.767 0-1.06s.767-.293 1.06 0l16.5 16.5c.293.293.293.768 0 1.06-.146.147-.338.22-.53.22M18.25 14.768c-.414 0-.75-.336-.75-.75V5.25c0-.413-.336-.75-.75-.75H7.902c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.848C17.99 3 19 4.01 19 5.25v8.768c0 .414-.336.75-.75.75M11.92 17H3.25C2.01 17 1 15.99 1 14.75V6.086c0-.414.336-.75.75-.75s.75.336.75.75v8.664c0 .413.336.75.75.75h8.67c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.994 10.534c-.396 0-.727-.31-.749-.71-.088-1.673-1.417-2.993-3.09-3.07-.414-.019-.734-.37-.715-.783s.373-.732.784-.715c2.447.113 4.39 2.043 4.52 4.488.021.414-.297.767-.71.79z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M17.5 14.018V5.25c0-.413-.336-.75-.75-.75H7.902c-.184 0-.347-.074-.478-.184l2.185 2.15c-.11-.136-.177-.307-.169-.495.02-.414.373-.732.784-.715 2.447.113 4.39 2.043 4.52 4.488.021.414-.297.767-.71.79h-.04c-.15 0-.284-.055-.403-.133l4.047 4.026c-.08-.12-.138-.255-.138-.41M7.208 4.026c.006.051.025.102.068.144l.063.062c-.053-.062-.1-.129-.131-.206",
                    opacity: 0.2
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.684 14.737q-.03 0-.059-.002c-2.32-.181-4.196-2.069-4.363-4.391-.03-.413.281-.773.695-.802.425-.007.772.281.801.694.114 1.59 1.397 2.88 2.983 3.003.413.032.722.394.69.807-.03.392-.36.691-.747.691"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M2.5 6.086v8.664c0 .413.336.75.75.75h8.67c.182 0 .343.073.473.18l-2.114-2.134c.104.14.166.313.152.5-.03.392-.36.691-.747.691q-.03 0-.059-.002c-2.32-.181-4.196-2.069-4.363-4.391-.03-.413.281-.773.695-.802.212-.003.406.067.55.19q0-.002.003-.004L2.284 5.561c.133.135.216.32.216.525M12.557 15.877l.03-.001-.096-.096q.037.045.066.097M2.275 5.552l-.042-.04-.02-.002c.02.016.044.024.062.042",
                    opacity: 0.2
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gOrsQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-9.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v9.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.414 0-.75.337-.75.75v9.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-9.5c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 14.75c-2.62 0-4.75-2.13-4.75-4.75S7.38 5.25 10 5.25s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75m0-8c-1.792 0-3.25 1.458-3.25 3.25s1.458 3.25 3.25 3.25 3.25-1.458 3.25-3.25S11.792 6.75 10 6.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 4.5H3.25c-.414 0-.75.337-.75.75v9.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-9.5c0-.413-.336-.75-.75-.75M10 14.75c-2.62 0-4.75-2.13-4.75-4.75S7.38 5.25 10 5.25s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75",
                opacity: 0.2
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dyurA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M9.03 10.97c-.293-.293-.767-.293-1.06 0L3.5 15.44v-2.433c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4.243c0 .414.336.75.75.75h4.243c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H4.56l4.47-4.47c.292-.293.292-.767 0-1.06M18 2.75v4.243c0 .414-.336.75-.75.75s-.75-.336-.75-.75V4.56l-4.47 4.47c-.146.146-.338.219-.53.219s-.384-.073-.53-.22c-.293-.293-.293-.767 0-1.06l4.47-4.47h-2.433c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.243c.414 0 .75.336.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"nFkMC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.583 15.073c-.116 0-.234-.027-.346-.085-.367-.191-.51-.643-.318-1.011.212-.408.32-.848.32-1.309 0-1.498-1.178-2.733-2.682-2.814-.255-.013-.485-.155-.612-.376-.126-.222-.132-.493-.013-.72.258-.497.39-1.012.39-1.53 0-1.844-1.5-3.344-3.343-3.344-.984 0-1.91.433-2.541 1.188-.266.319-.739.36-1.057.094s-.36-.738-.094-1.057c.918-1.096 2.263-1.725 3.692-1.725 2.67 0 4.843 2.173 4.843 4.845q0 .659-.186 1.298c1.802.53 3.102 2.19 3.102 4.141 0 .695-.169 1.387-.489 2.002-.134.257-.394.403-.666.403M11.95 17H3.717C1.814 17 .266 15.452.266 13.549c0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-.692.186-1.373.537-1.97.208-.358.667-.479 1.026-.267.357.21.476.67.266 1.027-.214.366-.329.785-.329 1.21q.001.5.206.964c.1.223.083.483-.044.692-.126.21-.348.345-.593.36-1.026.067-1.828.917-1.828 1.937 0 1.076.876 1.951 1.952 1.951h8.231c.414 0 .75.336.75.75s-.336.75-.75.75M18.25 19.021c-.192 0-.384-.073-.53-.22l-16.5-16.5c-.293-.292-.293-.767 0-1.06s.767-.293 1.06 0l16.5 16.5c.293.293.293.768 0 1.06-.146.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"VIo5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.715 18.98c-4.963 0-9-4.037-9-9 0-4.956 4.027-8.99 8.98-9.001h.042c2.51.029 4.634.91 5.984 2.481 1.3 1.514 1.803 3.588 1.456 5.996-.629 4.367-4.557 5.485-8.026 5.068-1.361-.196-3.831-1.494-3.565-5.019.124-1.651.741-2.887 1.832-3.674 1.99-1.432 4.794-.748 4.912-.718.352.089.59.418.565.78l-.497 6.979c1.487-.384 2.967-1.353 3.295-3.63.283-1.967-.1-3.628-1.11-4.805-1.069-1.244-2.803-1.94-4.885-1.958-4.128.01-7.483 3.37-7.483 7.5 0 4.137 3.364 7.502 7.5 7.502.414 0 .75.336.75.75s-.336.75-.75.75m.88-12.557c-.728 0-1.614.129-2.304.63-.713.515-1.12 1.378-1.209 2.565-.222 2.937 2.015 3.38 2.27 3.42.341.041.891.084 1.527.054l.471-6.625c-.214-.025-.473-.044-.754-.044"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gbebz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.25 9.5c-.414 0-.75-.336-.75-.75V5c0-1.379-1.122-2.5-2.5-2.5-.806 0-1.568.397-2.038 1.062-.24.34-.707.417-1.045.18-.338-.24-.419-.708-.18-1.046C7.488 1.634 8.708 1 10 1c2.206 0 4 1.794 4 4v3.75c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15.643 12.173q-.164 0-.32-.072c-.375-.178-.534-.625-.357-1 .354-.747.534-1.538.534-2.351v-.684c0-.414.336-.75.75-.75s.75.336.75.75v.684c0 1.037-.229 2.044-.679 2.994-.128.27-.397.429-.678.429M14 17.5h-3.266v-1.668c0-.044-.017-.082-.025-.124q.035-.001.07-.004c.411-.046.707-.416.662-.828-.046-.413-.414-.718-.829-.662q-.3.034-.612.036c-3.033 0-5.5-2.468-5.5-5.5v-.684c0-.414-.336-.75-.75-.75s-.75.336-.75.75v.684c0 3.61 2.746 6.588 6.26 6.96-.008.041-.026.079-.026.122V17.5H6c-.414 0-.75.336-.75.75s.336.75.75.75h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M18.78 17.741l-16.5-16.5c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06l16.5 16.5c.146.147.338.22.53.22s.384-.073.53-.22c.293-.292.293-.767 0-1.06"
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bcho2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 12.75c-2.206 0-4-1.794-4-4V5c0-2.206 1.794-4 4-4s4 1.794 4 4v3.75c0 2.206-1.794 4-4 4M10 2.5C8.622 2.5 7.5 3.621 7.5 5v3.75c0 1.379 1.122 2.5 2.5 2.5s2.5-1.121 2.5-2.5V5c0-1.379-1.122-2.5-2.5-2.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.25 7.316c-.414 0-.75.336-.75.75v.684c0 3.032-2.467 5.5-5.5 5.5s-5.5-2.468-5.5-5.5v-.684c0-.414-.336-.75-.75-.75s-.75.336-.75.75v.684c0 3.606 2.742 6.583 6.25 6.959V17.5H6c-.414 0-.75.336-.75.75s.336.75.75.75h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.25v-1.791C14.258 15.333 17 12.356 17 8.75v-.684c0-.414-.336-.75-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4nP90":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M9 11.75v4.243c0 .414-.336.75-.75.75s-.75-.336-.75-.75V13.56l-4.47 4.47c-.146.146-.338.219-.53.219s-.384-.073-.53-.22c-.293-.293-.293-.767 0-1.06l4.47-4.47H4.006c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H8.25c.414 0 .75.336.75.75M18.03 1.97c-.293-.293-.767-.293-1.06 0L12.5 6.44V4.006c0-.414-.336-.75-.75-.75s-.75.336-.75.75V8.25c0 .414.336.75.75.75h4.243c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H13.56l4.47-4.47c.292-.293.292-.767 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iesR2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.783 9.47-2.25-2.25c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l.97.97H10.75V3.558l.97.97c.146.146.338.22.53.22s.384-.074.53-.22c.293-.294.293-.768 0-1.061l-2.25-2.25c-.293-.293-.767-.293-1.06 0l-2.25 2.25c-.293.293-.293.767 0 1.06s.767.293 1.06 0l.97-.97V9.25H3.558l.97-.97c.292-.293.292-.767 0-1.06s-.768-.293-1.061 0l-2.25 2.25c-.293.293-.293.767 0 1.06l2.25 2.25c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06l-.97-.97H9.25v5.692l-.97-.97c-.293-.292-.767-.292-1.06 0s-.293.768 0 1.061l2.25 2.25c.146.147.338.22.53.22s.384-.073.53-.22l2.25-2.25c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0l-.97.97V10.75h5.692l-.97.97c-.292.293-.292.767 0 1.06.147.147.339.22.53.22s.385-.073.531-.22l2.25-2.25c.293-.293.293-.767 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Yg6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M11.75 16h-8.5C2.01 16 1 14.99 1 13.75v-7.5C1 5.01 2.01 4 3.25 4h8.5C12.99 4 14 5.01 14 6.25v1.046l2.368-1.684q.047-.033.1-.06c.546-.273 1.182-.244 1.702.077.52.322.83.878.83 1.49v5.763c0 .61-.31 1.167-.83 1.489-.52.32-1.156.35-1.703.076q-.052-.025-.099-.06L14 12.705v1.046c0 1.24-1.01 2.25-2.25 2.25M3.25 5.5c-.414 0-.75.336-.75.75v7.5c0 .414.336.75.75.75h8.5c.414 0 .75-.336.75-.75v-2.5c0-.28.157-.538.406-.666s.55-.108.779.055l3.49 2.482c.092.031.167-.001.206-.026.045-.028.119-.092.119-.213V7.118c0-.121-.074-.185-.119-.213-.04-.024-.116-.057-.206-.026l-3.49 2.482c-.229.163-.53.183-.779.056-.25-.13-.406-.386-.406-.667v-2.5c0-.414-.336-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bViLi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.176 1.589c-.523-.428-1.204-.597-1.867-.466l-7 1.4C7.26 2.733 6.5 3.661 6.5 4.73v8.997c-.85-.325-1.95-.291-3.026.188C1.65 14.728.7 16.438 1.31 17.81c.31.692.986 1.181 1.857 1.341q.319.059.656.058c.6 0 1.232-.138 1.83-.404.823-.367 1.505-.942 1.92-1.618.281-.458.426-.942.426-1.408V7.15l8.5-1.7v6.276c-.85-.325-1.95-.291-3.026.188-1.824.814-2.774 2.524-2.163 3.896.31.692.986 1.181 1.857 1.341q.319.059.656.058c.6 0 1.232-.138 1.83-.404.823-.367 1.505-.942 1.92-1.618.281-.458.426-.942.426-1.408V3.33c0-.677-.3-1.311-.824-1.741M5.043 17.435c-.542.24-1.127.328-1.605.24-.22-.04-.614-.155-.757-.477-.226-.508.295-1.42 1.403-1.914.435-.193.856-.277 1.221-.277.57 0 1.004.203 1.142.513q.051.12.053.245c.005.25-.116.493-.205.637-.254.414-.71.791-1.252 1.033M16.5 13.767c.005.247-.116.491-.205.635-.254.414-.71.791-1.252 1.033-.541.24-1.126.329-1.605.24-.22-.04-.614-.155-.757-.477-.226-.508.295-1.42 1.403-1.914.435-.193.856-.277 1.221-.277.57 0 1.004.203 1.142.513q.051.12.053.247m0-9.846L8 5.62v-.892c0-.355.254-.665.603-.735l7-1.4c.22-.044.448.01.622.155.175.144.275.355.275.581z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7DDOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m10.546 11.004-3.857-9c-.236-.55-1.142-.55-1.378 0l-3.857 9c-.163.38.013.822.394.985.379.161.82-.012.985-.393L3.945 9h4.11l1.112 2.596c.123.284.4.454.69.454q.15 0 .295-.06c.381-.164.557-.605.394-.986M4.588 7.5 6 4.204 7.412 7.5zM17.25 18h-5.5c-.275 0-.527-.15-.659-.392s-.12-.535.03-.765L15.87 9.5H11.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.5c.275 0 .527.15.659.392s.12.535-.03.765L13.13 16.5h4.121c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9ljtw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25m-1.5 0c0-.414-.336-.75-.75-.75H4.25c-.414 0-.75.336-.75.75v11.5c0 .414.336.75.75.75h11.5c.414 0 .75-.336.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.763 10c0 .421-.342.763-.763.763h-2.237V13c0 .421-.342.763-.763.763s-.763-.342-.763-.763v-2.237H7c-.421 0-.763-.342-.763-.763s.342-.763.763-.763h2.237V7c0-.421.342-.763.763-.763s.763.342.763.763v2.237H13c.421 0 .763.342.763.763"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hznZm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M11.784 13H8.216C7.545 13 7 12.455 7 11.784V8.216C7 7.545 7.545 7 8.216 7h3.568C12.455 7 13 7.545 13 8.216v3.568c0 .671-.545 1.216-1.216 1.216M8.5 11.5h3v-3h-3zM4 13c-.192 0-.384-.073-.53-.22l-2.25-2.25c-.293-.293-.293-.767 0-1.06l2.25-2.25c.293-.293.767-.293 1.06 0s.293.767 0 1.06L2.81 10l1.72 1.72c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22M12.25 4.75c-.192 0-.384-.073-.53-.22L10 2.81 8.28 4.53c-.293.293-.767.293-1.06 0s-.293-.767 0-1.06l2.25-2.25c.293-.293.767-.293 1.06 0l2.25 2.25c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22M16 13c-.192 0-.384-.073-.53-.22-.293-.293-.293-.767 0-1.06L17.19 10l-1.72-1.72c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0l2.25 2.25c.293.293.293.767 0 1.06l-2.25 2.25c-.146.147-.338.22-.53.22M10 19c-.192 0-.384-.073-.53-.22l-2.25-2.25c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0L10 17.19l1.72-1.72c.293-.293.767-.293 1.06 0s.293.767 0 1.06l-2.25 2.25c-.146.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iUGVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m5.494 15.564-2 1.75c-.283.249-.705.249-.988 0l-2-1.75c-.312-.272-.343-.747-.07-1.058.274-.312.747-.341 1.058-.07l.756.661V2.75c0-.414.336-.75.75-.75s.75.336.75.75v12.347l.756-.661c.142-.124.318-.186.494-.186.208 0 .416.087.564.256.273.311.242.786-.07 1.058"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.095 11.793c-.059-.041-.13-.04-.189-.001l-3.803 2.626c-.093.064-.103.17-.103.213s.01.148.103.213l3.803 2.626c.06.04.127.04.188 0l3.803-2.626c.093-.065.103-.17.103-.213s-.01-.149-.103-.213z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m17.749 13.184-3.804-2.626c-.287-.198-.616-.297-.945-.297s-.657.098-.944.296h-.001L8.25 13.185c-.47.324-.751.865-.751 1.447s.28 1.123.751 1.447l3.804 2.626c.574.397 1.316.397 1.89 0l3.804-2.626c.47-.324.751-.865.751-1.447s-.28-1.123-.751-1.447m-.852 1.66-3.803 2.626c-.06.04-.127.04-.188 0l-3.803-2.626C9.01 14.779 9 14.674 9 14.63s.01-.149.103-.213l3.803-2.626c.059-.04.13-.04.189.001l3.802 2.625c.093.064.103.17.103.213s-.01.148-.103.213"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 5.648c-.328 0-.656.098-.943.294L8.253 8.544c-.427.292-.697.759-.742 1.28-.046.531.143 1.045.518 1.41.3.29.774.282 1.06-.013.29-.297.284-.773-.013-1.06-.052-.052-.078-.129-.071-.208.004-.05.024-.122.095-.17l3.804-2.602c.059-.041.133-.041.192 0l3.803 2.601c.072.05.092.12.096.171.007.08-.02.156-.071.207-.297.288-.303.764-.014 1.06.288.296.763.304 1.06.014.376-.365.565-.879.52-1.41-.046-.521-.316-.988-.744-1.28l-3.803-2.602c-.287-.196-.615-.294-.943-.294"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 .999c-.328 0-.656.098-.941.292L8.253 3.894c-.427.292-.697.757-.742 1.279-.047.531.142 1.046.518 1.412.297.288.772.283 1.06-.014.29-.296.284-.771-.013-1.06-.052-.051-.078-.128-.071-.208.004-.051.024-.123.095-.171l3.804-2.602c.059-.04.131-.042.194.001l3.801 2.6c.072.049.092.121.096.172.007.08-.02.157-.071.208-.297.289-.303.764-.014 1.06.29.297.765.302 1.06.014.377-.366.566-.88.52-1.412-.046-.522-.316-.987-.744-1.28l-3.803-2.601c-.287-.195-.615-.293-.943-.293"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"frBLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m13.148 15.452 4.205-2.901c.132-.092.147-.241.147-.301s-.015-.209-.147-.3l-4.206-2.902c-.091-.065-.203-.065-.294 0l-4.206 2.901c-.132.092-.147.241-.147.301s.015.209.147.3l4.206 2.902q.069.048.147.048c.078 0 .102-.016.148-.048",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m5.494 13.564-2 1.75c-.283.249-.705.249-.988 0l-2-1.75c-.312-.272-.343-.747-.07-1.058.274-.312.747-.341 1.058-.07l.756.661V5.25c0-.414.336-.75.75-.75s.75.336.75.75v7.847l.756-.661c.142-.124.318-.186.494-.186.208 0 .416.087.564.256.273.311.242.786-.07 1.058M14 7.813l4.204 2.902c.498.344.796.917.796 1.535s-.298 1.191-.796 1.535l-4.203 2.902c-.607.42-1.394.42-2.001 0l-4.204-2.902C7.298 13.441 7 12.868 7 12.25s.298-1.191.796-1.535L12 7.813c.304-.21.652-.315 1-.315.349 0 .696.106 1 .315m-.852 7.64 4.205-2.902c.132-.092.147-.241.147-.301s-.015-.209-.147-.3l-4.206-2.902c-.091-.065-.203-.065-.294 0l-4.206 2.901c-.132.092-.147.241-.147.301s.015.209.147.3l4.206 2.902q.069.048.147.048c.078 0 .102-.016.148-.048"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.916 9.25c-.195 0-.39-.076-.537-.227-.29-.296-.283-.771.014-1.06.073-.071.11-.18.102-.291-.006-.06-.03-.174-.14-.25L13.15 4.549c-.091-.065-.208-.065-.301 0L8.646 7.423c-.11.075-.135.188-.141.249-.009.11.03.22.102.29.297.29.303.765.014 1.061-.287.296-.762.305-1.06.014-.398-.387-.6-.932-.55-1.494.048-.553.334-1.048.787-1.358l4.204-2.875c.607-.414 1.39-.414 1.995 0l4.205 2.875c.453.31.74.805.787 1.358.05.562-.152 1.107-.55 1.494-.146.143-.334.213-.523.213"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8HJNV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 4.5c-.05 0-.102.016-.147.048L8.647 7.449c-.132.092-.147.241-.147.301s.015.209.147.3l4.206 2.902c.091.065.203.065.294 0l4.206-2.901c.132-.092.147-.241.147-.301s-.015-.209-.147-.3l-4.205-2.902Q13.078 4.5 13 4.5",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m5.494 6.436-2-1.75c-.283-.248-.705-.248-.988 0l-2 1.75c-.312.272-.343.747-.07 1.058.274.312.747.341 1.058.07l.756-.661v7.847c0 .414.336.75.75.75s.75-.336.75-.75V6.903l.756.661c.142.124.318.186.494.186.208 0 .416-.087.564-.256.273-.311.242-.786-.07-1.058M13 12.502c-.348 0-.696-.106-1-.315L7.796 9.285C7.298 8.941 7 8.368 7 7.75s.298-1.191.796-1.535L12 3.313c.607-.42 1.394-.42 2.001 0l4.203 2.902c.498.344.796.917.796 1.535s-.298 1.191-.796 1.535L14 12.187c-.304.21-.651.315-1 .315M13 4.5c-.05 0-.102.016-.147.048L8.647 7.449c-.132.092-.147.241-.147.301s.015.209.147.3l4.206 2.902c.091.065.203.065.294 0l4.206-2.901c.132-.092.147-.241.147-.301s-.015-.209-.147-.3l-4.205-2.902Q13.078 4.5 13 4.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 17.001c-.348 0-.694-.104-.997-.31l-4.205-2.876c-.453-.31-.74-.805-.787-1.358-.05-.562.152-1.107.55-1.494.298-.29.773-.281 1.06.014.29.296.283.771-.014 1.06-.073.071-.11.18-.102.291.006.06.03.174.14.25l4.205 2.874c.091.065.208.065.301 0l4.203-2.875c.11-.075.135-.188.141-.249.009-.11-.03-.22-.102-.29-.297-.29-.303-.765-.014-1.061.288-.295.763-.303 1.06-.014.398.387.6.932.55 1.494-.048.553-.334 1.048-.787 1.358l-4.204 2.875c-.304.207-.65.311-.998.311"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1Ke9z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m5.494 4.436-2-1.75c-.283-.248-.705-.248-.988 0l-2 1.75c-.312.272-.343.747-.07 1.058.274.312.747.341 1.058.07l.756-.661V17.25c0 .414.336.75.75.75s.75-.336.75-.75V4.903l.756.661c.142.124.318.186.494.186.208 0 .416-.087.564-.256.273-.311.242-.786-.07-1.058"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.094 2.53c-.06-.04-.127-.04-.188 0L9.103 5.156C9.01 5.221 9 5.326 9 5.37s.01.149.103.213l3.803 2.626c.059.04.13.04.189-.001l3.802-2.625c.093-.064.103-.17.103-.213s-.01-.148-.103-.213z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m17.749 3.922-3.804-2.626c-.574-.397-1.316-.397-1.89 0L8.25 3.922c-.47.324-.751.865-.751 1.447s.28 1.123.751 1.447l3.804 2.626v.001c.288.198.616.296.945.296s.658-.1.945-.297l3.804-2.626c.47-.324.751-.865.751-1.447s-.28-1.123-.751-1.447m-.852 1.66-3.802 2.625c-.059.041-.13.04-.189.001L9.103 5.582C9.01 5.518 9 5.412 9 5.369s.01-.148.103-.213l3.803-2.626c.06-.04.127-.04.188 0l3.803 2.626c.093.065.103.17.103.213s-.01.149-.103.213"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 14.352c-.328 0-.656-.098-.943-.294l-3.804-2.602c-.427-.292-.697-.759-.742-1.28-.046-.531.143-1.045.518-1.41.3-.29.774-.282 1.06.013.29.297.284.773-.013 1.06-.052.052-.078.129-.071.208.004.05.024.122.095.17l3.804 2.602c.059.041.133.041.192 0l3.803-2.601c.072-.05.092-.12.096-.171.007-.08-.02-.156-.071-.207-.297-.288-.303-.764-.014-1.06.288-.296.763-.304 1.06-.014.376.365.565.879.52 1.41-.046.521-.316.988-.744 1.28l-3.803 2.602c-.287.196-.615.294-.943.294"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 19.001c-.328 0-.656-.098-.941-.292l-3.806-2.603c-.427-.292-.697-.757-.742-1.279-.047-.531.142-1.046.518-1.412.297-.288.772-.283 1.06.014.29.296.284.771-.013 1.06-.052.051-.078.128-.071.208.004.051.024.123.095.171l3.804 2.602c.059.04.131.042.194-.001l3.801-2.6c.072-.049.092-.121.096-.172.007-.08-.02-.157-.071-.208-.297-.289-.303-.764-.014-1.06.29-.297.765-.302 1.06-.014.377.366.566.88.52 1.412-.046.522-.316.987-.744 1.28l-3.803 2.601c-.287.195-.615.293-.943.293"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmIZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 12.502c-.348 0-.696-.106-1-.315L7.796 9.285C7.298 8.941 7 8.368 7 7.75s.298-1.191.796-1.535L12 3.313c.607-.42 1.394-.42 2.001 0l4.203 2.902c.498.344.796.917.796 1.535s-.298 1.191-.796 1.535L14 12.187c-.304.21-.651.315-1 .315M13 4.5c-.05 0-.102.016-.147.048L8.647 7.449c-.132.092-.147.241-.147.301s.015.209.147.3l4.206 2.902c.091.065.203.065.294 0l4.206-2.901c.132-.092.147-.241.147-.301s-.015-.209-.147-.3l-4.205-2.902Q13.078 4.5 13 4.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 17.001c-.348 0-.694-.104-.997-.31l-4.205-2.876c-.453-.31-.74-.805-.787-1.358-.05-.562.152-1.107.55-1.494.298-.29.773-.281 1.06.014.29.296.283.771-.014 1.06-.073.071-.11.18-.102.291.006.06.03.174.14.25l4.205 2.874c.091.065.208.065.301 0l4.203-2.875c.11-.075.135-.188.141-.249.009-.11-.03-.22-.102-.29-.297-.29-.303-.765-.014-1.061s.764-.303 1.06-.014c.398.387.6.932.55 1.494-.048.553-.334 1.048-.787 1.358l-4.204 2.875c-.304.207-.65.311-.998.311M4.506 12.436l-.756.661V6.903l.756.661c.142.124.318.186.494.186.208 0 .416-.087.564-.256.273-.311.242-.786-.07-1.058l-2-1.75c-.283-.249-.705-.249-.988 0l-2 1.75c-.312.272-.343.747-.07 1.058s.748.341 1.058.07l.756-.661v6.194l-.756-.661c-.31-.272-.785-.242-1.058.07-.273.311-.242.786.07 1.058l2 1.75c.037.033.081.05.123.074.032.018.06.042.095.056q.134.054.276.056c.142.002.187-.02.276-.056.035-.014.063-.038.095-.056.042-.024.086-.04.123-.074l2-1.75c.312-.272.343-.747.07-1.058-.274-.312-.747-.342-1.058-.07"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9fLd8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 11.064c-1.513 0-2.744-1.233-2.744-2.75S8.487 5.564 10 5.564s2.744 1.234 2.744 2.75-1.231 2.75-2.744 2.75m0-4c-.686 0-1.244.561-1.244 1.25s.558 1.25 1.244 1.25 1.244-.56 1.244-1.25-.558-1.25-1.244-1.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M7.413 15.5c.077-.794.313-1.583.902-1.925 1.084.422 2.292.423 3.373 0 .57.35.79 1.188.871 1.925zm10.087-.75c0 .413-.337.75-.75.75h-2.694c-.205-2.304-1.242-3.163-2.126-3.457-.186-.062-.385-.05-.56.035-.87.416-1.862.417-2.735.003-.175-.082-.371-.095-.557-.034-1.262.416-2.016 1.632-2.167 3.453H3.25c-.413 0-.75-.337-.75-.75v-9.5c0-.413.337-.75.75-.75h13.5c.413 0 .75.337.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3lC1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 10.064c-1.513 0-2.744-1.233-2.744-2.75S8.487 4.564 10 4.564s2.744 1.234 2.744 2.75-1.231 2.75-2.744 2.75m0-4c-.686 0-1.244.561-1.244 1.25s.558 1.25 1.244 1.25 1.244-.56 1.244-1.25-.558-1.25-1.244-1.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.75 1h-9.5C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25V3.25C17 2.01 15.99 1 14.75 1M8.314 12.575c1.086.423 2.293.42 3.374 0 1.048.644.971 2.966.837 3.925H7.481c-.06-.392-.435-3.191.833-3.925M15.5 15.75c0 .413-.337.75-.75.75h-.713c.125-1.146.303-4.658-2.107-5.457-.187-.062-.387-.049-.56.035-.87.416-1.862.417-2.735.003-.175-.082-.372-.095-.557-.034-2.511.828-2.254 4.369-2.112 5.453H5.25c-.413 0-.75-.337-.75-.75V3.25c0-.413.337-.75.75-.75h9.5c.413 0 .75.337.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fSpZi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16 3.375c-.583 0-1.116.197-1.552.52-1.34-.826-2.755-1.362-4.142-1.513-1.326-.145-2.568.072-3.679.575-.449-.359-1.01-.582-1.627-.582-1.447 0-2.625 1.178-2.625 2.625 0 .655.25 1.247.647 1.707-1.078 2.466-.79 5.345.803 7.825-.284.42-.45.925-.45 1.468 0 1.447 1.178 2.625 2.625 2.625S8.625 17.447 8.625 16 7.447 13.375 6 13.375c-.36 0-.702.073-1.014.205-1.215-1.955-1.462-4.144-.693-6.064.226.064.46.109.707.109 1.447 0 2.625-1.178 2.625-2.625 0-.28-.056-.544-.137-.797.804-.312 1.692-.434 2.655-.33 1.128.123 2.288.558 3.401 1.226-.104.282-.169.583-.169.901 0 1.447 1.178 2.625 2.625 2.625S18.625 7.447 18.625 6 17.447 3.375 16 3.375M7.375 16c0 .758-.617 1.375-1.375 1.375S4.625 16.758 4.625 16 5.242 14.625 6 14.625s1.375.617 1.375 1.375M5 6.375c-.758 0-1.375-.617-1.375-1.375S4.242 3.625 5 3.625 6.375 4.242 6.375 5 5.758 6.375 5 6.375m11 1c-.758 0-1.375-.617-1.375-1.375S15.242 4.625 16 4.625s1.375.617 1.375 1.375S16.758 7.375 16 7.375"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"djbJ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.945 14.42c-.293.292-.768.292-1.061 0l-2.121-2.122c-.293-.293-.293-.768 0-1.06s.767-.293 1.06 0l2.122 2.12c.292.294.292.769 0 1.061M15.127 9.116l-2.122 2.121c-.293.293-.768.293-1.06 0s-.293-.767 0-1.06l2.12-2.122c.294-.292.769-.292 1.062 0s.292.768 0 1.061M11.237 8.763c-.292.292-.767.292-1.06 0L8.055 6.64c-.292-.293-.292-.768 0-1.06s.768-.293 1.061 0l2.121 2.12c.293.294.293.769 0 1.062M8.055 9.823l-2.12 2.122c-.294.292-.769.292-1.062 0s-.292-.768 0-1.061l2.122-2.121c.293-.293.768-.293 1.06 0s.293.767 0 1.06"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2m0 14.5h-1.643l.312-.313c.293-.292.293-.768 0-1.06-.292-.293-.767-.293-1.06 0L11.985 16.5H7.743l1.02-1.02c.292-.293.292-.768 0-1.06-.293-.294-.768-.294-1.061 0l-2.08 2.08H4.25c-.414 0-.75-.337-.75-.75v-.936l.313.312c.292.293.768.293 1.06 0 .293-.292.293-.767 0-1.06L3.5 12.692V7.036l1.02 1.02c.293.292.768.292 1.06 0s.293-.768 0-1.061L3.5 4.915V4.25c0-.413.336-.75.75-.75h1.643l-.312.313c-.293.292-.293.768 0 1.06.292.293.767.293 1.06 0L8.015 3.5h4.242l-1.02 1.02c-.292.293-.292.768 0 1.06.293.293.768.293 1.061 0l2.08-2.08h1.372c.414 0 .75.337.75.75v.936l-.313-.312c-.292-.293-.768-.293-1.06 0-.293.292-.293.767 0 1.06L16.5 7.308v5.656l-1.02-1.02c-.293-.292-.768-.292-1.06 0s-.293.768 0 1.061l2.08 2.08v.665c0 .413-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5WDcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.75 13.5c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75s.75.336.75.75v5.5c0 .414-.336.75-.75.75M8.25 13.5c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75s.75.336.75.75v5.5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fqvG6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.75 18h-2.5C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v11.5C9 16.99 7.99 18 6.75 18M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75zM15.75 18h-2.5C12.01 18 11 16.99 11 15.75V4.25C11 3.01 12.01 2 13.25 2h2.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-14.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.75 18h-2.5C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v11.5C9 16.99 7.99 18 6.75 18M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75zM15.75 18h-2.5C12.01 18 11 16.99 11 15.75V4.25C11 3.01 12.01 2 13.25 2h2.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-14.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eJEX2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.24 3.717 11.283 1.76c-.679-.679-1.784-.677-2.463 0L7.498 3.083c-.018.018-.025.042-.041.062L4.488 4.764c-.432.237-.767.622-.943 1.083l-2.192 5.762c-.22.578-.08 1.234.357 1.67.302.302.702.461 1.111.461.198 0 .397-.037.587-.113l6.114-2.459c.471-.188.855-.544 1.08-.996l1.365-2.728c.008-.007.018-.009.025-.016l1.25-1.25c.677-.678.677-1.783-.002-2.461M9.26 9.502c-.062.125-.167.222-.297.273l-4.715 1.897 2.228-2.229c.42-.039.753-.381.753-.812 0-.456-.37-.826-.826-.826-.43 0-.773.333-.812.753l-2.377 2.377L4.947 6.38c.05-.128.142-.234.261-.3L7.922 4.6l2.526 2.527zm2.92-4.383-.809.809-2.298-2.299.807-.808c.097-.096.25-.093.343 0l1.957 1.956c.093.094.093.248 0 .342M18.081 6.651c-.434-.363-.977-.537-1.549-.485-.564.05-1.076.317-1.448.764-.056.07-3.114 3.837-4.365 5.34-.243.018-.49.055-.736.124-1.567.434-2.12 1.743-2.609 2.896-.363.856-.705 1.665-1.419 2.052-.286.154-.44.476-.38.797.06.319.319.564.642.606.707.09 1.493.157 2.287.157 1.66 0 3.351-.289 4.42-1.242.736-.657 1.101-1.539 1.087-2.623 0-.027-.01-.052-.01-.078.96-1.155 3.035-3.707 3.933-4.81l.415-.51c.363-.435.536-.985.485-1.55s-.317-1.075-.753-1.438m-6.156 9.89c-.7.622-2.09.918-3.922.852.315-.488.54-1.019.752-1.518.472-1.113.803-1.807 1.629-2.036.6-.166 1.182-.08 1.603.234.327.246.519.605.524.986.009.637-.183 1.123-.586 1.482m5.28-7.871c-.01.01-.173.21-.435.533-.751.923-2.331 2.864-3.387 4.15-.145-.176-.308-.339-.496-.48-.152-.113-.32-.197-.488-.28 1.44-1.748 3.835-4.7 3.845-4.713.107-.127.256-.205.422-.22.154-.017.325.036.454.142.127.106.205.256.22.422.014.165-.035.326-.136.446"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ctMXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.018 13.271c-1.98 0-3.59-1.69-3.59-3.767s1.61-3.768 3.59-3.768 3.59 1.69 3.59 3.768-1.61 3.767-3.59 3.767m0-6.035c-1.153 0-2.09 1.018-2.09 2.268s.937 2.267 2.09 2.267 2.09-1.017 2.09-2.267-.938-2.268-2.09-2.268M7.871 18.973q-.041 0-.082-.004c-.411-.045-.709-.415-.665-.827.26-2.406 2.794-4.22 5.894-4.22 3.076 0 5.665 1.857 5.893 4.228.04.413-.262.78-.674.819-.408.047-.779-.262-.818-.674-.153-1.584-2.128-2.873-4.401-2.873-2.294 0-4.227 1.265-4.402 2.882-.042.384-.367.669-.745.669M3.833 16.339q-.04 0-.081-.004c-.412-.045-.71-.415-.666-.826.23-2.137 2.283-3.85 4.992-4.168.404-.046.783.247.832.658s-.246.783-.658.832c-1.977.231-3.522 1.425-3.674 2.838-.042.385-.367.67-.745.67M.82 13.443q-.04.001-.08-.004c-.413-.044-.71-.415-.667-.826.214-1.98 2.11-3.565 4.61-3.858.403-.047.783.247.832.658.047.411-.246.784-.659.832-1.771.207-3.155 1.27-3.29 2.528-.043.385-.368.67-.746.67M7.565 9.648c-.207 0-.413-.085-.56-.252-.584-.658-.926-1.514-.963-2.412-.087-2.075 1.452-3.83 3.43-3.913.45-.021.89.05 1.314.202.39.14.591.57.45.96s-.568.59-.96.45c-.238-.084-.49-.12-.743-.114-1.15.05-2.045 1.104-1.993 2.353.023.554.232 1.079.586 1.478.275.31.247.785-.063 1.059-.142.127-.32.19-.498.19M3.951 7.254c-.191 0-.383-.072-.528-.218-.871-.865-1.21-2.314-.823-3.525.547-1.719 2.288-2.75 3.96-2.347.402.098.65.503.553.905-.097.404-.507.648-.905.554-.916-.22-1.868.371-2.179 1.344-.212.663-.013 1.544.45 2.005.294.292.296.767.004 1.06-.146.148-.34.222-.532.222"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2bVJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2M3.5 4.25c0-.414.337-.75.75-.75h11.5c.413 0 .75.336.75.75v11.5c0 .02-.01.037-.011.056-1.53-1.886-3.99-3.056-6.491-3.056-2.588 0-5.114 1.196-6.488 3.05-.001-.018-.01-.032-.01-.05zM15.11 16.5H4.872C6 15.128 7.965 14.25 9.998 14.25c1.944 0 3.851.856 5.111 2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.06 11.708c-.02 0-.064.002-.058 0-.592 0-1.168-.168-1.667-.486-.491-.314-.892-.752-1.16-1.267-.281-.537-.427-1.144-.418-1.756-.023-1.178.565-2.288 1.572-2.947 1.022-.648 2.328-.648 3.342-.005.49.318.89.753 1.162 1.26.283.52.43 1.112.424 1.71.01.592-.135 1.203-.42 1.747-.268.515-.668.954-1.158 1.27-.489.311-1.046.474-1.62.474m-.043-1.5h.01c.286.017.59-.076.842-.236.269-.173.49-.416.639-.701.169-.325.255-.687.249-1.05.004-.363-.08-.702-.243-1.002-.156-.288-.38-.532-.654-.71-.517-.329-1.195-.33-1.718.004-.564.368-.898 1-.885 1.682-.005.387.08.746.248 1.065.148.285.368.526.637.698.257.164.537.22.866.25z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5XxZU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M2.5 18.25c-.192 0-.384-.073-.53-.22-.293-.293-.293-.767 0-1.06l15-15c.293-.293.767-.293 1.06 0s.293.767 0 1.06l-15 15c-.146.147-.338.22-.53.22M5.25 8.5C3.458 8.5 2 7.042 2 5.25S3.458 2 5.25 2 8.5 3.458 8.5 5.25 7.042 8.5 5.25 8.5m0-5c-.965 0-1.75.785-1.75 1.75S4.285 7 5.25 7 7 6.215 7 5.25 6.215 3.5 5.25 3.5M14.75 18c-1.792 0-3.25-1.458-3.25-3.25s1.458-3.25 3.25-3.25S18 12.958 18 14.75 16.542 18 14.75 18m0-5c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75S15.715 13 14.75 13"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"buuiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.38 6.566 13.436 2.62c-.363-.363-.846-.562-1.36-.562s-1 .2-1.361.563c-.425.424-.621 1-.557 1.565L6.992 7.35l-2.311-.199c-.748-.086-1.438.31-1.76.986-.322.677-.188 1.459.344 1.99L6.038 12.9 2.22 16.72c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L7.1 13.962l2.774 2.774c.339.34.78.517 1.231.517.255 0 .513-.057.758-.173.677-.322 1.064-1.013.987-1.746l-.2-2.326 3.165-3.166c.568.067 1.141-.13 1.565-.554.363-.363.563-.846.564-1.36s-.199-.998-.562-1.362m-1.062 1.662c-.127.126-.288.159-.437.095-.281-.124-.61-.06-.827.158l-3.713 3.713c-.156.157-.237.374-.217.595l.231 2.688c.016.144-.067.214-.138.249s-.18.052-.283-.05L4.325 9.067c-.103-.103-.085-.212-.05-.284.032-.065.093-.14.224-.14l.04.003 2.672.229c.222.02.437-.06.595-.217l3.712-3.712c.216-.217.28-.545.158-.827-.066-.153-.031-.307.098-.437.08-.08.187-.124.301-.124s.22.044.299.123l3.946 3.946c.165.165.164.435-.002.6"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bKDWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.787 11.404 14 9.901V5.424c.445-.354.715-.9.715-1.498C14.715 2.864 13.852 2 12.79 2H7.21c-1.06 0-1.923.864-1.923 1.926 0 .598.269 1.144.713 1.497V9.9l-1.775 1.495c-.582.472-.797 1.234-.547 1.94.25.707.897 1.164 1.65 1.164H9.25v2.75c0 .414.336.75.75.75s.75-.336.75-.75V14.5h3.924c.752 0 1.4-.457 1.65-1.164s.034-1.468-.537-1.932m-.878 1.431c-.026.075-.089.165-.235.165H5.327c-.146 0-.209-.09-.235-.165s-.035-.183.089-.283l2.052-1.729c.17-.141.267-.351.267-.573V5c0-.307-.187-.583-.473-.696-.154-.063-.24-.197-.24-.378 0-.235.19-.426.423-.426h5.581c.233 0 .424.191.424.426 0 .18-.086.315-.242.378-.286.113-.473.39-.473.696v5.25c0 .222.098.432.267.574l2.064 1.738c.113.09.105.198.078.273"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2qWTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M4.749 18.004c-.398 0-.795-.108-1.153-.321C2.91 17.273 2.5 16.55 2.5 15.75V4.249c0-.799.41-1.521 1.096-1.932.685-.409 1.515-.43 2.219-.05L16.516 8.02C17.246 8.41 17.7 9.17 17.7 10s-.453 1.589-1.184 1.981L5.815 17.732c-.336.182-.702.272-1.066.272m.003-14.508c-.178 0-.318.068-.387.11-.11.065-.365.26-.365.643v11.502c0 .384.255.578.365.644s.402.198.74.017l10.7-5.75c.357-.193.395-.527.395-.662s-.038-.469-.394-.661L5.105 3.588c-.126-.067-.246-.092-.353-.092"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"769FV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 13.951,
                cy: 14.539,
                r: 1.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.16 19.661c-.231 0-.465-.057-.677-.179l-.493-.28c-.617-.352-.864-1.133-.564-1.776l.3-.647q-.181-.26-.32-.548l-.712-.055c-.707-.055-1.263-.655-1.267-1.364l-.003-.568c-.004-.722.535-1.313 1.254-1.377l.71-.062q.067-.144.145-.283.079-.136.17-.27l-.307-.643c-.307-.64-.067-1.421.547-1.78l.49-.287c.612-.355 1.412-.18 1.819.398l.411.585q.318-.028.634-.003l.404-.588c.402-.584 1.197-.769 1.816-.416l.493.28c.617.352.864 1.133.564 1.776l-.3.647q.181.26.32.548l.712.055c.707.055 1.263.655 1.267 1.364l.003.568c.004.722-.535 1.313-1.254 1.377l-.71.062q-.067.144-.145.283h-.001q-.078.137-.17.27l.308.643c.307.64.067 1.422-.547 1.78l-.49.287c-.611.357-1.412.183-1.819-.398l-.411-.585q-.318.028-.634.003l-.404.588c-.264.384-.698.595-1.14.595m-.034-9.056q-.033 0-.062.017l-.49.287c-.056.032-.078.103-.05.16l.472.99c.106.222.071.486-.088.673q-.16.189-.29.41-.124.223-.205.46c-.082.23-.29.392-.534.414l-1.09.096c-.066.006-.115.06-.115.126l.003.568c0 .065.05.119.115.124l1.092.086c.245.02.456.18.539.412q.171.474.504.861c.16.186.197.45.094.672l-.462.993c-.028.059-.005.13.05.161l.494.281c.057.033.128.014.165-.037l.62-.903c.14-.203.385-.303.627-.262.33.06.668.059.997-.004.242-.046.489.054.63.254l.629.897c.037.054.11.07.165.037l.49-.287c.056-.032.078-.103.05-.16l-.472-.99c-.106-.222-.071-.486.088-.673q.16-.189.29-.41.124-.224.205-.46c.082-.23.29-.392.534-.414l1.09-.096c.066-.006.115-.06.115-.126l-.003-.568c0-.065-.05-.119-.115-.124l-1.092-.086c-.245-.02-.456-.18-.539-.412q-.171-.474-.504-.861c-.16-.186-.197-.45-.093-.672l.461-.993c.028-.059.005-.13-.05-.161l-.494-.281c-.06-.033-.13-.015-.165.037l-.62.903c-.14.203-.384.309-.627.262-.33-.06-.668-.06-.997.004-.238.048-.488-.054-.63-.254l-.628-.897c-.025-.035-.064-.054-.104-.054m4.798 5.563h.01z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.876 4H16v-.751c0-.965-.785-1.75-1.75-1.75h-1.5c-.965 0-1.75.785-1.75 1.75V4H9v-.751c0-.965-.785-1.75-1.75-1.75h-1.5c-.965 0-1.75.785-1.75 1.75V4h-.876C1.954 4 1 4.953 1 6.124v8.752C1 16.046 1.953 17 3.124 17H7c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H3.124c-.344 0-.624-.28-.624-.624V6.124c0-.344.28-.624.624-.624h13.752c.344 0 .624.28.624.624v1.752c0 .414.336.75.75.75s.75-.336.75-.75V6.124C19 4.954 18.047 4 16.876 4M12.5 3.249c0-.138.112-.25.25-.25h1.5c.138 0 .25.112.25.25V4h-2zm-7 0c0-.138.112-.25.25-.25h1.5c.138 0 .25.112.25.25V4h-2z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kP2hr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 4H16v-.751c0-.965-.785-1.75-1.75-1.75h-1.5c-.965 0-1.75.785-1.75 1.75V4H9v-.751c0-.965-.785-1.75-1.75-1.75h-1.5c-.965 0-1.75.785-1.75 1.75V4h-.75C2.01 4 1 5.01 1 6.25v8.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-8.5C19 5.01 17.99 4 16.75 4m-4.25-.751c0-.138.112-.25.25-.25h1.5c.138 0 .25.112.25.25V4h-2zm-7 0c0-.138.112-.25.25-.25h1.5c.138 0 .25.112.25.25V4h-2zm12 11.501c0 .413-.336.75-.75.75H3.25c-.414 0-.75-.337-.75-.75v-8.5c0-.413.336-.75.75-.75h13.5c.414 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fmBad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.949 18H3.05c-.813 0-1.542-.42-1.948-1.125-.407-.705-.407-1.546 0-2.25L8.052 2.59C8.459 1.886 9.187 1.465 10 1.465s1.542.42 1.948 1.125l6.949 12.035c.407.704.407 1.545 0 2.25-.406.704-1.135 1.125-1.948 1.125M10 2.965c-.13 0-.454.036-.65.375L2.403 15.375c-.195.339-.066.638 0 .75.065.112.258.375.65.375h13.897c.39 0 .584-.263.65-.375.065-.112.194-.411 0-.75L10.648 3.34C10.454 3 10.13 2.965 10 2.965"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9k4qh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.994 18H6.006c-.978 0-1.838-.625-2.14-1.555L1.398 8.849c-.302-.93.026-1.941.818-2.516l6.461-4.695c.791-.575 1.854-.575 2.645 0l6.463 4.695c.791.575 1.12 1.586.817 2.516l-2.468 7.596c-.302.93-1.162 1.555-2.14 1.555M10 2.708c-.155 0-.31.048-.441.144L3.097 7.547c-.264.191-.373.528-.272.838l2.468 7.596c.1.311.387.519.713.519h7.988c.326 0 .612-.208.713-.518l2.468-7.597c.101-.31-.008-.647-.272-.838l-6.462-4.695c-.132-.096-.286-.144-.441-.144"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8FQgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.32 18H6.68c-.801 0-1.548-.432-1.948-1.125l-3.32-5.75c-.4-.693-.4-1.557 0-2.25l3.32-5.75C5.132 2.432 5.879 2 6.68 2h6.64c.801 0 1.548.432 1.948 1.125l3.32 5.75c.4.693.4 1.557 0 2.25l-3.32 5.75c-.4.693-1.147 1.125-1.948 1.125M6.68 3.5c-.267 0-.515.144-.649.375l-3.32 5.75c-.134.231-.134.519 0 .75l3.32 5.75c.134.231.382.375.65.375h6.639c.267 0 .515-.144.649-.375l3.32-5.75c.134-.231.134-.519 0-.75l-3.32-5.75c-.134-.231-.382-.375-.65-.375z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7ujFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m19.28 18.222-1.973-1.974c.436-.64.693-1.414.693-2.246 0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c.833 0 1.605-.257 2.246-.693l1.974 1.973c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06m-7.78-4.22c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5-2.5-1.121-2.5-2.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m16.34 5.28-3.62-3.62c-.418-.42-.998-.66-1.591-.66H5.25C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18H9c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H5.25c-.413 0-.75-.337-.75-.75V3.25c0-.413.337-.75.75-.75H10v3.25C10 6.99 11.01 8 12.25 8h3.25v.5c0 .414.336.75.75.75s.75-.336.75-.75V6.871c0-.592-.24-1.172-.66-1.59m-4.84.47V2.614c.055.032.113.06.158.106l3.622 3.62c.046.046.074.105.106.16H12.25c-.413 0-.75-.337-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4AoeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 5H16v-.75C16 3.01 14.99 2 13.75 2h-7.5C5.01 2 4 3.01 4 4.25V5h-.75C2.01 5 1 6.01 1 7.25v5.5C1 13.99 2.01 15 3.25 15H4v.75C4 16.99 5.01 18 6.25 18h7.5c1.24 0 2.25-1.01 2.25-2.25V15h.75c1.24 0 2.25-1.01 2.25-2.25v-5.5C19 6.01 17.99 5 16.75 5M5.5 4.25c0-.413.337-.75.75-.75h7.5c.413 0 .75.337.75.75V5h-9zm9 11.5c0 .413-.337.75-.75.75h-7.5c-.413 0-.75-.337-.75-.75v-3.5c0-.413.337-.75.75-.75h7.5c.413 0 .75.337.75.75zm3-3c0 .413-.337.75-.75.75H16v-1.25c0-1.24-1.01-2.25-2.25-2.25h-7.5C5.01 10 4 11.01 4 12.25v1.25h-.75c-.413 0-.75-.337-.75-.75v-5.5c0-.413.337-.75.75-.75h13.5c.413 0 .75.337.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.5 15h-5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fF9ir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 11H4.995l5.718-6.634c.782-.908.73-2.24-.118-2.97l-.323-.277c-.42-.364-.97-.523-1.54-.451-.543.069-1.045.343-1.414.771L1.44 8.259c-.782.908-.729 2.24.118 2.97l.323.278c.183.158.39.276.613.355-.304.383-.493.862-.493 1.388v3C2 17.767 3.233 19 4.75 19h10.5c1.517 0 2.75-1.233 2.75-2.75v-3c0-1.24-1.01-2.25-2.25-2.25M2.575 9.24l5.88-6.822c.126-.147.292-.24.466-.262q.03-.005.073-.005c.087 0 .202.02.3.104l.322.277c.217.187.2.578-.038.854l-5.88 6.821c-.127.147-.293.24-.467.263-.08.011-.243.012-.372-.099l-.322-.278c-.217-.187-.2-.578.038-.854M16.5 16.25c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-3c0-.414.336-.75.75-.75h11.5c.414 0 .75.336.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.5 15.5h-3c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3c.414 0 .75.336.75.75s-.336.75-.75.75M18.28 2.72c-.293-.293-.767-.293-1.06 0L13.5 6.44V5.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3c0 .414.336.75.75.75h3c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.19l3.72-3.72c.293-.293.293-.767 0-1.06"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aDb3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 8,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.5 9.875c-.758 0-1.375-.617-1.375-1.375s.617-1.375 1.375-1.375 1.375.617 1.375 1.375-.617 1.375-1.375 1.375m0-1.75c-.207 0-.375.168-.375.375s.168.375.375.375.375-.168.375-.375-.168-.375-.375-.375"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m10.595 1.396-.323-.277c-.42-.364-.97-.523-1.54-.451-.543.069-1.045.343-1.414.771L1.44 8.259c-.782.908-.729 2.24.118 2.97l.323.278c.183.158.39.276.613.355-.304.383-.493.862-.493 1.388v3C2 17.767 3.234 19 4.75 19h4.725c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H4.75c-.69 0-1.25-.56-1.25-1.25v-3c0-.414.336-.75.75-.75h5.13c.414 0 .75-.336.75-.75S9.794 11 9.38 11H4.995l5.718-6.634c.782-.908.73-2.24-.118-2.97m-1.017 1.99-5.88 6.821c-.127.147-.293.24-.467.263-.08.01-.243.012-.372-.099l-.322-.278c-.217-.187-.2-.578.038-.854l5.88-6.82c.126-.148.292-.241.466-.263q.03-.005.073-.005c.087 0 .202.02.3.104l.322.277c.217.187.2.578-.038.854"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.525 15.5c-.414 0-.762-.336-.762-.75S8.086 14 8.5 14h.025c.414 0 .75.336.75.75s-.336.75-.75.75M14.627 5.947c-.104 0-.207-.026-.3-.077-.145-.08-.253-.214-.3-.373l-.756-2.592c-.097-.332.094-.679.425-.776l2.592-.756c.333-.097.678.094.775.425l.756 2.592c.097.331-.093.678-.424.775l-2.592.757q-.087.024-.176.025m.019-2.793.406 1.392 1.392-.406-.406-1.392zM15 10.521c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875v1.875c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875v-1.875c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lkt5b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 8,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.5 9.875c-.758 0-1.375-.617-1.375-1.375s.617-1.375 1.375-1.375 1.375.617 1.375 1.375-.617 1.375-1.375 1.375m0-1.75c-.207 0-.375.168-.375.375s.168.375.375.375.375-.168.375-.375-.168-.375-.375-.375"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 11H4.995l5.718-6.634c.782-.908.73-2.24-.118-2.97l-.323-.277c-.42-.364-.97-.524-1.54-.451-.543.069-1.045.343-1.414.771L1.44 8.259c-.782.908-.729 2.24.118 2.97l.323.278c.183.158.39.276.613.355-.304.383-.493.862-.493 1.388v3C2 17.767 3.233 19 4.75 19h10.5c1.517 0 2.75-1.233 2.75-2.75v-3c0-1.24-1.01-2.25-2.25-2.25M2.575 9.24l5.88-6.822c.126-.147.292-.24.466-.262q.03-.005.073-.005c.087 0 .202.02.3.104l.322.277c.217.187.2.578-.038.854l-5.88 6.821c-.127.147-.293.24-.467.263-.08.01-.243.011-.372-.099l-.322-.278c-.217-.187-.2-.578.038-.854M16.5 16.25c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-3c0-.414.336-.75.75-.75h11.5c.414 0 .75.336.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.5 15.5h-3c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3c.414 0 .75.336.75.75s-.336.75-.75.75M14.627 5.947c-.104 0-.207-.026-.3-.077-.145-.08-.253-.214-.3-.373l-.756-2.592c-.097-.332.094-.679.425-.776l2.592-.756c.333-.096.678.094.775.425l.756 2.592c.097.331-.093.678-.424.775l-2.592.757q-.087.024-.176.025m.019-2.793.406 1.392 1.392-.406-.406-1.392z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5OfyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.014 2.389c-.618-.418-1.397-.504-2.09-.229-2.96 1.178-5.211 1.853-6.174 1.853H5c-2.206 0-4 1.793-4 3.997s1.794 3.996 4 3.996h.163l2.26 5.452c.4.96 1.332 1.542 2.312 1.542.319 0 .642-.062.954-.19.617-.256 1.097-.736 1.353-1.352s.256-1.296 0-1.915l-1.422-3.426c1.165.235 3.018.838 5.313 1.74.265.104.544.155.82.155.445 0 .886-.132 1.264-.39.616-.419.983-1.114.983-1.86V4.252c0-.747-.37-1.443-.986-1.862M2.5 8.009c0-1.376 1.121-2.496 2.5-2.496h4v4.993H5c-1.379 0-2.5-1.12-2.5-2.496m8.157 8.874c-.102.246-.295.438-.542.54-.508.212-1.094-.03-1.306-.54l-2.023-4.877H8.95l1.706 4.113c.102.246.102.518 0 .764m6.843-5.12c0 .252-.12.478-.327.62-.208.14-.461.168-.692.077-2.705-1.063-4.702-1.689-5.981-1.883V5.443c1.294-.192 3.29-.82 5.979-1.888.233-.093.486-.066.692.075.209.141.329.368.329.621z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cmRpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.725 1h-.668c-1.276 0-2.447.817-2.797 2H14c-2.619 0-4.75 2.13-4.75 4.75v4.5c0 1.792-1.458 3.25-3.25 3.25h-.265c-.328-1.152-1.378-2-2.635-2h-.825c-.152 0-.275.123-.275.275v4.95c0 .152.123.275.275.275h.668c1.277 0 2.448-.817 2.797-2H6c2.62 0 4.75-2.13 4.75-4.75v-4.5c0-1.792 1.458-3.25 3.25-3.25h.265c.328 1.152 1.378 2 2.635 2h.825c.152 0 .275-.123.275-.275v-4.95c0-.152-.123-.275-.275-.275"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8EeNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.21 5.825c.243.244.243.64 0 .885-.122.122-.282.183-.442.183s-.32-.061-.443-.183L15 15.885l-1.325 1.325c-.122.122-.282.183-.443.183s-.32-.061-.442-.183c-.243-.244-.243-.64 0-.885L14.115 15l-1.325-1.325c-.243-.244-.243-.64 0-.885.244-.244.64-.244.885 0L15 14.115l1.325-1.325c.244-.244.64-.244.885 0 .243.244.243.64 0 .885L15.885 15z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.78 1.219c-.213-.211-.527-.276-.805-.166l-16.5 6.509c-.27.105-.454.358-.473.647s.129.563.382.704l6.255 3.495.43.758c.137.244.391.38.653.38.125 0 .252-.03.368-.097.361-.204.487-.66.283-1.021l-.252-.446 7.129-7.168L14.929 8.2c-.15.386.042.82.428.97s.82-.042.97-.429l2.621-6.719c.109-.277.042-.593-.169-.803M8.055 10.923 3.497 8.376 15.17 3.771z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kuJHJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.78 1.219c-.213-.211-.528-.276-.805-.166l-16.5 6.509c-.27.105-.454.358-.473.647s.129.563.382.704l6.255 3.495 3.521 6.212c.134.235.384.38.652.38l.054-.002c.29-.02.54-.206.645-.476l6.437-16.5c.109-.277.042-.593-.169-.803M15.17 3.77l-7.114 7.152-4.559-2.547zm-3.482 12.737L9.12 11.98l7.129-7.167z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i8pOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 4,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4PoT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-9.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v9.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.414 0-.75.336-.75.75v9.5c0 .414.336.75.75.75h13.5c.414 0 .75-.336.75-.75v-9.5c0-.414-.336-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5YrhY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.743 5h8.449l-1.72-1.72c-.293-.293-.293-.767 0-1.06s.768-.293 1.06 0l2.998 2.997c.293.293.293.767 0 1.06L15.534 9.28c-.146.147-.338.22-.53.22s-.384-.073-.53-.22c-.294-.292-.294-.767-.001-1.06l1.717-1.72H7.743c-2.482 0-4.5 2.019-4.5 4.5s2.018 4.5 4.5 4.5h3.737c.415 0 .75.336.75.75s-.335.75-.75.75H7.743c-3.309 0-6-2.691-6-6s2.691-6 6-6"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gwFGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.207 3.897c-.406-.094-.809.15-.906.554l-.38 1.575C15.523 3.594 12.919 2.02 10 2.02c-3.685 0-6.875 2.5-7.76 6.08-.099.403.147.81.55.909.4.1.808-.147.907-.55.718-2.907 3.31-4.939 6.303-4.939 2.517 0 4.735 1.447 5.809 3.633l-2.102-.508c-.404-.094-.808.15-.906.553s.15.808.553.905l3.245.785c.125.088.274.142.432.142q.09 0 .18-.021c.048-.012.086-.041.13-.061.069-.019.142-.02.205-.058.17-.104.29-.27.338-.464l.875-3.624c.097-.403-.15-.808-.552-.906M17.21 11.032c-.396-.096-.807.147-.907.55-.718 2.908-3.31 4.94-6.303 4.94-2.517 0-4.735-1.447-5.81-3.634l2.103.508c.403.092.809-.15.906-.553s-.15-.808-.553-.905l-3.255-.787c-.171-.118-.385-.171-.602-.119-.015.004-.026.015-.04.02-.104.013-.205.044-.295.1-.17.103-.29.27-.338.463l-.875 3.624c-.097.403.15.808.552.906q.09.02.177.02c.339 0 .646-.23.729-.574l.38-1.575c1.398 2.432 4.002 4.005 6.921 4.005 3.685 0 6.876-2.5 7.76-6.08.099-.403-.147-.81-.549-.909"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bahY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.783 15.708 8.737 3.78c-.235-.554-1.146-.554-1.382 0L2.31 15.708c-.161.38.017.821.399.982q.144.06.292.06c.292 0 .57-.172.69-.458L5.508 12h5.079l1.815 4.292c.162.38.602.562.983.398.382-.16.56-.601.4-.982M6.141 10.5l1.905-4.503L9.951 10.5zM16.25 18.75c-.414 0-.75-.336-.75-.75V2c0-.414.336-.75.75-.75s.75.336.75.75v16c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aPbth":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M6.75 9h-2.5C3.01 9 2 7.99 2 6.75v-2.5C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v2.5C9 7.99 7.99 9 6.75 9m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM17.28 5.722c-.293-.293-.767-.293-1.06 0l-.483.483c-.07-2.19-1.864-3.953-4.07-3.953-.414 0-.75.336-.75.75s.336.75.75.75c1.37 0 2.482 1.075 2.567 2.423l-.454-.453c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l1.75 1.75q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l1.75-1.75c.293-.293.293-.767 0-1.06M15.75 18h-2.5C12.01 18 11 16.99 11 15.75v-2.5c0-1.24 1.01-2.25 2.25-2.25h2.5c1.24 0 2.25 1.01 2.25 2.25v2.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM8.333 16.252c-1.37 0-2.482-1.075-2.567-2.423l.454.453c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06l-1.75-1.75q-.105-.105-.243-.162c-.184-.076-.39-.076-.574 0q-.138.058-.243.162l-1.75 1.75c-.293.293-.293.767 0 1.06s.767.293 1.06 0l.483-.483c.07 2.19 1.864 3.953 4.07 3.953.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2HSQI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 13.945c-.224.008-.441-.071-.607-.22-.32-.354-.32-.892 0-1.245.164-.153.382-.235.606-.227.23-.01.451.077.613.24.157.162.24.38.233.606.012.228-.067.45-.22.619-.168.16-.395.242-.626.227"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 19c-.564 0-1.079-.26-1.412-.717L6.698 16H4.144c-.289 0-.57-.057-.834-.168q-.384-.163-.682-.46c-.298-.297-.352-.427-.459-.682q-.167-.398-.168-.833V4.143q0-.435.168-.833.162-.385.46-.682c.297-.297.426-.352.68-.46q.4-.167.835-.168h11.714c.289 0 .57.057.834.168q.384.163.682.46c.298.297.352.427.459.682q.167.398.168.833v9.714q0 .435-.168.833-.162.385-.46.682c-.297.297-.426.352-.68.46q-.4.167-.835.168H13.3l-1.915 2.318c-.306.421-.821.682-1.385.682M4.143 3.5q-.132 0-.25.05-.115.05-.205.138-.09.09-.137.204-.051.12-.051.25v9.715q0 .13.05.251.049.114.138.204.091.089.205.137.118.051.25.051h2.675c.397 0 .774.191 1.009.513l1.944 2.35c.185.248.3.213.43.035l2-2.42c.207-.287.584-.478.981-.478h2.675q.132 0 .25-.05.115-.05.205-.138.09-.09.137-.204.051-.12.051-.25V4.142q0-.13-.05-.251-.049-.114-.138-.204-.091-.089-.205-.137-.118-.051-.25-.051zm2.5 12.433.007.008zm6.741-.036-.018.023q.01-.01.018-.023"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 10.835c-.414 0-.75-.336-.75-.75V5.25c0-.414.336-.75.75-.75s.75.336.75.75v4.835c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Zjfa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2H11c.414 0 .75.336.75.75s-.336.75-.75.75H4.25c-.413 0-.75.337-.75.75v11.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75V9c0-.414.336-.75.75-.75s.75.336.75.75v6.75c0 1.24-1.01 2.25-2.25 2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.25 2H14c-.414 0-.75.336-.75.75s.336.75.75.75h1.44l-4.47 4.47c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22l4.47-4.47V6c0 .414.336.75.75.75S18 6.414 18 6V2.75c0-.414-.336-.75-.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12.25,
                cy: 15.25,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12.25,
                cy: 13,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12.25,
                cy: 10.75,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.75,
                cy: 7.75,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 7,
                cy: 7.75,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9.25,
                cy: 7.75,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hOe3F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18 15.5H3c-.414 0-.75-.336-.75-.75S2.586 14 3 14h15c.414 0 .75.336.75.75s-.336.75-.75.75M11 3.25c-3.777 0-6.926 2.816-7.609 6.528l-.858-1.44c-.212-.356-.673-.47-1.029-.26-.355.213-.472.673-.26 1.029l1.796 3.012c.104.173.273.298.47.345q.087.02.174.02c.141 0 .28-.04.402-.116l2.92-1.853c.349-.222.452-.685.23-1.035-.221-.35-.685-.453-1.034-.231l-1.344.852C5.392 7.061 7.94 4.75 11 4.75c3.446 0 6.25 2.931 6.25 6.534 0 .414.336.75.75.75s.75-.336.75-.75c0-4.43-3.477-8.034-7.75-8.034"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b1qtW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.125,
                cy: 6,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17H7c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H3.25c-.414 0-.75-.337-.75-.75V9H11c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H2.5V5.25c0-.413.336-.75.75-.75h13.5c.414 0 .75.337.75.75v.979c0 .414.336.75.75.75s.75-.336.75-.75V5.25C19 4.01 17.99 3 16.75 3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.2 18.25c-.922 0-1.788-.36-2.44-1.01-.651-.652-1.01-1.518-1.01-2.44s.359-1.788 1.01-2.44l.11-.109c.294-.292.768-.292 1.062.002.292.294.29.768-.003 1.06l-.109.109c-.367.367-.57.857-.57 1.378s.203 1.01.571 1.379c.737.736 2.02.735 2.758 0l.111-.11c.294-.293.77-.29 1.061.003.291.295.29.77-.005 1.06l-.11.11c-.648.649-1.514 1.008-2.436 1.008M17.6 13.968c-.192 0-.385-.073-.532-.22-.292-.295-.29-.77.003-1.061l.109-.109c.367-.367.57-.857.57-1.378s-.203-1.01-.571-1.379c-.738-.737-2.022-.736-2.758 0l-.111.11c-.294.294-.77.29-1.061-.003-.291-.295-.29-.77.005-1.06l.11-.11c1.297-1.298 3.572-1.3 4.875.003.652.651 1.011 1.517 1.011 2.44 0 .92-.359 1.787-1.01 2.439l-.11.109c-.147.146-.338.219-.53.219"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.8 14.95c-.192 0-.384-.073-.53-.22-.293-.293-.293-.767 0-1.06l2.4-2.4c.293-.293.767-.293 1.06 0s.293.767 0 1.06l-2.4 2.4c-.146.147-.338.22-.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"adRGe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m16.345 16.38-1.928-4.456c1.132-1.132 1.833-2.694 1.833-4.418 0-3.446-2.804-6.25-6.25-6.25S3.75 4.06 3.75 7.506c0 1.724.701 3.286 1.833 4.418l-1.928 4.455c-.103.24-.075.514.073.727s.391.327.657.32l1.858-.103L7.44 18.75c.143.17.354.267.574.267q.058 0 .115-.009c.26-.04.479-.213.579-.456L10 15.41l1.292 3.142c.1.243.32.416.579.456q.058.01.115.01c.22 0 .43-.098.574-.268l1.197-1.426 1.858.103c.267.008.509-.107.657-.32s.176-.488.073-.727M5.25 7.505c0-2.619 2.13-4.75 4.75-4.75s4.75 2.131 4.75 4.75-2.13 4.75-4.75 4.75-4.75-2.13-4.75-4.75m2.542 9.329-.642-.764c-.152-.18-.38-.277-.616-.266l-1.02.056 1.294-2.99c.687.41 1.457.69 2.28.811zm5.674-1.03c-.243-.012-.464.086-.616.266l-.641.764-1.297-3.153c.823-.121 1.593-.402 2.28-.812l1.294 2.991z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eZF8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.179 18.822c-.193 0-.384-.073-.53-.22-.294-.292-.294-.768 0-1.06l.938-.938c.293-.293.768-.291 1.06 0 .293.293.293.769 0 1.061l-.938.938c-.146.146-.339.22-.53.22M1.918 14.603c-.192 0-.384-.074-.53-.22-.293-.293-.293-.769 0-1.06l.938-.938c.294-.294.769-.292 1.06 0 .294.293.294.768 0 1.06l-.938.938c-.146.146-.339.22-.53.22M2.498 18.252c-.191 0-.383-.072-.53-.218-.292-.293-.294-.767-.002-1.061l2.496-2.51c.294-.292.767-.295 1.061-.003.293.293.295.768.003 1.061l-2.496 2.51c-.147.147-.34.221-.532.221M18.18 1.662c-.637-.585-1.576-.788-2.782-.611-2.324.344-4.172 1.61-5.656 3.02C9.37 4.028 8.995 4 8.65 4c-2.987.03-5.756 1.648-7.409 4.333-.305.496-.32 1.118-.035 1.621.282.5.792.796 1.36.796h2.803c.087.512.329.997.712 1.38l1.79 1.79c.387.388.872.624 1.38.711v2.782c-.005.581.292 1.098.796 1.382.241.136.51.204.78.204.29 0 .583-.08.842-.24 2.684-1.652 4.303-4.421 4.332-7.408.003-.362-.026-.732-.072-1.102.071-.075.154-.15.222-.225 1.552-1.68 2.461-3.406 2.78-5.277.231-1.36-.029-2.426-.75-3.085M5.79 8.84c-.077.111-.14.225-.198.344l-.003.005c-.01.02-.015.041-.024.061H2.624c-.08 0-.13-.09-.09-.157 1.282-2.089 3.487-3.455 5.824-3.57-.106.122-.218.246-.32.366-.72.851-1.476 1.843-2.248 2.95m5.118 8.622c-.068.042-.158-.01-.158-.088v-2.936c.141-.064.28-.137.411-.229 1.286-.896 2.372-1.748 3.317-2.58-.117 2.342-1.465 4.53-3.57 5.833M17.45 4.495c-.268 1.576-1.054 3.052-2.402 4.512-1.16 1.255-2.711 2.554-4.745 3.972-.43.3-1.006.248-1.373-.12l-1.79-1.79c-.32-.32-.402-.811-.203-1.224q.036-.078.083-.149c.745-1.067 1.472-2.022 2.162-2.839 1.612-1.905 3.636-3.909 6.434-4.322.51-.076 1.192-.096 1.55.234.435.397.364 1.252.284 1.726"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.5 6.75c0 .69-.56 1.25-1.25 1.25S12 7.44 12 6.75s.56-1.25 1.25-1.25 1.25.56 1.25 1.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hsD8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M1.73 3.729c.392-.12.814.1.937.497l.53 1.73C4.636 3.626 7.195 2.13 10 2.13c4.411 0 8 3.59 8 8s-3.589 8-8 8c-2.662 0-5.142-1.318-6.633-3.527-.232-.343-.142-.81.201-1.041.344-.231.81-.14 1.042.202C5.822 15.559 7.837 16.63 10 16.63c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5c-2.2 0-4.212 1.135-5.4 2.915l1.547-.475c.393-.119.816.1.937.497.122.396-.1.815-.496.937l-3.38 1.038q-.11.033-.22.033c-.321 0-.618-.207-.717-.53L1.233 4.666c-.122-.396.1-.815.496-.937"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dEIAf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.27 3.729c-.392-.12-.814.1-.936.497l-.532 1.73C15.365 3.626 12.806 2.13 10 2.13c-4.411 0-8 3.59-8 8s3.589 8 8 8c2.662 0 5.142-1.318 6.633-3.527.232-.343.142-.81-.201-1.041-.344-.231-.81-.14-1.042.202-1.212 1.795-3.227 2.866-5.39 2.866-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5c2.2 0 4.212 1.135 5.4 2.915l-1.547-.475c-.393-.119-.816.1-.937.497-.122.396.1.815.496.937l3.38 1.038q.11.033.22.033c.321 0 .618-.207.717-.53l1.038-3.379c.122-.396-.1-.815-.496-.937"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eMDaf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.75 18h-7.5C2.01 18 1 16.99 1 15.75v-7.5C1 7.01 2.01 6 3.25 6h7.5C11.99 6 13 7.01 13 8.25v7.5c0 1.24-1.01 2.25-2.25 2.25M3.25 7.5c-.414 0-.75.336-.75.75v7.5c0 .414.336.75.75.75h7.5c.414 0 .75-.336.75-.75v-7.5c0-.414-.336-.75-.75-.75zm15.28.091c-.293-.293-.767-.293-1.06 0l-.47.47V6.75C17 4.13 14.87 2 12.25 2h-2c-.414 0-.75.336-.75.75s.336.75.75.75h2c1.792 0 3.25 1.458 3.25 3.25v1.311l-.47-.47c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06l1.75 1.75c.146.147.338.22.53.22s.384-.073.53-.22l1.75-1.75c.293-.292.293-.767 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3MX7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.09 4.026 15.975 1.91c-.85-.85-2.334-.85-3.182 0L1.91 12.798c-.877.877-.878 2.305 0 3.182l2.117 2.118c.425.424.99.659 1.591.659s1.166-.235 1.591-.66L18.092 7.209c.876-.878.876-2.305-.001-3.182m-1.06 2.121L6.149 17.037c-.283.283-.778.283-1.06 0L2.97 14.92c-.293-.293-.293-.769 0-1.062l1.01-1.01 1.764 1.764c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06L5.04 11.787l1.541-1.541 1.058 1.058c.147.146.339.22.53.22s.384-.074.53-.22c.294-.293.294-.768 0-1.06l-1.058-1.06 1.54-1.54 1.767 1.766c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06l-1.766-1.767 1.54-1.541 1.06 1.06c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.061l-1.06-1.06 1.01-1.011c.142-.142.33-.22.53-.22.201 0 .39.078.531.22l2.117 2.117c.293.292.293.768 0 1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"JOv4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.451 13.313c-.423-.41-.959-.504-1.373-.577-.336-.057-.37-.09-.516-.226-.086-.08-.188-.208-.188-.364s.102-.284.188-.363l1.204-1.119c1.047-.97 1.625-2.27 1.625-3.66s-.578-2.689-1.626-3.66c-1.45-1.336-3.437-2.073-5.594-2.073-2.488 0-4.979.986-6.83 2.704-1.762 1.63-2.732 3.813-2.732 6.144s.97 4.514 2.732 6.145c1.727 1.597 4.067 2.489 6.662 2.507 2.46 0 4.806-.869 6.43-2.382.403-.371.629-.9.637-1.49.008-.607-.222-1.2-.618-1.586m-1.04 1.978c-1.35 1.259-3.322 1.98-5.397 1.98q-.402-.002-.794-.039c-.236-.02-.469-.054-.7-.093q-.03-.003-.063-.008c-1.577-.275-2.996-.95-4.097-1.968-1.451-1.344-2.25-3.135-2.25-5.044s.799-3.7 2.251-5.045c1.174-1.089 2.647-1.83 4.195-2.14h.003q.361-.07.727-.11.04-.006.079-.011.402-.041.806-.042c1.372 0 2.646.362 3.697 1.018.312.195.61.41.878.656.738.684 1.145 1.592 1.145 2.559 0 .835-.32 1.617-.878 2.26-.089.1-.168.208-.268.301l-1.2 1.115c-.432.398-.671.919-.671 1.466 0 .344.105.675.284.976.103.173.224.339.38.484.185.173.354.294.543.388.206.1.435.168.74.22.231.04.494.086.584.173.03.03.057.086.084.141.046.095.083.209.081.349-.001.124-.03.295-.159.414"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.17 4.271c-1.091 0-2.185.274-3.17.775V15.1c.908.416 1.927.664 3.024.671.331 0 .656-.029.976-.072V4.34c-.271-.036-.545-.068-.83-.068",
                opacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8 5.046c-.586.298-1.133.677-1.619 1.128C5.238 7.232 4.61 8.633 4.61 10.119s.629 2.887 1.77 3.944c.467.431 1.024.763 1.621 1.037z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJeQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.5 5.521H9.25c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M10.5 16.021H9.25c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M15.25 7.021c-.414 0-.75-.335-.75-.75 0-.413-.337-.75-.75-.75-.414 0-.75-.335-.75-.75s.336-.75.75-.75c1.24 0 2.25 1.01 2.25 2.25 0 .415-.336.75-.75.75M15.25 11.271c-.414 0-.75-.335-.75-.75v-1.25c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .415-.336.75-.75.75M4.75 11.271c-.414 0-.75-.335-.75-.75v-1.25c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .415-.336.75-.75.75M6.25 16.021c-1.24 0-2.25-1.01-2.25-2.25 0-.414.336-.75.75-.75s.75.336.75.75.337.75.75.75c.414 0 .75.336.75.75s-.336.75-.75.75M4.75 7.021c-.414 0-.75-.335-.75-.75 0-1.24 1.01-2.25 2.25-2.25.414 0 .75.336.75.75s-.336.75-.75.75c-.413 0-.75.337-.75.75 0 .415-.336.75-.75.75M13.75 16.021c-.414 0-.75-.335-.75-.75s.336-.75.75-.75c.413 0 .75-.336.75-.75s.336-.75.75-.75.75.336.75.75c0 1.24-1.01 2.25-2.25 2.25M18.25 5.75c-.414 0-.75-.336-.75-.75V3.25c0-.413-.337-.75-.75-.75H15c-.414 0-.75-.336-.75-.75S14.586 1 15 1h1.75C17.99 1 19 2.01 19 3.25V5c0 .414-.336.75-.75.75M16.75 19H15c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.75c.413 0 .75-.337.75-.75V15c0-.414.336-.75.75-.75s.75.336.75.75v1.75c0 1.24-1.01 2.25-2.25 2.25M5 19H3.25C2.01 19 1 17.99 1 16.75V15c0-.414.336-.75.75-.75s.75.336.75.75v1.75c0 .413.337.75.75.75H5c.414 0 .75.336.75.75S5.414 19 5 19M1.75 5.75C1.336 5.75 1 5.414 1 5V3.25C1 2.01 2.01 1 3.25 1H5c.414 0 .75.336.75.75s-.336.75-.75.75H3.25c-.413 0-.75.337-.75.75V5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gueil":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M2.457 9.896c-.186 0-.375-.037-.556-.11C1.354 9.56 1 9.031 1 8.438V2.354c0-.591.353-1.119.898-1.345.545-.227 1.167-.104 1.585.313l4.16 4.149c.422.42.545 1.055.313 1.618C7.727 7.643 7.2 8 6.616 8H4.964q-.017.003-.023-.002L3.49 9.465c-.28.281-.652.43-1.032.43M1.75 8.439l.75.001zm.673-6.054L2.5 8.37l1.432-1.484c.383-.387.873-.387 1.034-.387h1.65zM19.21 11.53l-2.002-1.75c-.261-.228-.655-.2-.882.059-.227.26-.2.654.06.882l.606.529H12.75V6.959l.53.605c.123.142.296.214.47.214.146 0 .293-.05.411-.154.26-.228.287-.622.06-.882L12.47 4.74c-.238-.271-.704-.271-.942 0L9.78 6.742c-.227.26-.2.654.06.882s.655.2.882-.06l.529-.605v4.291H7.408l.606-.53c.26-.227.287-.621.06-.881s-.622-.287-.882-.06l-2.003 1.75c-.136.12-.214.29-.214.471s.078.352.214.47l2.003 1.75c.119.104.265.155.41.155.175 0 .348-.072.472-.214.227-.26.2-.654-.06-.882l-.606-.529h3.842v3.791l-.53-.605c-.226-.26-.621-.288-.881-.06s-.287.622-.06.882l1.75 2.003c.119.135.29.214.471.214s.352-.079.47-.214l1.75-2.003c.228-.26.201-.654-.059-.882-.261-.228-.655-.2-.882.06l-.529.605V12.75h4.242l-.606.53c-.26.227-.287.621-.06.881.124.142.297.214.471.214.146 0 .293-.05.411-.154l2.003-1.75c.136-.12.214-.29.214-.471s-.078-.352-.214-.47"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kKUGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.628 8.395c-.335-.244-.803-.172-1.048.162l-3.075 4.198-1.014-1.306c-.254-.327-.725-.384-1.052-.132-.327.254-.386.725-.132 1.052L9.93 14.46c.017.022.043.03.062.05.03.032.05.07.087.096.026.019.056.027.084.043q.035.02.071.036c.093.039.19.065.287.065h.001c.101 0 .2-.028.296-.07q.038-.017.075-.04c.03-.016.061-.026.089-.047.036-.028.056-.067.085-.1.018-.019.044-.028.06-.05l3.662-5c.245-.334.172-.803-.162-1.048"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18h-8.5C6.01 18 5 16.99 5 15.75v-8.5C5 6.01 6.01 5 7.25 5h8.5C16.99 5 18 6.01 18 7.25v8.5c0 1.24-1.01 2.25-2.25 2.25M7.25 6.5c-.414 0-.75.337-.75.75v8.5c0 .413.336.75.75.75h8.5c.414 0 .75-.337.75-.75v-8.5c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2.75 13.75c-.414 0-.75-.336-.75-.75V4.25C2 3.01 3.01 2 4.25 2H13c.414 0 .75.336.75.75s-.336.75-.75.75H4.25c-.414 0-.75.337-.75.75V13c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"MY7qb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.75 3.5H11.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75m.75 13.75c0-.414-.336-.75-.75-.75H11.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.25c.414 0 .75-.336.75-.75M9.25 2.75c0-.414-.336-.75-.75-.75H7.25c-.414 0-.75.336-.75.75s.336.75.75.75H8.5c.414 0 .75-.336.75-.75m0 14.5c0-.414-.336-.75-.75-.75H7.25c-.414 0-.75.336-.75.75s.336.75.75.75H8.5c.414 0 .75-.336.75-.75m8.75-13C18 3.01 16.99 2 15.75 2c-.414 0-.75.336-.75.75s.336.75.75.75.75.336.75.75.336.75.75.75.75-.336.75-.75m0 4.25V7.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75V8.5c0 .414.336.75.75.75s.75-.336.75-.75m-14.5 0V7.25c0-.414-.336-.75-.75-.75S2 6.836 2 7.25V8.5c0 .414.336.75.75.75s.75-.336.75-.75M18 12.75V11.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.25c0 .414.336.75.75.75s.75-.336.75-.75m-14.5 0V11.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.25c0 .414.336.75.75.75s.75-.336.75-.75m1.5 4.5c0-.414-.336-.75-.75-.75s-.75-.336-.75-.75-.336-.75-.75-.75-.75.336-.75.75C2 16.99 3.01 18 4.25 18c.414 0 .75-.336.75-.75m13.78 1.53c.293-.293.293-.767 0-1.06L2.28 1.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l16.5 16.5c.146.147.338.22.53.22s.384-.073.53-.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7KZLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.75 3.5H11.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M12.75 18H11.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M8.5 3.5H7.25c-.414 0-.75-.336-.75-.75S6.836 2 7.25 2H8.5c.414 0 .75.336.75.75s-.336.75-.75.75M8.5 18H7.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H8.5c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 5c-.414 0-.75-.336-.75-.75 0-.413-.337-.75-.75-.75-.414 0-.75-.336-.75-.75s.336-.75.75-.75C16.99 2 18 3.01 18 4.25c0 .414-.336.75-.75.75M17.25 9.25c-.414 0-.75-.336-.75-.75V7.25c0-.414.336-.75.75-.75s.75.336.75.75V8.5c0 .414-.336.75-.75.75M2.75 9.25c-.414 0-.75-.336-.75-.75V7.25c0-.414.336-.75.75-.75s.75.336.75.75V8.5c0 .414-.336.75-.75.75M2.75 13.5c-.414 0-.75-.336-.75-.75V11.5c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .414-.336.75-.75.75M17.25 13.5c-.414 0-.75-.336-.75-.75V11.5c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .414-.336.75-.75.75M4.25 18C3.01 18 2 16.99 2 15.75c0-.414.336-.75.75-.75s.75.336.75.75c0 .413.337.75.75.75.414 0 .75.336.75.75s-.336.75-.75.75M15.75 18c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c.413 0 .75-.337.75-.75 0-.414.336-.75.75-.75s.75.336.75.75c0 1.24-1.01 2.25-2.25 2.25M2.75 5C2.336 5 2 4.664 2 4.25 2 3.01 3.01 2 4.25 2c.414 0 .75.336.75.75s-.336.75-.75.75c-.413 0-.75.337-.75.75 0 .414-.336.75-.75.75M11.06 10l1.72-1.72c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0L10 8.94 8.28 7.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06L8.94 10l-1.72 1.72c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.06l1.72 1.72c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4HvH2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M4.25 2C3.01 2 2 3.01 2 4.25c0 .414.336.75.75.75s.75-.336.75-.75.336-.75.75-.75.75-.336.75-.75S4.664 2 4.25 2M8.5 16.5H7.25c-.414 0-.75.336-.75.75s.336.75.75.75H8.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M15.75 3.5c.414 0 .75.336.75.75s.336.75.75.75.75-.336.75-.75C18 3.01 16.99 2 15.75 2c-.414 0-.75.336-.75.75s.336.75.75.75M2.75 13.5c.414 0 .75-.336.75-.75V11.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.25c0 .414.336.75.75.75M2.75 9.25c.414 0 .75-.336.75-.75V7.25c0-.414-.336-.75-.75-.75S2 6.836 2 7.25V8.5c0 .414.336.75.75.75M4.25 16.5c-.414 0-.75-.336-.75-.75S3.164 15 2.75 15s-.75.336-.75.75C2 16.99 3.01 18 4.25 18c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M8.5 2H7.25c-.414 0-.75.336-.75.75s.336.75.75.75H8.5c.414 0 .75-.336.75-.75S8.914 2 8.5 2M17.25 15c-.414 0-.75.336-.75.75s-.336.75-.75.75-.75.336-.75.75.336.75.75.75c1.24 0 2.25-1.01 2.25-2.25 0-.414-.336-.75-.75-.75M17.25 6.5c-.414 0-.75.336-.75.75V8.5c0 .414.336.75.75.75s.75-.336.75-.75V7.25c0-.414-.336-.75-.75-.75M17.25 10.75c-.414 0-.75.336-.75.75v1.25c0 .414.336.75.75.75s.75-.336.75-.75V11.5c0-.414-.336-.75-.75-.75M12.75 2H11.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.25c.414 0 .75-.336.75-.75S13.164 2 12.75 2M12.75 16.5H11.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"crxtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.649 9.974c0-.295-.172-.563-.443-.683L4.058 2.933c-.257-.115-.557-.077-.776.098-.22.177-.323.46-.267.736l1.272 6.241-1.222 6.23c-.049.247.03.5.205.675q.031.03.065.058c.221.174.52.211.776.095l14.098-6.408c.268-.122.44-.39.44-.684m-4.243-.747-8.742.027L4.777 4.9zm-9.589 5.87.852-4.344 8.763-.027z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a466w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15 13.25c-.768 0-1.462.318-1.961.827l-6.357-3.485c.042-.191.068-.388.068-.592s-.026-.4-.068-.592l6.357-3.485c.5.509 1.193.827 1.961.827 1.517 0 2.75-1.233 2.75-2.75S16.517 1.25 15 1.25 12.25 2.483 12.25 4c0 .207.027.407.07.601L5.97 8.088C5.47 7.573 4.773 7.25 4 7.25c-1.517 0-2.75 1.233-2.75 2.75S2.483 12.75 4 12.75c.773 0 1.47-.323 1.97-.838l6.35 3.487c-.043.194-.07.394-.07.601 0 1.517 1.233 2.75 2.75 2.75s2.75-1.233 2.75-2.75-1.233-2.75-2.75-2.75m0-10.5c.69 0 1.25.56 1.25 1.25S15.69 5.25 15 5.25 13.75 4.69 13.75 4s.56-1.25 1.25-1.25M2.75 10c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25M15 17.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5zEOm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m13.527 5.49-3.002-2.997c-.293-.292-.767-.293-1.06 0L6.467 5.491c-.293.293-.293.767 0 1.06.147.147.339.22.53.22s.384-.073.53-.22L9.25 4.83v8.181c0 .414.336.75.75.75s.75-.336.75-.75V4.837l1.718 1.715c.293.292.767.293 1.06-.001.293-.293.293-.768 0-1.06"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18.021H4.25c-1.24 0-2.25-1.01-2.25-2.25v-5.75c0-.414.336-.75.75-.75s.75.336.75.75v5.75c0 .414.336.75.75.75h11.5c.414 0 .75-.336.75-.75v-5.75c0-.414.336-.75.75-.75s.75.336.75.75v5.75c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"28zfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.18 4.809C16.752 4.295 16.122 4 15.453 4H5.087l-.141-.861C4.768 2.044 3.834 1.25 2.726 1.25H1c-.414 0-.75.336-.75.75s.336.75.75.75h1.724c.37 0 .68.265.74.63l1.59 9.731C5.233 14.206 6.167 15 7.275 15H16c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H7.275c-.37 0-.68-.265-.74-.63L6.23 11h8.768c1.088 0 2.02-.776 2.214-1.848l.455-2.5c.12-.658-.058-1.33-.487-1.843m-.989 1.576-.455 2.499c-.065.357-.375.616-.738.616H5.985l-.653-4h10.12c.306 0 .493.169.577.27s.217.314.162.615m-1.19 12.865c-.691 0-1.25-.56-1.25-1.25s.559-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25m-8 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bH1Dq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.744 4.188-2.25-2.25c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06L16.436 4h-2.224c-2.108 0-4.001 1.299-4.797 3.252l-2.47 4.873C6.356 13.567 5.01 14.5 3.512 14.5H1.714c-.414 0-.75.336-.75.75s.336.75.75.75h1.798c2.11 0 4.003-1.299 4.797-3.252l2.47-4.873c.59-1.442 1.937-2.375 3.433-2.375h2.16l-.938.937c-.293.293-.293.768 0 1.061.146.147.337.22.53.22s.384-.073.53-.22l2.25-2.25c.293-.293.293-.768 0-1.06M7.103 7.389c-.235 0-.465-.11-.612-.314C5.787 6.09 4.673 5.5 3.511 5.5H1.715c-.414 0-.75-.336-.75-.75S1.3 4 1.714 4h1.798c1.644 0 3.215.823 4.2 2.202.24.338.163.806-.174 1.047-.133.095-.285.14-.435.14M18.744 14.736l-2.25-2.25c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06l.953.954h-2.174c-1.155 0-2.266-.584-2.97-1.562-.242-.334-.71-.413-1.048-.17-.336.242-.412.71-.17 1.046.986 1.369 2.551 2.186 4.188 2.186h2.207l-.986.986c-.293.293-.293.768 0 1.06.146.147.337.22.53.22s.384-.073.53-.22l2.25-2.25c.293-.292.293-.767 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dAI8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.75 16h-7.5C5.01 16 4 14.99 4 13.75v-7.5C4 5.01 5.01 4 6.25 4h7.5C14.99 4 16 5.01 16 6.25v7.5c0 1.24-1.01 2.25-2.25 2.25M6.25 5.5c-.414 0-.75.337-.75.75v7.5c0 .413.336.75.75.75h7.5c.414 0 .75-.337.75-.75v-7.5c0-.413-.336-.75-.75-.75zM1.75 14.75c-.414 0-.75-.336-.75-.75V6c0-.414.336-.75.75-.75s.75.336.75.75v8c0 .414-.336.75-.75.75M18.25 14.75c-.414 0-.75-.336-.75-.75V6c0-.414.336-.75.75-.75s.75.336.75.75v8c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.196 9.414 9.018 7.706C8.558 7.46 8 7.792 8 8.315v3.416c0 .523.558.856 1.018.609l3.178-1.708c.485-.261.485-.957 0-1.218"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eZq7m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.75 13.5c-.414 0-.75-.336-.75-.75V9.5c0-.414.336-.75.75-.75s.75.336.75.75v3.25c0 .414-.336.75-.75.75M6.75 13.5c-.414 0-.75-.336-.75-.75v-1c0-.414.336-.75.75-.75s.75.336.75.75v1c0 .414-.336.75-.75.75M12.75 13.5c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75s.75.336.75.75v5.5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eZU2C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.955 8.13c.028-.224-.059-.448-.245-.584l-7.343-5.333c-.029-.021-.062-.032-.094-.048-.02-.01-.04-.023-.061-.031q-.078-.027-.16-.032c-.021-.002-.04-.013-.062-.013-.047 0-.089.017-.132.027-.019.005-.038.005-.056.011q-.084.029-.156.08-.007.002-.013.006l-.046.033c-.013.012-.03.018-.042.03L2.291 7.55c-.024.017-.04.041-.061.061s-.04.036-.058.058q-.07.086-.107.19l-.002.003v.005q-.031.106-.025.217.003.038.012.075c.005.03.004.06.013.09l2.806 8.63c.01.03.028.055.042.083q.015.034.034.064.06.097.151.165.015.009.029.015.067.047.145.074.095.03.193.031h9.076c.03 0 .056-.01.084-.014s.055-.006.082-.014c.146-.04.27-.13.353-.258q.02-.031.034-.065c.014-.028.032-.052.042-.082l2.804-8.632c.01-.03.009-.06.014-.092zm-3.631 7.194-3.31-4.554 5.347-1.719zM3.63 9.027l5.359 1.74-3.31 4.558zm6.986-5.088 5.388 3.914-5.38 1.729zM9.375 9.58l-5.357-1.74L9.367 3.95zM10 11.502l3.311 4.557H6.69z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9.997,
                cy: 2.604,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5.416,
                cy: 16.745,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10.349,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.557,
                cy: 16.71,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 17.4,
                cy: 8.088,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 2.6,
                cy: 8.081,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9.997,
                cy: 2.604,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5.416,
                cy: 16.745,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10.349,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.557,
                cy: 16.71,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 17.4,
                cy: 8.088,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 2.6,
                cy: 8.081,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lTXig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M9.25 15.5h-6.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M13.25 10.5H2.75c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h10.5c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 5.5H2.75c-.414 0-.75-.336-.75-.75S2.336 4 2.75 4h14.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4c1u1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.203 5.3c-.244-.245-.622-.273-.873-.06-1.39 1.175-6.846 5.986-7.167 6.307-.462.478-.43 1.26.072 1.747.49.476 1.25.495 1.718.044.32-.322 5.133-5.776 6.31-7.165.212-.251.185-.63-.06-.874M16.488 15.25c-.128 0-.258-.032-.376-.102-.358-.207-.48-.666-.273-1.024.596-1.028.911-2.194.911-3.374 0-.36-.035-.737-.106-1.154-.07-.408.204-.796.612-.866.412-.066.796.204.866.612.086.502.128.962.128 1.408 0 1.443-.385 2.87-1.113 4.126-.139.24-.39.374-.65.374M3.512 15.25c-.259 0-.51-.134-.65-.374-.727-1.256-1.112-2.683-1.112-4.126C1.75 6.201 5.451 2.5 10 2.5c1.513 0 2.999.42 4.3 1.218.352.217.463.678.247 1.031-.216.354-.678.464-1.032.248C12.451 4.345 11.235 4 10 4c-3.722 0-6.75 3.028-6.75 6.75 0 1.18.315 2.346.91 3.374.208.358.086.817-.272 1.024-.118.07-.248.102-.376.102"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"buR8k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16 18H4c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 15H2.75c-.414 0-.75-.336-.75-.75v-2C2 11.01 3.01 10 4.25 10h3.2l.5-2.362c-1.049-.686-1.7-1.86-1.7-3.138C6.25 2.433 7.933.75 10 .75s3.75 1.683 3.75 3.75c0 1.277-.651 2.452-1.7 3.138l.5 2.362h3.2c1.24 0 2.25 1.01 2.25 2.25v2c0 .414-.336.75-.75.75M3.5 13.5h13v-1.25c0-.413-.337-.75-.75-.75h-3.807c-.354 0-.66-.248-.733-.595l-.743-3.503c-.074-.347.106-.699.432-.841.82-.36 1.351-1.17 1.351-2.061 0-1.24-1.01-2.25-2.25-2.25S7.75 3.26 7.75 4.5c0 .892.53 1.7 1.35 2.06.327.143.507.495.433.842l-.743 3.503c-.073.347-.379.595-.733.595H4.25c-.413 0-.75.337-.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cPXrk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M11.495 2.414 12.7 5.597c.211.56.735.94 1.332.968l3.4.161c1.492.07 2.103 1.951.937 2.886l-2.656 2.128c-.467.375-.667.99-.508 1.568l.896 3.26c.396 1.444-1.207 2.608-2.457 1.785l-2.819-1.858c-.5-.33-1.147-.33-1.648-.002l-2.867 1.88c-1.249.82-2.848-.342-2.454-1.783l.898-3.284c.158-.577-.042-1.192-.509-1.566L1.59 9.612c-1.167-.935-.556-2.815.937-2.886l3.4-.161c.597-.028 1.12-.409 1.332-.968L8.46 2.414c.529-1.398 2.506-1.398 3.034 0"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8dCAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M9.749 15.955c-.394 0-.787-.106-1.145-.317L2.35 11.937c-.692-.41-1.104-1.133-1.104-1.937s.412-1.527 1.104-1.937l6.254-3.7c.706-.417 1.55-.423 2.26-.018C11.577 4.75 12 5.48 12 6.299V13.7c0 .819-.424 1.548-1.135 1.954-.35.2-.734.3-1.116.3M9.745 5.547c-.113 0-.242.027-.377.106L3.114 9.355c-.333.196-.368.516-.368.645s.035.45.368.646l6.254 3.7c.338.2.64.071.754.007.113-.066.378-.26.378-.652V6.3c0-.393-.265-.586-.378-.652-.069-.039-.206-.1-.377-.1M16.75 16h-.5C15.01 16 14 14.99 14 13.75v-7.5C14 5.01 15.01 4 16.25 4h.5C17.99 4 19 5.01 19 6.25v7.5c0 1.24-1.01 2.25-2.25 2.25m-.5-10.5c-.414 0-.75.337-.75.75v7.5c0 .413.336.75.75.75h.5c.414 0 .75-.337.75-.75v-7.5c0-.413-.336-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"74ZDk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.251 15.955c-.383 0-.766-.1-1.116-.3C8.425 15.25 8 14.52 8 13.701V6.3c0-.819.424-1.548 1.135-1.954.712-.404 1.556-.398 2.26.017l6.255 3.701c.692.41 1.104 1.133 1.104 1.937s-.412 1.527-1.104 1.937l-6.254 3.7c-.358.212-.751.318-1.145.318m.004-10.41c-.172 0-.308.063-.377.102-.113.066-.378.26-.378.652V13.7c0 .393.265.586.378.652.114.064.414.191.754-.006l6.254-3.701c.333-.197.368-.517.368-.646s-.035-.45-.368-.646l-6.254-3.7c-.135-.08-.264-.108-.377-.108M3.75 16h-.5C2.01 16 1 14.99 1 13.75v-7.5C1 5.01 2.01 4 3.25 4h.5C4.99 4 6 5.01 6 6.25v7.5C6 14.99 4.99 16 3.75 16m-.5-10.5c-.414 0-.75.337-.75.75v7.5c0 .413.336.75.75.75h.5c.414 0 .75-.337.75-.75v-7.5c0-.413-.336-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cgtQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h7.879c.592 0 1.172-.24 1.59-.66l3.622-3.62c.419-.42.659-1 .659-1.591V4.25C18 3.01 16.99 2 15.75 2M3.5 15.75V4.25c0-.413.336-.75.75-.75h11.5c.414 0 .75.337.75.75V11h-3.25C12.01 11 11 12.01 11 13.25v3.25H4.25c-.414 0-.75-.337-.75-.75m9.16.53c-.046.046-.105.074-.16.106V13.25c0-.413.336-.75.75-.75h3.136c-.032.055-.06.114-.106.16z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5We3S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.087 10.875c-.483 0-.875-.392-.875-.875s.392-.875.875-.875.875.392.875.875-.392.875-.875.875M14.845 10.875c-.483 0-.875-.392-.875-.875s.392-.875.875-.875.875.392.875.875-.392.875-.875.875M11.602 10.875c-.483 0-.875-.392-.875-.875s.392-.875.875-.875.875.392.875.875-.391.875-.875.875M8.36 10.875c-.483 0-.875-.392-.875-.875s.392-.875.875-.875.875.392.875.875-.392.875-.875.875M1.875 10.875C1.392 10.875 1 10.483 1 10s.392-.875.875-.875.875.392.875.875-.392.875-.875.875M5.117 10.875c-.483 0-.875-.392-.875-.875s.392-.875.875-.875.875.392.875.875-.391.875-.875.875"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dAej9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18 10.75H2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h16c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"zX49W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.75 14.75c0-.966-.784-1.75-1.75-1.75H3c-.966 0-1.75.784-1.75 1.75S2.034 16.5 3 16.5h14c.966 0 1.75-.784 1.75-1.75M18 5.5H2c-.414 0-.75-.336-.75-.75S1.586 4 2 4h16c.414 0 .75.336.75.75s-.336.75-.75.75M18.75 9.25c0-.69-.56-1.25-1.25-1.25h-15c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"71qYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m9.53 4.47-3-3c-.293-.293-.767-.293-1.06 0l-3 3c-.293.293-.293.767 0 1.06s.767.293 1.06 0l1.72-1.72V16c0 .414.336.75.75.75s.75-.336.75-.75V3.81l1.72 1.72c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M17.53 14.47c-.293-.293-.767-.293-1.06 0l-1.72 1.72V4c0-.414-.336-.75-.75-.75s-.75.336-.75.75v12.19l-1.72-1.72c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l3 3c.146.147.338.22.53.22s.384-.073.53-.22l3-3c.293-.293.293-.767 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lljLf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 13.47-3-3c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l1.72 1.72H4c-.414 0-.75.336-.75.75s.336.75.75.75h12.19l-1.72 1.72c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22l3-3c.293-.293.293-.767 0-1.06M16 5.25H3.81l1.72-1.72c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0l-3 3c-.293.293-.293.767 0 1.06l3 3c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06L3.81 6.75H16c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYnHM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2M3.5 9h3v3h-3zM8 9h8.5v3H8zM3.5 4.25c0-.413.336-.75.75-.75h11.5c.414 0 .75.337.75.75V7.5h-13zm0 11.5V13.5h3v3H4.25c-.414 0-.75-.337-.75-.75m13 0c0 .413-.336.75-.75.75H8v-3h8.5z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a4mCK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.393 11.822c-.326-1.6-1.439-2.903-2.915-3.576.62-.92.85-2.04.631-3.134C12.75 3.31 11.12 2 9.232 2H5.125C4.504 2 4 2.504 4 3.125v13.75C4 17.496 4.504 18 5.125 18h5.197c1.57 0 3.036-.693 4.026-1.902.973-1.192 1.354-2.75 1.045-4.276M6.25 4.25h2.982c.818 0 1.52.548 1.67 1.304.113.56-.035 1.137-.403 1.588-.317.386-.755.608-1.2.608H6.25zm6.355 10.424c-.56.683-1.391 1.076-2.283 1.076H6.25V10h3.928c1.476 0 2.743.954 3.01 2.27.176.874-.03 1.728-.583 2.404"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gFPTC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.3 2h-5c-.414 0-.75.336-.75.75s.336.75.75.75h1.641l-3.492 13H5.662c-.414 0-.75.336-.75.75s.336.75.75.75h5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.66l3.493-13H14.3c.414 0 .75-.336.75-.75S14.714 2 14.3 2"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aVVqT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M5.968 7.988q.12.001.241-.04c.393-.133.603-.558.469-.95-.097-.285-.146-.62-.146-.996 0-2.292 2.27-2.903 3.612-2.903 1.192 0 2.808.597 3.537 1.906.05.094.162.339.216.593.005.023.021.04.028.064q.024.074.062.142.033.06.076.113.048.056.106.102.054.045.115.077.06.032.13.052.073.024.15.031c.023.002.043.013.067.013.027 0 .05-.012.077-.015s.052.005.078-.001c.024-.005.042-.02.064-.028q.074-.023.141-.06.062-.035.114-.078.056-.046.1-.103.045-.054.079-.116c.034-.062.039-.085.053-.132q.022-.071.03-.145c.002-.025.014-.046.014-.072v-3.3c0-.413-.336-.75-.75-.75s-.75.337-.75.75v.816c-1.1-.924-2.538-1.36-3.737-1.36-2.462 0-5.112 1.379-5.112 4.404 0 .54.076 1.037.226 1.478.105.312.397.508.71.508M16.25 9.25H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h7.456q.195.047.39.1c1.878.52 2.596 1.25 2.654 2.699 0 .012.028 1.223-.827 2.107-.65.672-1.666 1.013-3.018 1.013-4.23 0-4.644-3.105-4.659-3.232-.005-.051-.029-.095-.044-.143-.008-.024-.011-.048-.021-.071-.124-.295-.413-.496-.758-.454-.275.028-.49.208-.596.442q-.01.02-.02.039c-.023.06-.031.123-.038.188-.004.031-.019.06-.019.092v3.4c0 .415.336.75.75.75s.75-.335.75-.75v-.436c.907.906 2.347 1.675 4.655 1.675 1.785 0 3.17-.501 4.115-1.49 1.295-1.355 1.232-3.118 1.228-3.189-.05-1.266-.505-2.125-1.139-2.74h1.641c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k6hCW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 19H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M10 16c-2.62 0-4.75-2.13-4.75-4.75v-8.5c0-.414.336-.75.75-.75s.75.336.75.75v8.5c0 1.792 1.458 3.25 3.25 3.25s3.25-1.458 3.25-3.25v-8.5c0-.414.336-.75.75-.75s.75.336.75.75v8.5c0 2.62-2.13 4.75-4.75 4.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eFOXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.864 18.804c-.552 0-1.103-.207-1.523-.622l-7.633-7.467C2.258 10.275 2 9.662 2 9.033v-4.68C2 3.057 3.056 2 4.354 2h4.779c.628 0 1.218.244 1.662.687l7.571 7.548c.408.403.634.942.634 1.515s-.226 1.113-.637 1.518l-4.975 4.914c-.42.415-.972.622-1.524.622M4.354 3.5c-.471 0-.854.383-.854.854v4.679c0 .228.094.45.257.61l7.636 7.47c.261.258.682.257.94.002L17.31 12.2c.123-.121.19-.281.19-.45s-.067-.33-.19-.45L9.736 3.748c-.159-.158-.378-.249-.602-.249z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4nACT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 15c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m0-8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gExBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.5 9.261V4.196C13.5 2.158 11.93.5 10 .5S6.5 2.158 6.5 4.196v5.065c-1.22 1.01-2 2.535-2 4.239 0 3.032 2.468 5.5 5.5 5.5s5.5-2.468 5.5-5.5c0-1.704-.78-3.23-2-4.239M10 17.5c-2.206 0-4-1.794-4-4 0-1.031.403-1.963 1.045-2.673q.417-.458.955-.77v-5.86C8 2.984 8.897 2 10 2s2 .985 2 2.196v5.86q.538.313.955.771C13.597 11.537 14 12.47 14 13.5c0 2.206-1.794 4-4 4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 11.388V6.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4.638c-.872.31-1.5 1.134-1.5 2.112 0 1.243 1.007 2.25 2.25 2.25s2.25-1.007 2.25-2.25c0-.978-.628-1.802-1.5-2.112"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aNtQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.75 18h-9.5C4.01 18 3 16.99 3 15.75V3.25C3 2.01 4.01 1 5.25 1h9.5C15.99 1 17 2.01 17 3.25v12.5c0 1.24-1.01 2.25-2.25 2.25M5.25 2.5c-.413 0-.75.336-.75.75v12.5c0 .414.337.75.75.75h9.5c.413 0 .75-.336.75-.75V3.25c0-.414-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.651 15.267q-.257 0-.512-.108c-.58-.25-.873-.852-.713-1.463l.589-2.218H6.88c-.452 0-.87-.245-1.09-.64-.222-.394-.213-.878.023-1.263l3.468-5.346c.322-.523.956-.728 1.541-.483.582.245.881.844.727 1.457L10.95 7.5h2.17c.461 0 .883.252 1.1.658.22.406.197.897-.057 1.282l-3.48 5.252c-.23.368-.62.575-1.032.575m-.223-1.395-.005.007zM7.34 9.978h2c.39 0 .752.178.99.488.24.31.318.704.218 1.082l-.28 1.054L12.656 9h-2.028c-.39 0-.75-.177-.988-.485-.24-.309-.32-.702-.222-1.079l.287-1.104zM13.12 9h.01zM10.55 5.03l-.005.007z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kJSkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.59 1.998H3.41c-1.24 0-2.25 1.01-2.25 2.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75v-1.11c0-.413.337-.75.75-.75h3.84v13h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.13c.415 0 .75-.336.75-.75s-.335-.75-.75-.75h-.13v-13h3.84c.413 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75v-1.11c0-1.24-1.01-2.25-2.25-2.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3zo1O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 8.5H3.75c-.414 0-.75-.336-.75-.75S3.336 7 3.75 7h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M13.25 16.5h-6.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iYsj6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 8.5H3.75c-.414 0-.75-.336-.75-.75S3.336 7 3.75 7h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 16.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cwdKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 8.5H3.75c-.414 0-.75-.336-.75-.75S3.336 7 3.75 7h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 16.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2dZZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 5h-5.5C1.285 5 .5 5.785.5 6.75v.77c0 .414.336.75.75.75S2 7.934 2 7.52v-.77c0-.138.112-.25.25-.25h2v7.967h-.701c-.414 0-.75.336-.75.75s.336.75.75.75H6.45c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-.7V6.5h2c.138 0 .25.112.25.25v.77c0 .414.336.75.75.75s.75-.336.75-.75v-.77C9.5 5.785 8.715 5 7.75 5M17.75 5h-5.5c-.965 0-1.75.785-1.75 1.75v.77c0 .414.336.75.75.75s.75-.336.75-.75v-.77c0-.138.112-.25.25-.25h2v7.967h-.701c-.414 0-.75.336-.75.75s.336.75.75.75h2.901c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-.7V6.5h2c.138 0 .25.112.25.25v.77c0 .414.336.75.75.75s.75-.336.75-.75v-.77c0-.965-.785-1.75-1.75-1.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bC11M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.522 2H3.478C2.249 2 1.25 3.01 1.25 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.326-.75.728-.75H7.25v13H5.68c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H8.75v-13h3.772c.402 0 .728.337.728.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-1.24-.999-2.25-2.228-2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.75 9h-5c-.827 0-1.5.673-1.5 1.5v.86c0 .414.336.75.75.75s.75-.336.75-.75v-.86h1.75v6h-.586c-.414 0-.75.336-.75.75s.336.75.75.75h2.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H16v-6h1.75v.86c0 .414.336.75.75.75s.75-.336.75-.75v-.86c0-.827-.673-1.5-1.5-1.5"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aSnpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.558 2.952-1.51-1.51c-.862-.862-2.223-.93-3.158-.154L7.042 6.87c-.307.258-.543.591-.687.966l-.65 1.714-.006.013q-.067.173-.195.302l-1.442 1.442c-.54.54-.665 1.341-.38 2.006L1.275 15.72c-.214.215-.278.537-.163.817.117.28.39.463.694.463h3.901c.2 0 .39-.08.53-.22l.46-.459c.227.097.47.148.712.148.466 0 .932-.177 1.286-.532l1.442-1.44q.13-.13.3-.195l1.73-.657c.374-.144.707-.38.972-.696l5.571-6.835c.776-.94.71-2.3-.151-3.162M7.634 14.877c-.125.125-.326.123-.451 0l-2.059-2.059c-.125-.125-.125-.328 0-.452l1.375-1.375 2.51 2.51zm9.916-9.714-5.568 6.83c-.093.111-.214.197-.35.25l-1.276.484-3.083-3.083.485-1.275c.052-.137.138-.258.24-.345l6.843-5.577c.159-.13.351-.195.543-.195.219 0 .436.084.603.25l1.51 1.51c.313.313.337.806.053 1.151"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d28Yb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.59 1.998H3.41c-1.24 0-2.25 1.01-2.25 2.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75v-1.11c0-.413.337-.75.75-.75h3.84v13h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75H10c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H8.75v-13h3.84c.413 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75v-1.11c0-1.24-1.01-2.25-2.25-2.25M18.75 18.5c-.192 0-.384-.073-.53-.22l-2.47-2.47-2.47 2.47c-.293.293-.767.293-1.06 0s-.293-.767 0-1.06l3-3c.293-.293.767-.293 1.06 0l3 3c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4rSQP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M3.029 13.262v-5.55h-.032l-1.133.79c-.15.107-.264.145-.43.145-.328 0-.57-.236-.57-.58 0-.247.097-.43.35-.606l1.535-1.065c.376-.257.634-.305.967-.305.575 0 .92.348.92.907v6.264c0 .488-.323.81-.802.81-.477 0-.805-.322-.805-.81M6.396 13.308c0-.306.119-.511.446-.812l2.31-2.207c.955-.918 1.202-1.295 1.202-1.853 0-.64-.494-1.096-1.186-1.096-.623 0-1.053.312-1.332.935-.183.323-.371.473-.72.473-.435 0-.693-.258-.693-.661 0-.124.021-.236.06-.349.262-.86 1.235-1.66 2.7-1.66 1.644 0 2.75.924 2.75 2.256 0 .945-.461 1.536-1.729 2.734L8.528 12.68v.031h2.922c.42 0 .672.253.672.644 0 .382-.253.645-.672.645H7.16c-.512 0-.764-.284-.764-.692M13.169 12.73c-.086-.177-.123-.35-.123-.511 0-.418.268-.682.714-.682.322 0 .526.129.687.424.275.543.694.865 1.5.865.794 0 1.342-.462 1.342-1.106.005-.752-.548-1.171-1.488-1.171h-.338c-.393 0-.618-.23-.618-.58 0-.338.225-.574.618-.574h.316c.812 0 1.338-.442 1.338-1.075 0-.623-.419-1.037-1.203-1.037-.655 0-1.053.274-1.306.822-.176.366-.365.5-.73.5-.451 0-.682-.263-.682-.656 0-.182.037-.338.118-.521.344-.757 1.225-1.39 2.594-1.39 1.639 0 2.745.81 2.745 2.05 0 .984-.704 1.629-1.617 1.816v.033c1.155.107 1.902.784 1.902 1.852 0 1.408-1.22 2.342-3.019 2.342-1.477 0-2.385-.639-2.75-1.402"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5QYia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.741 2H7.125c-2.62 0-4.75 2.13-4.75 4.75s2.13 4.75 4.75 4.75H7.5v5.651c0 .414.336.75.75.75s.75-.336.75-.75V3.5h3v13.651c0 .414.336.75.75.75s.75-.336.75-.75V3.5h3.241c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M7.5 10h-.375c-1.792 0-3.25-1.458-3.25-3.25S5.333 3.5 7.125 3.5H7.5z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4uJnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.5 2h-9C2.26 2 1.25 3.01 1.25 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.336-.75.75-.75h3.75v3.75c0 .414.336.75.75.75s.75-.336.75-.75V3.5h3.75c.414 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25C14.75 3.01 13.74 2 12.5 2M10.75 9.25H2c-.414 0-.75.336-.75.75s.336.75.75.75h5.25v5.75H5.7c-.414 0-.75.336-.75.75s.336.75.75.75h3.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-.59v-5.75h2c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M13.94 19.5q-.146 0-.286-.057c-.281-.115-.465-.39-.465-.693v-.88C11.973 17.813 11 16.806 11 15.574V13.55c0-1.268 1.03-2.299 2.298-2.299h3.904c1.267 0 2.298 1.031 2.298 2.299v2.025c0 1.268-1.03 2.3-2.298 2.3h-1.341l-1.388 1.403c-.144.146-.337.223-.534.223m-.642-6.75c-.44 0-.798.358-.798.799v2.025c0 .44.358.8.798.8h.641c.353 0 .65.243.73.571l.345-.35c.14-.142.333-.222.533-.222h1.655c.44 0 .798-.358.798-.799V13.55c0-.44-.358-.799-.798-.799z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4IGfd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M7.478 2h9.044c1.229 0 2.228 1.01 2.228 2.25v1.11c0 .414-.336.75-.75.75s-.75-.336-.75-.75V4.25c0-.413-.326-.75-.728-.75H12.75v13h1.57c.414 0 .75.336.75.75s-.336.75-.75.75H9.68c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.57v-13H7.478c-.402 0-.728.337-.728.75v1.11c0 .414-.336.75-.75.75s-.75-.336-.75-.75V4.25C5.25 3.01 6.249 2 7.478 2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2.25 9h5c.827 0 1.5.673 1.5 1.5v.86c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.86H5.5v6h.586c.414 0 .75.336.75.75s-.336.75-.75.75h-2.64c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H4v-6H2.25v.86c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.86c0-.827.673-1.5 1.5-1.5"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"35shn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 15.271h-7.669c-.34-1.43-1.621-2.5-3.154-2.5s-2.813 1.07-3.154 2.5H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h2.523c.34 1.43 1.621 2.5 3.154 2.5s2.814-1.07 3.154-2.5h7.669c.414 0 .75-.335.75-.75s-.336-.75-.75-.75m-10.823 2.5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.786 1.75 1.75-.785 1.75-1.75 1.75M7.25 2h-4.5C1.785 2 1 2.785 1 3.75V4c0 .414.336.75.75.75s.75-.336.75-.75v-.25c0-.138.112-.25.25-.25h1.5v6h-.366c-.414 0-.75.336-.75.75s.336.75.75.75h2.2c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H5.75v-6h1.5c.138 0 .25.112.25.25V4c0 .414.336.75.75.75S9 4.414 9 4v-.25C9 2.785 8.215 2 7.25 2M16.75 2h-4.5C11.01 2 10 3.01 10 4.25v.25c0 .553.448 1 1 1s1-.447 1-1v-.25c0-.138.112-.25.25-.25h1.017c-.002.03-.017.055-.017.085V9H13c-.552 0-1 .447-1 1s.448 1 1 1h3c.552 0 1-.447 1-1s-.448-1-1-1h-.25V4.085c0-.03-.015-.055-.017-.085h1.017c.138 0 .25.112.25.25v.25c0 .553.448 1 1 1s1-.447 1-1v-.25C19 3.01 17.99 2 16.75 2"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"QNroZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.59 2H5.41C4.17 2 3.16 3.01 3.16 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.337-.75.75-.75h3.84v13H7.68c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.57v-13h3.84c.413 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-1.24-1.01-2.25-2.25-2.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"015fd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.78 9.194-2.03-4.877C16.165 2.911 14.807 2.001 13.29 2H4.25C3.01 2 2 3.01 2 4.251v5.5c0 1.24 1.01 2.25 2.25 2.25h2.066c.99.003 1.286 1.246 1.624 3.144.281 1.573.6 3.355 2.125 3.355 1.85 0 2.063-1.47 2.18-2.275l.205-2.536c.032-.385.36-.688.747-.688h3.045c.922 0 1.777-.458 2.288-1.225s.605-1.731.25-2.582M3.5 9.751v-5.5c0-.414.336-.751.75-.751h1v7.001h-1c-.414 0-.75-.337-.75-.75m13.782 1.193c-.236.354-.615.557-1.04.557h-3.045c-1.162 0-2.147.907-2.242 2.066 0 0-.195 2.414-.197 2.457-.141.976-.26.962-.714.974-.268-.106-.51-1.464-.627-2.117-.308-1.725-.723-4.044-2.667-4.346V3.5h6.54c.909.001 1.724.548 2.076 1.394l2.03 4.877c.164.392.122.82-.114 1.173"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bt8TI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.53 8.225C18.02 7.458 17.164 7 16.242 7h-3.045c-.387 0-.715-.303-.747-.688l-.2-2.38c.002-.052-.002-.138-.01-.189-.112-.653-.373-2.183-2.175-2.183-1.482 0-1.79 1.669-2.087 3.284C7.638 6.69 7.32 7.997 6.318 8H4.25C3.01 8 2 9.01 2 10.25v5.5C2 16.99 3.01 18 4.25 18h7.5q.052 0 .1-.007h1.44c1.52 0 2.877-.908 3.46-2.31l2.03-4.876c.355-.851.261-1.816-.25-2.582M3.5 15.75v-5.5c0-.413.336-.75.75-.75h1v7h-1c-.414 0-.75-.337-.75-.75m13.896-5.52-2.03 4.877c-.35.841-1.165 1.385-2.076 1.386h-1.54q-.052 0-.1.007h-4.9V9.467c1.956-.3 2.385-2.624 2.704-4.352.122-.667.351-1.909.611-2.055.36 0 .53 0 .686.877l.001.042.203 2.456c.095 1.158 1.08 2.065 2.242 2.065h3.045c.425 0 .804.203 1.04.557s.278.78.114 1.173"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6EmTT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.985 9h-9.97C2.8 9 1 7.206 1 5s1.8-4 4.015-4h9.97C17.2 1 19 2.794 19 5s-1.8 4-4.015 4m-9.97-6.5C3.628 2.5 2.5 3.621 2.5 5s1.128 2.5 2.515 2.5h9.97C16.372 7.5 17.5 6.379 17.5 5s-1.128-2.5-2.515-2.5z",
                opacity: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M5 9C2.794 9 1 7.206 1 5s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m0-6.5C3.621 2.5 2.5 3.621 2.5 5S3.621 7.5 5 7.5 7.5 6.379 7.5 5 6.379 2.5 5 2.5M19 14c0-2.206-1.8-4-4.015-4h-9.97C2.8 10 1 11.794 1 14s1.8 4 4.015 4h9.7c.071.004.139.021.212.021.554 0 1.082-.113 1.562-.318C17.96 17.108 19 15.676 19 14m-4.015 2.5h-.27c-1.279-.11-2.288-1.172-2.288-2.479 0-1.378 1.12-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 1.032-.628 1.918-1.521 2.3-.286.112-.595.179-.92.179M2.5 14c0-1.379 1.128-2.5 2.515-2.5h6.832c-.566.69-.92 1.56-.92 2.521 0 .941.34 1.795.885 2.479H5.015C3.628 16.5 2.5 15.379 2.5 14"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"h9703":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m8.747 5.33-1.82-3.505c-.17-.33-.508-.538-.88-.54h-.008c-.37 0-.706.201-.88.525l-1.89 3.5C3.095 5.639 3 6.008 3 6.38V16.75C3 17.99 4.01 19 5.25 19h1.5C7.99 19 9 17.99 9 16.75V6.366c0-.36-.088-.719-.253-1.037M7.5 7.5v7h-3v-7zM6.03 3.354 7.405 6H4.603zM6.75 17.5h-1.5c-.413 0-.75-.337-.75-.75V16h3v.75c0 .413-.337.75-.75.75M14.75 1h-1.5C12.01 1 11 2.01 11 3.25v6.729q-.002.007-.003.014.002.008.003.015v3.722q-.002.006-.003.013.002.008.003.015v2.992c0 1.24 1.01 2.25 2.25 2.25h1.5c1.24 0 2.25-1.01 2.25-2.25V3.25C17 2.01 15.99 1 14.75 1m.75 15.75c0 .413-.337.75-.75.75h-1.5c-.413 0-.75-.337-.75-.75v-2.251l1.244.005h.003c.413 0 .748-.334.75-.747.002-.414-.333-.751-.747-.753l-1.25-.005v-2.25l1.244.005h.003c.413 0 .748-.334.75-.747.002-.414-.333-.751-.747-.753l-1.25-.005V7.003l1.247.006h.003c.413 0 .748-.334.75-.747.002-.414-.332-.751-.747-.753L12.5 5.503V3.25c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ach2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M5.86 3.769H3.336l1.054-1.054c.244-.244.245-.64 0-.884s-.639-.245-.883 0L1.384 3.95c-.118.118-.183.277-.183.443s.065.325.183.442l2.122 2.121c.122.122.281.183.442.183s.32-.062.442-.184c.244-.244.243-.64-.001-.884L3.335 5.02H5.86c.344 0 .625-.28.625-.625s-.28-.625-.625-.625M18.442 3.951l-2.12-2.12c-.245-.245-.641-.245-.885 0-.244.243-.244.64 0 .884l1.054 1.054h-2.526c-.345 0-.625.28-.625.625s.28.625.625.625h2.526l-1.054 1.053c-.244.245-.244.641 0 .885.122.122.282.183.442.183s.32-.06.442-.183l2.121-2.12c.244-.245.244-.641 0-.886M12.145 19.06h-.079c-2.88-.034-4.757-2.32-6.13-3.989l-.24-.293c-.398-.48-.73-.865-1.003-1.183-.907-1.055-1.32-1.536-1.32-2.334.003-1.019.91-1.91 1.94-1.91.795.002 1.239.363 2.683 1.8V4.123c0-1.057.86-1.916 1.916-1.916s1.915.86 1.915 1.916v4.55c.593.012 1.246.044 1.737.148 2.484.599 3.82 2.242 3.596 4.4-.15 1.449-.605 5.839-5.015 5.839m-6.832-8.21c-.209 0-.439.216-.44.414 0 .228.23.507.958 1.353.277.323.615.715 1.02 1.204l.245.297c1.25 1.523 2.806 3.416 4.988 3.443 2.167.018 3.255-1.318 3.584-4.493.193-1.864-1.442-2.544-2.435-2.783-.499-.105-1.414-.114-2.02-.12h-.144c-.41-.005-.742-.34-.742-.75V4.123c0-.23-.186-.416-.415-.416-.23 0-.416.187-.416.416v8.834c0 .303-.183.576-.462.692-.28.118-.602.052-.817-.16l-.742-.741c-1.303-1.303-1.898-1.897-2.162-1.898"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9LYat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M1.75 16.652c-.414 0-.75-.336-.75-.75v-6.5c0-.414.336-.75.75-.75s.75.336.75.75v6.5c0 .414-.336.75-.75.75M4.75 19c-.414 0-.75-.336-.75-.75V6.75c0-.414.336-.75.75-.75s.75.336.75.75v11.5c0 .414-.336.75-.75.75M7.75 15.652c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 18h-5.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.5c.413 0 .75-.337.75-.75V3.25c0-.413-.337-.75-.75-.75h-9.5c-.413 0-.75.337-.75.75v.48c0 .414-.336.75-.75.75S5 4.143 5 3.73v-.48C5 2.01 6.01 1 7.25 1h9.5C17.99 1 19 2.01 19 3.25v12.5c0 1.24-1.01 2.25-2.25 2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 6.5H9c-.414 0-.75-.336-.75-.75S8.586 5 9 5h6c.414 0 .75.336.75.75s-.336.75-.75.75M15 10.5h-3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H15c.414 0 .75.336.75.75s-.336.75-.75.75M15 14.5h-3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H15c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iVJgu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m17.116 12.15-1.064-4.215c.55-.385.913-1.02.913-1.742 0-1.172-.953-2.125-2.125-2.125-.667 0-1.256.315-1.646.798L7.866 3.104c-.048-1.13-.975-2.036-2.116-2.036-1.172 0-2.125.953-2.125 2.125 0 .758.401 1.42 1 1.796l-1.843 9.17C1.773 14.326 1 15.197 1 16.25c0 1.172.953 2.125 2.125 2.125 1.012 0 1.858-.712 2.07-1.662l9.834-1.43c.365.648 1.05 1.092 1.846 1.092 1.172 0 2.125-.953 2.125-2.125 0-1.09-.827-1.979-1.884-2.1M14.8 13.8 4.977 15.23c-.174-.315-.421-.582-.725-.773l1.843-9.173c.522-.086.976-.363 1.297-.757l5.333 1.765c.048 1.043.847 1.883 1.87 2.002l1.065 4.218c-.43.302-.745.759-.86 1.29m.04-8.483c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.392-.875-.875.392-.875.875-.875m-9.09-3c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.392-.875-.875.393-.875.875-.875M3.125 17.125c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875m13.75-2c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hrHN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.375 10c0-.907-.574-1.677-1.375-1.981V5.73c.801-.304 1.375-1.074 1.375-1.981 0-1.172-.953-2.125-2.125-2.125-.907 0-1.677.574-1.982 1.375h-2.286c-.305-.801-1.075-1.375-1.982-1.375S8.323 2.199 8.018 3H5.732c-.305-.801-1.075-1.375-1.982-1.375-1.172 0-2.125.953-2.125 2.125 0 .907.574 1.677 1.375 1.981V8.02C2.199 8.323 1.625 9.093 1.625 10S2.199 11.677 3 11.981v2.288c-.801.304-1.375 1.074-1.375 1.981 0 1.172.953 2.125 2.125 2.125.907 0 1.677-.574 1.981-1.375h2.287c.305.801 1.075 1.375 1.982 1.375s1.677-.574 1.982-1.375h2.286c.305.801 1.075 1.375 1.982 1.375 1.172 0 2.125-.953 2.125-2.125 0-.907-.574-1.677-1.375-1.981V11.98c.801-.304 1.375-1.074 1.375-1.981m-4.107 5.5h-2.286c-.305-.801-1.075-1.375-1.982-1.375s-1.677.574-1.982 1.375H5.732c-.216-.567-.665-1.016-1.232-1.231V11.98c.801-.304 1.375-1.074 1.375-1.981S5.301 8.323 4.5 8.019V5.73c.567-.215 1.016-.664 1.231-1.231h2.287c.305.801 1.075 1.375 1.982 1.375s1.677-.574 1.982-1.375h2.286c.216.567.665 1.016 1.232 1.231V8.02c-.801.304-1.375 1.074-1.375 1.981s.574 1.677 1.375 1.981v2.288c-.567.215-1.016.664-1.232 1.231m1.982-4.625c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875m0-8c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m-6.25 0c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m-6.25 0c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m0 6.25c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m0 8c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875m6.25 0c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875m6.25 0c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8ARg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17 11.269V8.73c.801-.304 1.375-1.074 1.375-1.981 0-1.172-.953-2.125-2.125-2.125-.73 0-1.375.37-1.757.932L5.848 3.482C5.715 2.438 4.83 1.625 3.75 1.625c-1.172 0-2.125.953-2.125 2.125 0 .907.574 1.677 1.375 1.981v8.538c-.801.304-1.375 1.074-1.375 1.981 0 1.172.953 2.125 2.125 2.125 1.08 0 1.965-.813 2.098-1.857l8.645-2.075c.382.562 1.027.932 1.757.932 1.172 0 2.125-.953 2.125-2.125 0-.907-.574-1.677-1.375-1.981m-2.848 1.714-8.645 2.074c-.244-.358-.596-.632-1.007-.788V5.73c.41-.156.763-.43 1.007-.788l8.645 2.074c.1.789.628 1.44 1.348 1.714v2.538c-.72.273-1.247.925-1.348 1.714m2.098-7.108c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m-12.5-3c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m0 14.25c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875m12.5-3c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kEXJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.375 3.75c0-1.172-.953-2.125-2.125-2.125-.907 0-1.677.574-1.982 1.375H9.732c-.305-.801-1.075-1.375-1.982-1.375-1.172 0-2.125.953-2.125 2.125 0 .672.32 1.265.808 1.655L3.64 14.136c-1.12.06-2.014.98-2.014 2.114 0 1.172.953 2.125 2.125 2.125.907 0 1.677-.574 1.982-1.375h4.536c.305.801 1.075 1.375 1.982 1.375 1.172 0 2.125-.953 2.125-2.125 0-.672-.32-1.265-.808-1.655l2.794-8.731c1.12-.06 2.014-.98 2.014-2.114m-2.125-.875c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875M10.268 15.5H5.732c-.137-.36-.37-.669-.665-.905L7.86 5.864c.858-.046 1.579-.596 1.87-1.364h4.538c.136.36.368.669.664.905l-2.794 8.731c-.858.046-1.579.596-1.87 1.364M7.75 2.875c.482 0 .875.393.875.875s-.393.875-.875.875-.875-.393-.875-.875.393-.875.875-.875m-4 14.25c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875m8.5 0c-.482 0-.875-.393-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9hhbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.95 5.938c0-1.172-.953-2.125-2.125-2.125-.376 0-.725.106-1.032.279-1.318-.94-3.366-2.03-5.793-2.03-2.433 0-4.5 1.095-5.832 2.035-.31-.176-.662-.285-1.043-.285C1.953 3.813 1 4.767 1 5.938c0 1.053.773 1.924 1.78 2.09l1.207 6.002c-.598.377-.999 1.038-.999 1.795 0 1.172.953 2.125 2.125 2.125s2.125-.953 2.125-2.125c0-.106-.016-.209-.031-.311.865-.404 1.887-.764 2.793-.764.93 0 1.924.36 2.738.748-.017.107-.033.215-.033.327 0 1.172.953 2.125 2.125 2.125s2.125-.953 2.125-2.125c0-.664-.313-1.251-.792-1.641l1.064-6.162c.98-.188 1.723-1.05 1.723-2.084m-1.25 0c0 .482-.392.875-.875.875s-.875-.393-.875-.875.393-.875.875-.875.875.392.875.875m-15.45 0c0-.483.393-.875.875-.875S4 5.455 4 5.938s-.393.875-.875.875-.875-.393-.875-.875M5.113 16.7c-.482 0-.875-.392-.875-.875s.393-.875.875-.875.875.393.875.875-.392.875-.875.875m1.353-2.5c-.284-.237-.627-.402-1.008-.465L4.25 7.733c.598-.377.999-1.038.999-1.795 0-.237-.048-.46-.12-.673C6.284 4.467 8.019 3.563 10 3.563c1.972 0 3.685.896 4.823 1.69-.074.216-.123.444-.123.685 0 .777.425 1.451 1.05 1.822l-1.028 5.951c-.468.024-.892.2-1.233.479-.988-.477-2.26-.94-3.489-.94-1.24 0-2.53.47-3.534.95m8.364 2.5c-.482 0-.875-.392-.875-.875s.393-.875.875-.875.875.393.875.875-.393.875-.875.875"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2PtZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.25 2.5H7.834v-.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v.75H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h7.878C9.17 6.271 7.792 7.876 6.272 8.934c-.479-.869-.843-1.76-1.068-2.645-.101-.401-.51-.648-.912-.542-.4.102-.644.51-.542.911.259 1.02.677 2.045 1.228 3.039-.793.395-1.563.66-2.195.802-.405.09-.659.491-.569.896.078.348.388.585.732.585q.082 0 .164-.018c.766-.171 1.705-.499 2.669-.996.824 1.19 1.83 2.311 2.988 3.284.14.118.312.176.482.176.214 0 .426-.091.575-.268.266-.317.225-.79-.092-1.056-1.031-.867-1.927-1.858-2.664-2.906C8.946 8.906 10.67 6.903 11.156 4h1.094c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M18.94 17.958l-4.018-9.5c-.118-.277-.39-.458-.691-.458s-.573.18-.691.458l-4.02 9.5c-.16.38.018.821.399.982.384.165.822-.016.983-.398l1.28-3.026h4.097l1.28 3.026c.121.286.399.458.691.458q.148 0 .292-.06c.382-.16.56-.601.399-.982m-6.123-3.942 1.414-3.341 1.413 3.34z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gmxtP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M5.516 14.185q-.108 0-.216-.033l-2.678-.805C1.671 13.077 1 12.187 1 11.187V3.252c0-.712.326-1.367.895-1.796S3.18.892 3.868 1.087L9 2.554l5.132-1.466c.684-.198 1.404-.063 1.973.367.569.429.895 1.084.895 1.796v2.854c0 .415-.336.75-.75.75s-.75-.335-.75-.75V3.251c0-.237-.108-.456-.298-.599s-.432-.19-.658-.122L9.206 4.055c-.135.039-.277.039-.412 0L3.456 2.529c-.226-.065-.468-.02-.658.123s-.298.362-.298.599v7.937c0 .333.224.628.544.72l2.687.809c.397.119.623.537.502.933-.097.326-.395.535-.717.535"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.718 6.743q-.104 0-.206-.03L4.5 6.14c-.398-.114-.629-.529-.515-.927.114-.399.529-.634.927-.515l2.012.575c.398.114.629.529.514.927-.093.33-.393.544-.72.544M6.718 10.056q-.104 0-.206-.03L4.5 9.451c-.398-.113-.629-.528-.515-.927.114-.398.529-.635.927-.514l2.012.575c.398.113.629.528.514.927-.093.329-.393.544-.72.544M11.282 6.743c-.327 0-.627-.215-.72-.544-.115-.398.116-.813.514-.927l2.012-.575c.397-.117.813.117.927.515s-.117.813-.515.927l-2.012.575q-.102.03-.206.03M13.5 19C10.468 19 8 16.532 8 13.5S10.468 8 13.5 8s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5m0-9.5c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12 14.953v-2.906c0-.429.414-.69.733-.463l2.35 1.453c.301.214.301.712 0 .926l-2.35 1.453c-.319.227-.733-.034-.733-.463"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gTBhP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.5 17.771c-.32 0-.616-.206-.716-.527l-.821-2.642c-.123-.396.098-.817.493-.939.4-.125.816.099.939.493l.82 2.643c.124.395-.097.816-.492.938q-.113.035-.223.034M17 14.271q-.112.001-.224-.034l-2.657-.829c-.395-.123-.615-.544-.492-.94.122-.395.544-.62.94-.491l2.657.829c.395.123.615.544.492.94-.1.32-.397.525-.716.525M7.316 6.405c-.32 0-.616-.206-.716-.528l-.817-2.634c-.122-.395.099-.815.495-.938.395-.122.815.098.939.495l.816 2.634c.122.395-.098.815-.495.938q-.11.034-.222.033M5.64 8.09q-.111 0-.223-.033l-2.64-.82c-.395-.122-.616-.543-.493-.938s.54-.615.939-.493l2.64.819c.395.122.616.543.492.938-.1.322-.395.528-.715.528M5.313 18.77c-1.04 0-2.08-.397-2.873-1.189-1.585-1.584-1.585-4.163 0-5.747l1.927-1.927c.293-.293.768-.293 1.06 0s.294.768 0 1.06l-1.926 1.928c-1 1-1 2.626 0 3.626s2.627.997 3.626 0l1.952-1.954c.292-.292.767-.294 1.06 0 .294.292.294.768 0 1.06l-1.951 1.954c-.792.792-1.834 1.188-2.875 1.189M15.1 10.356c-.192 0-.383-.073-.53-.22-.293-.292-.293-.767 0-1.06l1.928-1.928c1-1 1-2.627.001-3.626-.969-.968-2.657-.968-3.626 0l-1.952 1.953c-.293.293-.768.293-1.06 0s-.294-.768 0-1.06l1.951-1.953c.768-.768 1.789-1.192 2.875-1.192 1.084 0 2.105.424 2.873 1.192 1.584 1.584 1.584 4.162 0 5.746l-1.93 1.929c-.146.146-.337.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7Cl4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.257 5H3.808l1.72-1.72c.293-.293.293-.767 0-1.06s-.768-.293-1.06 0L1.47 5.217c-.293.293-.293.767 0 1.06L4.466 9.28c.146.147.338.22.53.22s.384-.073.53-.22c.294-.292.294-.767.001-1.06L3.811 6.5h8.446c2.482 0 4.5 2.019 4.5 4.5s-2.018 4.5-4.5 4.5H8.52c-.415 0-.75.336-.75.75s.335.75.75.75h3.737c3.309 0 6-2.691 6-6s-2.691-6-6-6"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1FptQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M6.995 18.247c-.227-.227-.29-.582-.134-.88l1.288-2.449c.193-.366.647-.508 1.013-.314.371.194.507.647.314 1.012l-1.287 2.45c-.193.366-.647.507-1.013.314q-.104-.055-.181-.133M11.944 18.247q-.079-.079-.134-.183L10.518 15.6c-.193-.366-.05-.82.316-1.012s.823-.054 1.012.316l1.293 2.465c.193.367.05.82-.316 1.013-.297.156-.653.092-.879-.134M10.66 5.22c-.227-.226-.29-.581-.134-.88l1.285-2.44c.193-.366.646-.507 1.014-.313.365.192.506.645.313 1.013l-1.285 2.44c-.193.366-.646.507-1.013.314q-.103-.055-.18-.134M8.282 5.227q-.08-.078-.133-.182L6.86 2.599c-.193-.366-.051-.82.315-1.012s.817-.053 1.013.315l1.287 2.445c.193.366.052.82-.315 1.013-.298.157-.653.093-.88-.133M7 13.5H4C1.933 13.5.25 11.817.25 9.75S1.933 6 4 6h3c.414 0 .75.336.75.75s-.336.75-.75.75H4c-1.24 0-2.25 1.01-2.25 2.25S2.76 12 4 12h3c.414 0 .75.336.75.75s-.336.75-.75.75M16 13.5h-3c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3c1.24 0 2.25-1.01 2.25-2.25S17.24 7.5 16 7.5h-3c-.414 0-.75-.336-.75-.75S12.586 6 13 6h3c2.067 0 3.75 1.683 3.75 3.75S18.067 13.5 16 13.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5G11O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 19.028c-.192 0-.384-.073-.53-.22l-16.5-16.5c-.293-.293-.293-.768 0-1.06s.767-.293 1.06 0l16.5 16.5c.293.292.293.767 0 1.06-.146.147-.338.22-.53.22M13 9.889c-.414 0-.75-.336-.75-.75V4.81c0-1.259-1.023-2.282-2.282-2.282-.865 0-1.645.478-2.036 1.249-.189.37-.641.515-1.01.329-.368-.189-.516-.64-.328-1.009.65-1.276 1.942-2.07 3.374-2.07 2.086 0 3.782 1.697 3.782 3.783v4.329c0 .414-.336.75-.75.75M10.038 19.028c-2.089 0-3.788-1.7-3.788-3.79V10.89c0-.414.336-.75.75-.75s.75.336.75.75v4.35c0 1.261 1.026 2.289 2.288 2.289.861 0 1.642-.477 2.036-1.243.189-.369.642-.516 1.01-.325.37.19.514.642.324 1.01-.653 1.27-1.944 2.058-3.37 2.058"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4W2RY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M19.739 11.668c0 1.158-.45 2.246-1.27 3.063S16.564 16 15.407 16h-.657c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.657c.757 0 1.468-.294 2.003-.83.535-.534.83-1.245.83-2.002 0-.728-.277-1.418-.78-1.942-.501-.524-1.176-.833-1.902-.872-.254-.014-.485-.156-.611-.377-.127-.222-.132-.492-.014-.718.126-.241.222-.49.287-.739q.103-.392.103-.791c0-.894-.347-1.734-.979-2.366-1.208-1.207-3.296-1.274-4.568-.14-.6.536-.99 1.272-1.094 2.072-.03.236-.172.444-.38.559-.207.116-.457.126-.675.027q-.253-.116-.516-.175c-.86-.196-1.742.069-2.349.662-.474.463-.736 1.076-.736 1.728q0 .252.054.498c.034.158.086.316.152.466.1.224.083.483-.043.693-.128.21-.35.344-.594.36-.496.032-.957.247-1.298.606-.341.36-.53.832-.53 1.33 0 .52.203 1.011.572 1.38.369.368.858.571 1.38.571h2.1c.413 0 .75.336.75.75s-.337.75-.75.75h-2.1c-.922 0-1.789-.359-2.44-1.01-.653-.653-1.012-1.52-1.012-2.442 0-.882.335-1.72.942-2.361.387-.408.86-.71 1.382-.89q-.065-.348-.065-.701c0-1.06.422-2.054 1.189-2.802.956-.934 2.333-1.35 3.676-1.063.264-.814.74-1.55 1.387-2.127.882-.787 2.018-1.22 3.202-1.22 1.293 0 2.51.504 3.425 1.419.914.915 1.418 2.132 1.418 3.426 0 .394-.051.789-.152 1.172q-.016.063-.035.125c.721.212 1.378.61 1.908 1.162.771.806 1.196 1.864 1.196 2.98"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.854 10.824 10.85 7.826c-.293-.292-.768-.292-1.06 0l-2.998 2.998c-.293.293-.293.768 0 1.06.147.147.339.22.53.22s.385-.073.531-.22l1.722-1.722v8.184c0 .414.336.75.75.75s.75-.336.75-.75V10.17l1.718 1.714c.292.292.767.292 1.06 0 .293-.294.293-.769 0-1.061"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i0vS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m13.527 10.491-3.002-2.998c-.293-.293-.767-.293-1.06 0l-2.998 2.998c-.293.293-.293.768 0 1.06.147.147.339.22.53.22s.384-.073.53-.22L9.25 9.83v8.18c0 .414.336.75.75.75s.75-.336.75-.75V9.837l1.718 1.715c.293.293.767.293 1.06 0s.293-.769 0-1.06"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 17h-2.799c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.799c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75H4.25c-.414 0-.75.337-.75.75v10.5c0 .413.336.75.75.75h2.726c.414 0 .75.336.75.75s-.336.75-.75.75H4.25C3.01 17 2 15.99 2 14.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v10.5c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2oOIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15 10.502c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.123h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625M2.275 18.752q-.079 0-.16-.018c-.405-.088-.662-.487-.573-.892.595-2.73 3.312-5.025 6.607-5.58.423-.076.796.208.865.615.069.41-.206.796-.615.864-2.707.456-4.924 2.274-5.392 4.421-.076.35-.387.59-.732.59M10 10.852c-2.485 0-4.507-2.154-4.507-4.8s2.022-4.8 4.507-4.8 4.507 2.153 4.507 4.8-2.022 4.8-4.507 4.8m0-8.1c-1.658 0-3.007 1.48-3.007 3.3s1.349 3.3 3.007 3.3 3.007-1.48 3.007-3.3-1.349-3.3-3.007-3.3"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kS2gn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75q.504-.001.991-.056c.412-.046.708-.417.662-.828-.045-.41-.415-.699-.828-.662q-.406.046-.825.046c-1.829 0-3.496-.686-4.773-1.806 1.07-1.188 3.269-1.907 5.4-1.739.41.035.775-.273.809-.686s-.274-.775-.687-.808c-2.534-.204-5.125.655-6.538 2.136C3.298 13.134 2.75 11.632 2.75 10c0-3.998 3.252-7.25 7.25-7.25s7.25 3.252 7.25 7.25c0 .372-.028.746-.085 1.112-.063.41.218.792.627.856.41.068.793-.218.855-.627.069-.442.103-.893.103-1.341 0-4.825-3.925-8.75-8.75-8.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.054 11c-.02 0-.018-.016-.062-.001-.59 0-1.166-.168-1.665-.485-.49-.314-.89-.751-1.158-1.266-.283-.539-.428-1.147-.418-1.758-.023-1.176.563-2.287 1.571-2.946 1.019-.648 2.327-.65 3.342-.005.491.318.89.753 1.163 1.26.282.52.429 1.112.423 1.71.01.593-.136 1.203-.419 1.747-.268.515-.669.954-1.158 1.27-.488.31-1.046.474-1.62.474m-.044-1.501h.01c.306-.004.591-.074.842-.235.268-.173.49-.416.639-.702.169-.324.255-.686.249-1.048.004-.364-.08-.703-.243-1.002-.154-.29-.38-.533-.653-.711-.52-.33-1.196-.33-1.72.004-.564.369-.897 1-.883 1.682-.006.387.08.746.247 1.066.148.284.368.524.637.696.256.163.552.25.858.25zM14.258 18.361c-.161 0-.324-.03-.48-.094-.472-.196-.778-.652-.778-1.163v-4.37c0-.51.304-.964.774-1.16.474-.195 1.011-.089 1.37.27l2.986 2.978c.364.365.47.911.27 1.395-.197.475-.651.783-1.158.783h-1.114l-.979.988c-.242.244-.563.373-.891.373m.242-5.04v3.192l.665-.672q.338-.34.893-.341h.628z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7CBmZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25m0 1.5c3.998 0 7.25 3.252 7.25 7.25 0 1.632-.548 3.134-1.462 4.347-1.481-1.244-3.587-1.972-5.788-1.972-2.267 0-4.418.74-5.797 1.96C3.295 13.124 2.75 11.626 2.75 10c0-3.998 3.252-7.25 7.25-7.25M5.22 15.437c1.102-.959 2.909-1.562 4.78-1.562 1.797 0 3.562.592 4.768 1.572-1.276 1.119-2.942 1.803-4.768 1.803-1.832 0-3.502-.688-4.78-1.813m4.838-4.037c-.021 0-.057-.01-.063 0-.637 0-1.258-.181-1.796-.524-.53-.338-.961-.81-1.25-1.366-.306-.583-.463-1.24-.453-1.9-.024-1.273.61-2.472 1.697-3.183 1.099-.698 2.508-.698 3.6-.005.527.342.959.81 1.254 1.358.307.566.465 1.206.457 1.85.01.641-.146 1.302-.452 1.889-.29.556-.723 1.03-1.25 1.371-.526.335-1.126.51-1.744.51m-.048-1.5h.01c.348.015.681-.087.972-.273.305-.197.56-.476.73-.802.191-.366.289-.779.282-1.191.005-.41-.09-.798-.277-1.14-.176-.329-.434-.608-.744-.81-.596-.377-1.374-.378-1.977.004-.644.421-1.025 1.14-1.01 1.92-.006.435.09.844.281 1.207.17.325.422.6.729.797.295.188.638.287.99.287z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j3r74":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.571 10.043c-.966-.792-2.453-.689-3.379.24l-4.183 4.182c-.248.247-.432.555-.533.89l-.954 3.16c-.08.265-.008.552.188.747.142.143.334.22.53.22q.108 0 .217-.032l3.158-.954c.336-.101.644-.285.89-.533 0 0 4.126-4.124 4.253-4.253.494-.492.757-1.175.722-1.872-.034-.697-.366-1.35-.909-1.795m-7.209 7.566.55-1.821c.018-.057.059-.102.091-.152l1.332 1.332c-.05.033-.094.074-.153.092zm6.335-4.958-3.456 3.456-1.376-1.376 3.388-3.388c.221-.222.512-.337.793-.337.21 0 .413.065.576.198.219.179.346.43.36.708.014.279-.087.54-.285.739M9 11.25c-2.62 0-4.75-2.243-4.75-5s2.13-5 4.75-5 4.75 2.243 4.75 5-2.131 5-4.75 5m0-8.5c-1.792 0-3.25 1.57-3.25 3.5S7.208 9.75 9 9.75s3.25-1.57 3.25-3.5-1.458-3.5-3.25-3.5M1.75 18.75q-.035 0-.072-.004c-.413-.04-.714-.406-.675-.819C1.31 14.744 4.823 12.25 9 12.25q.372 0 .734.025c.413.028.725.387.696.8s-.381.71-.8.696q-.31-.022-.63-.021c-3.413 0-6.27 1.898-6.504 4.322-.037.388-.363.678-.745.678"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3WBuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.4 3.35L15.09 17c-.11.152-.284.245-.472.254l-.032.001c-.176 0-.345-.074-.464-.207l-1.439-1.599c-.23-.257-.21-.652.047-.883.256-.23.65-.21.883.047l.924 1.028 1.855-2.53c.204-.278.596-.339.873-.134.278.204.339.595.134.873M2.274 18.752q-.078 0-.16-.017c-.405-.089-.661-.488-.573-.893.596-2.73 3.313-5.025 6.608-5.58.407-.065.795.207.865.615.069.41-.207.796-.616.865-2.706.455-4.923 2.273-5.391 4.42-.077.35-.387.59-.733.59M10 10.852c-2.485 0-4.507-2.153-4.507-4.8s2.022-4.8 4.507-4.8 4.507 2.153 4.507 4.8-2.022 4.8-4.507 4.8m0-8.1c-1.658 0-3.007 1.48-3.007 3.3s1.349 3.3 3.007 3.3 3.007-1.48 3.007-3.3-1.349-3.3-3.007-3.3"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8sjSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.253 11.95c-2.276 0-4.128-1.947-4.128-4.34s1.852-4.339 4.128-4.339 4.128 1.947 4.128 4.34-1.852 4.338-4.128 4.338m0-7.179c-1.45 0-2.628 1.274-2.628 2.84s1.179 2.838 2.628 2.838S14.88 9.176 14.88 7.61s-1.179-2.839-2.628-2.839M6.877 17.612c.215-1.992 2.576-3.552 5.376-3.552 2.823 0 5.184 1.556 5.376 3.544.04.414.416.727.818.674.412-.039.714-.405.674-.818-.264-2.748-3.281-4.9-6.868-4.9-3.614 0-6.566 2.103-6.868 4.892-.044.411.254.781.666.826q.04.004.08.004c.379 0 .704-.285.746-.67m.24-7.893c.17-.378.001-.823-.377-.992-.985-.443-1.62-1.472-1.62-2.623 0-1.565 1.178-2.838 2.627-2.838q.228 0 .446.04c.403.082.8-.192.874-.6.076-.407-.193-.799-.6-.874q-.351-.066-.72-.066c-2.276 0-4.128 1.946-4.128 4.338 0 1.74.984 3.307 2.506 3.992q.151.066.308.065c.286 0 .56-.165.684-.442m-4.746 6.388c.205-1.902 2.37-3.426 5.032-3.545.414-.019.735-.369.716-.783-.017-.402-.35-.716-.748-.716h-.034c-3.453.155-6.168 2.208-6.458 4.882-.044.412.254.783.665.827q.042.004.082.004c.378 0 .703-.285.745-.669"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9QgwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 11.25c-2.62 0-4.75-2.243-4.75-5s2.13-5 4.75-5 4.75 2.243 4.75 5-2.13 5-4.75 5m0-8.5c-1.792 0-3.25 1.57-3.25 3.5s1.458 3.5 3.25 3.5 3.25-1.57 3.25-3.5-1.458-3.5-3.25-3.5M2.751 18.75q-.037 0-.073-.004c-.412-.039-.714-.405-.674-.818C2.31 14.744 5.822 12.25 10 12.25c.677 0 1.347.063 1.991.188.407.08.673.473.594.88-.078.407-.48.678-.879.593-.55-.107-1.125-.161-1.706-.161-3.414 0-6.27 1.898-6.504 4.322-.037.388-.363.678-.745.678M18.01 14.002v-.992C18.01 11.9 17.108 11 16 11s-2.01.901-2.01 2.01v.992c-.547.006-.99.45-.99.998v3c0 .552.448 1 1 1h4c.552 0 1-.448 1-1v-3c0-.549-.443-.992-.99-.998M16 12.25c.419 0 .76.34.76.76V14h-1.52v-.99c0-.42.341-.76.76-.76"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gLc9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M11.75 10.748c-2.276 0-4.128-1.946-4.128-4.339S9.474 2.07 11.75 2.07s4.128 1.947 4.128 4.34-1.852 4.338-4.128 4.338m0-7.178c-1.45 0-2.628 1.274-2.628 2.84s1.179 2.838 2.628 2.838 2.628-1.273 2.628-2.839S13.199 3.57 11.75 3.57M5.577 16.998q-.041.001-.082-.004c-.411-.045-.709-.415-.665-.827.303-2.788 3.255-4.89 6.868-4.89.414 0 .75.335.75.75s-.336.75-.75.75c-2.799 0-5.16 1.56-5.376 3.552-.042.384-.367.669-.745.669M5.878 8.998q-.157 0-.308-.066c-1.521-.684-2.505-2.25-2.505-3.99 0-2.393 1.852-4.34 4.128-4.34q.367.001.716.065c.408.074.679.464.606.871-.074.408-.464.678-.871.606q-.22-.04-.45-.041c-1.45 0-2.629 1.273-2.629 2.838 0 1.15.636 2.18 1.62 2.623.378.17.546.614.377.992-.125.278-.398.442-.684.442M1.071 15.498q-.04.001-.082-.004c-.412-.045-.709-.415-.665-.827.291-2.675 3.007-4.729 6.46-4.882.375-.048.763.302.781.716s-.301.764-.715.782c-2.663.12-4.828 1.644-5.034 3.546-.042.384-.367.669-.745.669M19 14.998c0-.55-.445-.996-.995-.999v-.991c0-1.109-.901-2.01-2.01-2.01-1.107 0-2.009.901-2.009 2.01V14c-.545.008-.986.45-.986.997v3c0 .22.086.414.207.58q.112.154.276.255c.153.095.323.165.517.165h4c.194 0 .364-.07.517-.165q.163-.101.276-.256c.121-.165.207-.358.207-.579zm-3.005-2.75c.42 0 .76.34.76.76v.99h-1.519v-.99c0-.42.341-.76.76-.76"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bHYwF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.413 0-.75.337-.75.75v11.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75V4.25c0-.413-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m13.073 9.12-4.6-2.473C7.807 6.289 7 6.772 7 7.527v4.945c0 .756.807 1.239 1.473.881l4.6-2.472c.702-.378.702-1.384 0-1.762"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2DcIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.25 4.498h-9.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.5c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 10.498h-9.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.5c.414 0 .75.336.75.75s-.336.75-.75.75M17.25 16.498h-9.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.5c.414 0 .75.336.75.75s-.336.75-.75.75M4.75 4.498h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.414 0 .75.336.75.75s-.336.75-.75.75M4.75 10.498h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.414 0 .75.336.75.75s-.336.75-.75.75M4.75 16.498h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a4EFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h11.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M4 4h3v3H4zM10 4h3v3h-3zM7 7h3v3H7zM13 7h3v3h-3zM4 10h3v3H4zM10 10h3v3h-3zM7 13h3v3H7zM13 13h3v3h-3z",
                opacity: 0.5
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iItAA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.966 16.683C5.11 16.683.75 12.294.75 10.222c0-.92.864-2.36 2.201-3.668.295-.288.77-.284 1.06.011.29.296.285.77-.011 1.061-1.31 1.281-1.75 2.32-1.75 2.596 0 1.144 3.647 4.96 7.716 4.96.604 0 1.231-.084 1.863-.251.398-.102.81.133.917.534.106.4-.134.81-.534.917-.756.2-1.512.3-2.246.3M16.604 13.843c-.204 0-.406-.082-.554-.244-.28-.306-.258-.78.048-1.06 1.14-1.042 1.652-1.982 1.652-2.317 0-.802-1.904-3.277-4.51-4.552-1.01-.51-2.13-.784-3.25-.798-.62 0-1.264.094-1.905.28-.4.109-.814-.116-.929-.513-.115-.398.115-.814.513-.929.775-.225 1.56-.338 2.331-.338 1.356.017 2.704.347 3.907.954 2.742 1.343 5.343 4.21 5.343 5.896 0 .919-.8 2.199-2.14 3.424-.144.132-.326.197-.506.197"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "m18.78 17.741-5.778-5.778c.204-.296.358-.615.46-.946.208-.684-.46-1.25-1.12-.976-.495.206-.946.14-1.18.081L9.788 8.75c-.094-.37-.079-.745.04-1.085.223-.637-.473-1.26-1.1-1.01q-.354.14-.677.358L2.28 1.241c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06l16.5 16.5c.146.147.338.22.53.22s.384-.073.53-.22c.293-.292.293-.767 0-1.06M8.205 12.998c.695.434 1.523.587 2.319.484L6.542 9.501c-.168 1.315.386 2.7 1.663 3.497"
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Nxjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.034 16.662C5.143 16.662.75 12.273.75 10.2c0-1.685 2.598-4.55 5.347-5.898 1.201-.606 2.548-.935 3.893-.952 5.158 0 9.26 4.919 9.26 6.85 0 2.072-4.36 6.46-9.216 6.46M10 4.85c-1.11.014-2.231.289-3.231.793l-.008.004C4.155 6.924 2.25 9.398 2.25 10.201c0 1.144 3.68 4.96 7.784 4.96 4.069 0 7.716-3.816 7.716-4.96 0-1.05-3.481-5.35-7.75-5.35m-3.569.124h.01z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.83 7.644c.222-.637-.474-1.26-1.1-1.01-.474.187-.914.48-1.283.88-1.492 1.614-1.208 4.236.758 5.463 1.2.749 2.797.688 3.94-.147.668-.49 1.103-1.136 1.316-1.834.209-.684-.458-1.25-1.119-.976-.536.223-1.032.128-1.245.067-.57-.165-1.034-.59-1.247-1.144-.167-.436-.163-.893-.02-1.3"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2ZQwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.78 17.74 2.28 1.24c-.293-.294-.767-.294-1.06 0s-.293.767 0 1.06L3.94 5.02H3.25C2.01 5.021 1 6.031 1 7.271v5.5c0 1.24 1.01 2.25 2.25 2.25h1.629c.198 0 .392.08.53.22l2.604 2.604c.336.336.78.513 1.235.513.226 0 .453-.044.67-.134.658-.272 1.082-.907 1.082-1.618V12.08l6.72 6.72c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.06M9.5 16.605c0 .146-.097.208-.154.232-.059.024-.171.047-.273-.054L6.47 14.18c-.425-.425-.99-.658-1.591-.658H3.25c-.413 0-.75-.337-.75-.75v-5.5c0-.414.337-.75.75-.75h2.191L9.5 10.58zM8.259 4.073l.814-.814c.105-.103.216-.076.273-.055.07.03.154.093.154.232v2.59c0 .414.336.75.75.75s.75-.336.75-.75v-2.59c0-.71-.424-1.345-1.08-1.618-.657-.27-1.404-.122-1.907.38l-.815.815c-.293.293-.293.767 0 1.06s.768.293 1.06 0M13.223 9.825c.04.386.365.673.745.673q.038.001.078-.004c.412-.043.712-.411.669-.823-.1-.963-.573-1.794-1.299-2.277-.345-.229-.81-.136-1.04.208s-.137.81.208 1.04c.348.231.586.673.639 1.183M17.25 10.018c0 .866-.284 1.686-.8 2.31-.264.318-.22.791.099 1.056.14.115.31.172.478.172.215 0 .43-.093.578-.272.739-.892 1.145-2.053 1.145-3.266 0-1.686-.798-3.266-2.083-4.124-.348-.23-.812-.137-1.041.207-.23.344-.137.81.207 1.04.874.584 1.417 1.686 1.417 2.877"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jegkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.001 12.747c-.242 0-.48-.117-.624-.333-.23-.345-.138-.81.207-1.041.411-.274.666-.802.666-1.376s-.255-1.101-.666-1.376c-.345-.23-.437-.696-.207-1.04s.697-.436 1.04-.208c.823.55 1.334 1.556 1.334 2.624s-.511 2.074-1.334 2.624c-.128.085-.272.126-.416.126M9.248 18.337c-.455 0-.9-.178-1.235-.514L5.409 15.22c-.14-.14-.333-.22-.53-.22H3.25C2.01 15 1 13.99 1 12.75v-5.5C1 6.01 2.01 5 3.25 5h1.629c.197 0 .39-.08.53-.22l2.604-2.603c.502-.503 1.25-.653 1.907-.38.656.272 1.08.907 1.08 1.617v13.172c0 .71-.424 1.345-1.08 1.616-.218.09-.446.135-.672.135M3.25 6.5c-.414 0-.75.337-.75.75v5.5c0 .413.336.75.75.75h1.629c.592 0 1.172.24 1.59.66l2.604 2.603c.102.101.214.078.273.053.057-.023.154-.085.154-.23V3.414c0-.145-.097-.207-.154-.23-.06-.026-.17-.05-.273.053L6.47 5.841c-.42.419-.999.659-1.591.659z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gyhDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.001 12.747c-.242 0-.48-.117-.625-.334-.23-.345-.137-.81.208-1.04.411-.274.666-.802.666-1.376s-.255-1.101-.666-1.376c-.345-.23-.438-.695-.208-1.04s.694-.436 1.04-.208c.835.558 1.334 1.538 1.334 2.624s-.499 2.066-1.334 2.624c-.128.085-.272.126-.415.126M16.251 14.247c-.242 0-.48-.117-.625-.333-.23-.345-.137-.81.207-1.041.874-.583 1.417-1.686 1.417-2.876 0-1.191-.543-2.293-1.416-2.876-.345-.23-.438-.695-.208-1.04s.695-.437 1.04-.208c1.285.857 2.084 2.438 2.084 4.124s-.798 3.266-2.083 4.124c-.128.085-.273.126-.416.126M9.248 18.337c-.454 0-.9-.178-1.235-.514L5.409 15.22c-.14-.14-.333-.22-.53-.22H3.25C2.01 15 1 13.99 1 12.75v-5.5C1 6.01 2.01 5 3.25 5h1.629c.197 0 .39-.08.53-.22l2.604-2.603c.502-.503 1.252-.653 1.907-.38.656.272 1.08.907 1.08 1.617v13.172c0 .71-.424 1.345-1.08 1.616-.218.09-.446.135-.672.135M3.25 6.5c-.413 0-.75.337-.75.75v5.5c0 .413.337.75.75.75h1.629c.592 0 1.172.24 1.59.66l2.604 2.603c.103.101.215.079.273.053.057-.023.154-.085.154-.23V3.414c0-.145-.097-.207-.154-.23-.058-.026-.17-.048-.273.053L6.47 5.841c-.42.419-1 .659-1.591.659z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fwKUa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M4.128 6.072c-.332 0-.635-.221-.724-.558-.147-.556-.069-1.136.22-1.633s.755-.853 1.31-1l6.786-1.796c1.152-.306 2.329.383 2.633 1.531L15 5.064c.106.4-.132.812-.532.917-.395.11-.81-.13-.917-.532L12.903 3c-.092-.349-.446-.56-.799-.466L5.32 4.331c-.348.093-.557.451-.465.8.106.4-.132.81-.534.916q-.095.025-.192.025M18.25 10h-.326c-.349-1.71-1.863-3-3.674-3h-11C2.01 7 1 8.01 1 9.25v6.5C1 16.99 2.01 18 3.25 18h11c1.81 0 3.325-1.29 3.674-3h.326c.414 0 .75-.336.75-.75v-3.5c0-.414-.336-.75-.75-.75m-.75 3.5h-3v-2h3zm-3.25 3h-11c-.413 0-.75-.337-.75-.75v-6.5c0-.413.337-.75.75-.75h11c.976 0 1.801.63 2.112 1.5H13.75c-.414 0-.75.336-.75.75v3.5c0 .414.336.75.75.75h2.612c-.311.87-1.136 1.5-2.112 1.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"17pX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.125,
                cy: 6,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M2.5 5.25c0-.414.337-.75.75-.75h13.5c.413 0 .75.336.75.75V7.5h-15zm0 9.5V9H6v6.5H3.25c-.413 0-.75-.336-.75-.75m14.25.75H7.5V9h10v5.75c0 .414-.337.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kPrFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.125,
                cy: 6,
                r: 0.75,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M2.5 5.25c0-.413.337-.75.75-.75h13.5c.413 0 .75.337.75.75V7.5h-15zM16.75 15.5H3.25c-.413 0-.75-.337-.75-.75V9h15v5.75c0 .413-.337.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gOqkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.8 7.25H8.75V5.2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.05H5.2c-.414 0-.75.336-.75.75s.336.75.75.75h2.05v2.05c0 .414.336.75.75.75s.75-.336.75-.75V8.75h2.05c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m18.78 17.72-5.333-5.333C14.417 11.184 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.583 4.387-1.553l5.333 5.333c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.033 0-5.5-2.468-5.5-5.5S4.967 2.5 8 2.5s5.5 2.468 5.5 5.5-2.467 5.5-5.5 5.5"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bloyx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.8 8.75H5.2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.6c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7M8 2.5C4.967 2.5 2.5 4.968 2.5 8s2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5S11.033 2.5 8 2.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 19c-.192 0-.384-.073-.53-.22l-5.333-5.333c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0l5.333 5.333c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=icons.62c799a2.js.map
